export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  Date: any;
  DateTime: any;
  JSONObject: any;
  Money: any;
  link__Import: any;
};

export type AccountSecurityFilter = {
  id?: InputMaybe<IdOperator>;
  securityType?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export enum AccountSecurityType {
  FaceId = 'FACE_ID',
  Fingerprint = 'FINGERPRINT',
  Pin = 'PIN'
}

export type ActivateShopRequestDto = {
  shopType: ShopType;
  userId: Scalars['ID'];
};

export type AddCheckoutCartItemInput = {
  onConflict?: InputMaybe<CheckoutConflictResolution>;
  productId: Scalars['ID'];
  profit?: InputMaybe<Scalars['Float']>;
  profitType: ProfitType;
  qty: Scalars['Int'];
};

export type AddCustomerToStorefrontCartInput = {
  cart_id: Scalars['ID'];
  customer: StorefrontCartCustomerInput;
};

export type AddDeliveryToStorefrontCartInput = {
  cart_id: Scalars['ID'];
  delivery: StorefrontCartDeliveryInput;
};

export type AddItemToStorefrontCartInput = {
  cart_id: Scalars['ID'];
  item: StorefrontCartItemInput;
};

export type AddPaymentToStorefrontCartInput = {
  cart_id: Scalars['ID'];
  payment: StorefrontCartPaymentInput;
};

export type AddPluginToUserRequestDto = {
  plugin_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type AddProductConditionToDiscountRequestDto = {
  discountId: Scalars['ID'];
  productCondition: DiscountProductConditionRequestDto;
};

export type AddProductsToCollectionInput = {
  collectionId: Scalars['ID'];
  productIds: Array<Scalars['ID']>;
};

export type AddSalesTargetExemptionInput = {
  campaignId: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  reason: SalesTargetExemptionReason;
  userId: Scalars['ID'];
};

export type AddScopeToTeamCredentialInput = {
  scope?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  team_id: Scalars['ID'];
};

export type AddSupplierAgreementTermsInput = {
  agreed_term?: InputMaybe<SupplierAgreementTerms>;
  supplier_id: Scalars['ID'];
};

export type AddSupplierLocationInput = {
  address: Scalars['String'];
  address_ext?: InputMaybe<Scalars['String']>;
  business_id: Scalars['ID'];
  city: Scalars['String'];
  gmap_data: Scalars['String'];
  lat: Scalars['String'];
  lng: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
  state_code: Scalars['String'];
  supplier_id?: InputMaybe<Scalars['ID']>;
};

export type AddTeamLogoInput = {
  logo: Scalars['String'];
  team_id: Scalars['ID'];
};

export type AddTeamServiceAgreementTermsInput = {
  team_id: Scalars['ID'];
  terms: Service_Agreement_Terms;
  terms_value: TeamServiceAgreementTermsValueInput;
};

export type AddToCartInput = {
  force_replace?: InputMaybe<Scalars['Boolean']>;
  product_sku: Scalars['String'];
  profit: Scalars['Float'];
  profit_type: ProfitType;
  quantity: Scalars['Int'];
  user_id: Scalars['ID'];
};

export type Address = {
  __typename?: 'Address';
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  landmark?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  area: Scalars['String'];
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  landmark?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
};

export type AdjustStorefrontCartItemQuantityInput = {
  item_id: Scalars['ID'];
  type: QuantityAdjustmentType;
};

export type AeItemBaseInfoDto = {
  __typename?: 'AeItemBaseInfoDto';
  avg_evaluation_rating?: Maybe<Scalars['String']>;
  category_id?: Maybe<Scalars['String']>;
  category_sequence?: Maybe<Scalars['String']>;
  currency_code?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  evaluation_count?: Maybe<Scalars['String']>;
  gmt_create?: Maybe<Scalars['String']>;
  gmt_modified?: Maybe<Scalars['String']>;
  mobile_detail?: Maybe<Scalars['String']>;
  owner_member_seq_long?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  product_status_type?: Maybe<Scalars['String']>;
  sales_count?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  ws_display?: Maybe<Scalars['String']>;
  ws_offline_date?: Maybe<Scalars['String']>;
};

export type AeItemProperties = {
  __typename?: 'AeItemProperties';
  attr_name?: Maybe<Scalars['String']>;
  attr_name_id?: Maybe<Scalars['String']>;
  attr_value?: Maybe<Scalars['String']>;
  attr_value_end?: Maybe<Scalars['String']>;
  attr_value_id?: Maybe<Scalars['String']>;
  attr_value_start?: Maybe<Scalars['String']>;
  attr_value_unit?: Maybe<Scalars['String']>;
};

export type AeItemProperty = {
  __typename?: 'AeItemProperty';
  ae_item_property?: Maybe<Array<Maybe<AeItemProperties>>>;
};

export type AeItemSkuInfoDtos = {
  __typename?: 'AeItemSkuInfoDtos';
  ae_item_sku_info_d_t_o?: Maybe<Array<Maybe<AeSkuPropertyDtos>>>;
  barcode?: Maybe<Scalars['String']>;
  buy_amount_limit_set_by_promotion?: Maybe<Scalars['String']>;
  currency_code?: Maybe<Scalars['String']>;
  ean_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ipm_sku_stock?: Maybe<Scalars['String']>;
  limit_strategy?: Maybe<Scalars['String']>;
  offer_bulk_sale_price?: Maybe<Scalars['String']>;
  offer_sale_price?: Maybe<Scalars['String']>;
  price_include_tax?: Maybe<Scalars['String']>;
  sku_attr?: Maybe<Scalars['String']>;
  sku_available_stock?: Maybe<Scalars['String']>;
  sku_bulk_order?: Maybe<Scalars['String']>;
  sku_code?: Maybe<Scalars['String']>;
  sku_id?: Maybe<Scalars['String']>;
  sku_price?: Maybe<Scalars['String']>;
  sku_stock?: Maybe<Scalars['String']>;
  wholesale_price_tiers?: Maybe<Array<Maybe<WholesalePriceTiers>>>;
};

export type AeMultimediaInfoDto = {
  __typename?: 'AeMultimediaInfoDto';
  ae_video_dtos?: Maybe<Array<Maybe<AeVideoDtos>>>;
  image_urls?: Maybe<Scalars['String']>;
};

export type AeSkuPropertyDto = {
  __typename?: 'AeSkuPropertyDTO';
  property_value_definition_name?: Maybe<Scalars['String']>;
  property_value_id?: Maybe<Scalars['Int']>;
  sku_image?: Maybe<Scalars['String']>;
  sku_property_id?: Maybe<Scalars['Int']>;
  sku_property_name?: Maybe<Scalars['String']>;
  sku_property_value?: Maybe<Scalars['String']>;
};

export type AeSkuPropertyDtos = {
  __typename?: 'AeSkuPropertyDtos';
  ae_sku_property_dtos?: Maybe<InnerAeSkuPropertyDtos>;
  currency_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ipm_sku_stock?: Maybe<Scalars['Int']>;
  offer_bulk_sale_price?: Maybe<Scalars['String']>;
  offer_sale_price?: Maybe<Scalars['String']>;
  price_include_tax?: Maybe<Scalars['Boolean']>;
  sku_attr?: Maybe<Scalars['String']>;
  sku_available_stock?: Maybe<Scalars['Int']>;
  sku_code?: Maybe<Scalars['String']>;
  sku_id?: Maybe<Scalars['String']>;
  sku_price?: Maybe<Scalars['String']>;
  sku_stock?: Maybe<Scalars['Boolean']>;
};

export type AeStoreInfo = {
  __typename?: 'AeStoreInfo';
  communication_rating?: Maybe<Scalars['String']>;
  item_as_described_rating?: Maybe<Scalars['String']>;
  shipping_speed_rating?: Maybe<Scalars['String']>;
  store_country_code?: Maybe<Scalars['String']>;
  store_id?: Maybe<Scalars['String']>;
  store_name?: Maybe<Scalars['String']>;
};

export type AeVideoDtos = {
  __typename?: 'AeVideoDtos';
  ali_member_id?: Maybe<Scalars['String']>;
  media_id?: Maybe<Scalars['String']>;
  media_status?: Maybe<Scalars['String']>;
  media_type?: Maybe<Scalars['String']>;
  media_url?: Maybe<Scalars['String']>;
  poster_url?: Maybe<Scalars['String']>;
};

export type AgencyDetails = {
  __typename?: 'AgencyDetails';
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AliExpressProduct = {
  __typename?: 'AliExpressProduct';
  cateId?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  evaluateRate?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['String']>;
  itemMainPic?: Maybe<Scalars['String']>;
  itemUrl?: Maybe<Scalars['String']>;
  orders?: Maybe<Scalars['String']>;
  originMinPrice?: Maybe<Scalars['String']>;
  originalPrice?: Maybe<Scalars['String']>;
  originalPriceCurrency?: Maybe<Scalars['String']>;
  salePrice?: Maybe<Scalars['String']>;
  salePriceCurrency?: Maybe<Scalars['String']>;
  salePriceFormat?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['String']>;
  targetOriginalPrice?: Maybe<Scalars['String']>;
  targetOriginalPriceCurrency?: Maybe<Scalars['String']>;
  targetSalePrice?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AliExpressProductResponse = {
  __typename?: 'AliExpressProductResponse';
  length?: Maybe<Scalars['Int']>;
  products?: Maybe<Array<Maybe<AliExpressProduct>>>;
};

export type AliexpressDsProductGetResponse = {
  __typename?: 'AliexpressDsProductGetResponse';
  result?: Maybe<Result>;
  rsp_code?: Maybe<Scalars['String']>;
  rsp_msg?: Maybe<Scalars['String']>;
};

export type AppBanner = {
  __typename?: 'AppBanner';
  banner_code?: Maybe<Scalars['String']>;
  collection: Catalog;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  updated_at: Scalars['DateTime'];
  url: Scalars['String'];
};

export type AppBannerFilter = {
  active?: InputMaybe<BooleanOperator>;
  country?: InputMaybe<StringOperator>;
  createdAt?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
};

export type AppBannerInput = {
  banner_code?: InputMaybe<Scalars['String']>;
  collection_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  url: Scalars['String'];
};

/**
 * App-level cart aggregate for a user. This is a virtual/cart view
 * over duke_cart_items and is not the same as StorefrontCart.
 */
export type AppCart = {
  __typename?: 'AppCart';
  allowInstantDelivery: Scalars['Boolean'];
  deliveryFee: Scalars['Float'];
  discountAmount: Scalars['Float'];
  hasAliexpressProduct: Scalars['Boolean'];
  hasFreeDeliveryItem: Scalars['Boolean'];
  hasInstantDeliveryItem: Scalars['Boolean'];
  id: Scalars['ID'];
  items: Array<CartItem>;
  profitTotal: Scalars['Float'];
  shippingCost: Scalars['Float'];
  subtotal: Scalars['Float'];
  total: Scalars['Float'];
  userId: Scalars['ID'];
};

export type Auth = {
  __typename?: 'Auth';
  token: Scalars['String'];
  user: User;
};

export type AutogeneratedMainType = {
  __typename?: 'AutogeneratedMainType';
  agency_details?: Maybe<AgencyDetails>;
  currency_code?: Maybe<Scalars['String']>;
  currency_name?: Maybe<Scalars['String']>;
  currency_symbol?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  end_time?: Maybe<Scalars['Date']>;
  estimate_id?: Maybe<Scalars['String']>;
  estimate_type_details?: Maybe<EstimateTypeDetails>;
  full_price?: Maybe<Scalars['Int']>;
  time_string?: Maybe<Scalars['String']>;
  total_distance?: Maybe<Scalars['Float']>;
};

export enum BillingCycle {
  Annual = 'annual',
  Monthly = 'monthly'
}

export type BobAddress = {
  __typename?: 'BobAddress';
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  entered_address?: Maybe<Scalars['String']>;
  gs_hash?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  local_area?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  street_address?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['String']>;
  zone_name?: Maybe<Scalars['String']>;
};

export type BobAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  entered_address?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  local_area?: InputMaybe<Scalars['String']>;
  street_address?: InputMaybe<Scalars['String']>;
  zone?: InputMaybe<Scalars['String']>;
};

export type BobBillingBillingTransaction = {
  __typename?: 'BobBillingBillingTransaction';
  account_code?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  payment?: Maybe<Scalars['String']>;
  payment_id?: Maybe<Scalars['String']>;
  payment_provider_id?: Maybe<Scalars['String']>;
  provider_doc_number?: Maybe<Scalars['String']>;
  shipment_id?: Maybe<Scalars['Int']>;
  shipment_reference?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  transaction_date?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  ua_doc_number?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BobCancelShipmentRequestDto = {
  tracking_reference?: InputMaybe<Scalars['String']>;
};

export type BobChannel = {
  __typename?: 'BobChannel';
  account_id?: Maybe<Scalars['Int']>;
  channel_type?: Maybe<Scalars['String']>;
  channel_type_logo_square_url?: Maybe<Scalars['String']>;
  channel_type_logo_url?: Maybe<Scalars['String']>;
  channel_type_slug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type BobCheckpoint = {
  __typename?: 'BobCheckpoint';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_friendly?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['String']>;
};

export type BobCollectionAddressBook = {
  __typename?: 'BobCollectionAddressBook';
  account_id?: Maybe<Scalars['Int']>;
  additional_instructions?: Maybe<Scalars['String']>;
  address?: Maybe<BobAddress>;
  address_id?: Maybe<Scalars['Int']>;
  collect_after?: Maybe<Scalars['String']>;
  collect_before?: Maybe<Scalars['String']>;
  collection_lead_time?: Maybe<Scalars['Int']>;
  company?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  contact_surname?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['Int']>;
  custom_logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  include_packing_slip?: Maybe<Scalars['Boolean']>;
  is_collection_address?: Maybe<Scalars['Boolean']>;
  is_default?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<BobOrderMeta>;
  mobile_number?: Maybe<Scalars['String']>;
  modified_by?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  request_collection_at?: Maybe<Scalars['String']>;
  shipping_label_email?: Maybe<Array<Maybe<Scalars['String']>>>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
};

export type BobCreateOrderRequestDto = {
  buyer_selected_shipping_cost: Scalars['Float'];
  buyer_selected_shipping_method: Scalars['String'];
  currency: Scalars['String'];
  customer_email: Scalars['String'];
  customer_name: Scalars['String'];
  customer_phone: Scalars['String'];
  customer_surname: Scalars['String'];
  delivery_address: BobAddressInput;
  order_items: Array<BobOrderItemInput>;
  payment_status: BobOrderPaymentStatus;
};

export type BobCreateShipmentRequestDto = {
  collection_address?: InputMaybe<BobAddressInput>;
  collection_after?: InputMaybe<Scalars['String']>;
  collection_before?: InputMaybe<Scalars['String']>;
  collection_contact_company?: InputMaybe<Scalars['String']>;
  collection_contact_email?: InputMaybe<Scalars['String']>;
  collection_contact_mobile_number?: InputMaybe<Scalars['String']>;
  collection_contact_name?: InputMaybe<Scalars['String']>;
  collection_min_date?: InputMaybe<Scalars['String']>;
  custom_tracking_reference?: InputMaybe<Scalars['String']>;
  declared_value?: InputMaybe<Scalars['Int']>;
  delivery_address?: InputMaybe<BobAddressInput>;
  delivery_contact_company?: InputMaybe<Scalars['String']>;
  delivery_contact_email?: InputMaybe<Scalars['String']>;
  delivery_contact_mobile_number?: InputMaybe<Scalars['String']>;
  delivery_contact_name?: InputMaybe<Scalars['String']>;
  instructions_collection?: InputMaybe<Scalars['String']>;
  instructions_delivery?: InputMaybe<Scalars['String']>;
  parcels?: InputMaybe<Array<InputMaybe<BobParcelInput>>>;
  provider_slug?: InputMaybe<Scalars['String']>;
  service_level_code?: InputMaybe<Scalars['String']>;
  timeout?: InputMaybe<Scalars['Int']>;
};

export type BobGetCourierRatesRequestDto = {
  collection_address: BobAddressInput;
  declared_value?: InputMaybe<Scalars['Int']>;
  delivery_address: BobAddressInput;
  parcels: Array<BobParcelInput>;
  providers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  service_levels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  timeout?: InputMaybe<Scalars['Int']>;
};

export type BobGetCourierRatesResponseDto = {
  __typename?: 'BobGetCourierRatesResponseDto';
  account_id?: Maybe<Scalars['Int']>;
  collection_address?: Maybe<BobAddress>;
  declared_value?: Maybe<Scalars['Int']>;
  delivery_address?: Maybe<BobAddress>;
  id?: Maybe<Scalars['Int']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider_rate_requests?: Maybe<Array<Maybe<BobProviderRateRequest>>>;
  request_timeout?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  timeout?: Maybe<Scalars['Int']>;
  total_submitted_weight_kg?: Maybe<Scalars['Float']>;
  webhook_url?: Maybe<Scalars['String']>;
};

export type BobGetOrderFulfillmentsRequestDto = {
  order_id?: InputMaybe<Scalars['Int']>;
};

export type BobGetOrderFulfillmentsResponseDto = {
  __typename?: 'BobGetOrderFulfillmentsResponseDto';
  count?: Maybe<Scalars['Int']>;
  order_fulfillments?: Maybe<Array<Maybe<BobOrderFulfillments>>>;
};

export type BobGetOrdersRequestDto = {
  /** Province */
  delivery_address_zone?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['Date']>;
  fulfillment_status?: InputMaybe<Scalars['String']>;
  has_delivery_address?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  order_by?: InputMaybe<Scalars['String']>;
  payment_status?: InputMaybe<BobOrderPaymentStatus>;
  start_date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  tag_id?: InputMaybe<Scalars['Int']>;
  /** The reference of the fulfillment (shipment) created in the order */
  tracking_reference?: InputMaybe<Scalars['String']>;
};

export type BobGetOrdersResponseDto = {
  __typename?: 'BobGetOrdersResponseDto';
  count?: Maybe<Scalars['Int']>;
  orders?: Maybe<Array<Maybe<BobOrder>>>;
};

export type BobGetRateRequestsRequestDto = {
  id?: InputMaybe<Scalars['Int']>;
};

export type BobGetRateRequestsResponseDto = {
  __typename?: 'BobGetRateRequestsResponseDto';
  count?: Maybe<Scalars['Int']>;
  rate_requests?: Maybe<Array<Maybe<BobRateRequest>>>;
};

export type BobGetRatesAtCheckoutRequestDto = {
  collection_address: BobAddressInput;
  declared_value?: InputMaybe<Scalars['Int']>;
  delivery_address: BobAddressInput;
  handling_time?: InputMaybe<Scalars['Int']>;
  items: Array<BobRateItem>;
};

export type BobGetRatesAtCheckoutResponseDto = {
  __typename?: 'BobGetRatesAtCheckoutResponseDto';
  count?: Maybe<Scalars['Int']>;
  rates?: Maybe<Array<Maybe<BobRate>>>;
};

export type BobGetShipmentWaybillRequestDto = {
  paper_size?: InputMaybe<Scalars['String']>;
  show_email_address?: InputMaybe<Scalars['Boolean']>;
  show_order_items?: InputMaybe<Scalars['Boolean']>;
  tracking_references?: InputMaybe<Scalars['String']>;
  waybill_size?: InputMaybe<Scalars['String']>;
  waybills_per_shipment?: InputMaybe<Scalars['Int']>;
};

export type BobGetShipmentsRequestDto = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type BobGetShipmentsResponseDto = {
  __typename?: 'BobGetShipmentsResponseDto';
  count?: Maybe<Scalars['Int']>;
  shipments?: Maybe<Array<Maybe<BobShipment>>>;
};

export type BobGetTrackingEventsRequestDto = {
  tracking_reference?: InputMaybe<Scalars['String']>;
};

export type BobLiabilityCover = {
  __typename?: 'BobLiabilityCover';
  declared_value?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  provider_liability_cover?: Maybe<Scalars['Boolean']>;
};

export type BobOrder = {
  __typename?: 'BobOrder';
  account_id?: Maybe<Scalars['Int']>;
  archived_by_user?: Maybe<Scalars['String']>;
  buyer_selected_shipping_cost?: Maybe<Scalars['Float']>;
  buyer_selected_shipping_method?: Maybe<Scalars['String']>;
  channel?: Maybe<BobChannel>;
  channel_order_number?: Maybe<Scalars['String']>;
  channel_order_url?: Maybe<Scalars['String']>;
  channel_ref_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['Int']>;
  created_by_user?: Maybe<BobUser>;
  currency?: Maybe<Scalars['String']>;
  customer_email?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  customer_phone?: Maybe<Scalars['String']>;
  customer_surname?: Maybe<Scalars['String']>;
  date_placed_on_channel?: Maybe<Scalars['String']>;
  delivery_address?: Maybe<BobAddress>;
  delivery_address_id?: Maybe<Scalars['Int']>;
  fulfillment_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_modified_on_channel?: Maybe<Scalars['String']>;
  line_item_total?: Maybe<Scalars['Int']>;
  meta?: Maybe<BobOrderMeta>;
  note?: Maybe<Scalars['String']>;
  order_fulfillment_presets?: Maybe<BobOrderFulfillmentPreset>;
  order_fulfillments?: Maybe<Scalars['String']>;
  order_items?: Maybe<Array<Maybe<BobOrderItem>>>;
  payment_status?: Maybe<BobOrderPaymentStatus>;
  rate_request?: Maybe<BobRateRequest>;
  rate_request_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  taxes_included?: Maybe<Scalars['Boolean']>;
  time_archived?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  total_discount?: Maybe<Scalars['Int']>;
  total_fulfilled_qty?: Maybe<Scalars['Int']>;
  total_price?: Maybe<Scalars['Float']>;
  total_qty?: Maybe<Scalars['Int']>;
  total_tax?: Maybe<Scalars['Int']>;
  total_weight_kg?: Maybe<Scalars['Float']>;
};

export type BobOrderFulfillment = {
  __typename?: 'BobOrderFulfillment';
  account_id?: Maybe<Scalars['Int']>;
  batch_number?: Maybe<Scalars['String']>;
  channel_ref_id?: Maybe<Scalars['String']>;
  failed_reason?: Maybe<Scalars['String']>;
  fulfilled_by_user?: Maybe<BobUser>;
  fulfillment_provider?: Maybe<Scalars['String']>;
  fulfillment_service_level_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<BobOrderFulfillmentItem>>>;
  method?: Maybe<Scalars['String']>;
  method_id?: Maybe<Scalars['Int']>;
  method_reference?: Maybe<Scalars['String']>;
  method_status?: Maybe<Scalars['String']>;
  modified_by?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type BobOrderFulfillmentItem = {
  __typename?: 'BobOrderFulfillmentItem';
  id?: Maybe<Scalars['Int']>;
  order_fulfillment_id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  order_item?: Maybe<BobOrderItem>;
  order_item_id?: Maybe<Scalars['Int']>;
  qty?: Maybe<Scalars['Int']>;
};

export type BobOrderFulfillmentPreset = {
  __typename?: 'BobOrderFulfillmentPreset';
  buyer_contact_number?: Maybe<Scalars['String']>;
  buyer_email?: Maybe<Scalars['String']>;
  buyer_name?: Maybe<Scalars['String']>;
  collection_address_book?: Maybe<BobCollectionAddressBook>;
  collection_address_book_id?: Maybe<Scalars['Int']>;
  collection_address_book_name?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider_slug?: Maybe<Scalars['String']>;
  service_level_code?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BobOrderFulfillments = {
  __typename?: 'BobOrderFulfillments';
  buyer_collection?: Maybe<Scalars['String']>;
  order_fulfillment?: Maybe<BobOrderFulfillment>;
  shipment?: Maybe<BobShipment>;
};

export type BobOrderItem = {
  __typename?: 'BobOrderItem';
  channel_location?: Maybe<Scalars['String']>;
  channel_ref_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  fulfilled_qty?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  total_price?: Maybe<Scalars['Int']>;
  total_weight_kg?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Int']>;
  unit_weight_kg?: Maybe<Scalars['Float']>;
  vendor?: Maybe<Scalars['String']>;
};

export type BobOrderItemInput = {
  channel_location?: InputMaybe<Scalars['String']>;
  channel_ref_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  fulfilled_qty?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
  total_price?: InputMaybe<Scalars['Int']>;
  total_weight_kg?: InputMaybe<Scalars['Float']>;
  unit_price?: InputMaybe<Scalars['Int']>;
  unit_weight_kg?: InputMaybe<Scalars['Float']>;
  vendor?: InputMaybe<Scalars['String']>;
};

export type BobOrderMeta = {
  __typename?: 'BobOrderMeta';
  buyer_selected_shipping_method_codes?: Maybe<Scalars['String']>;
  original_address?: Maybe<Scalars['String']>;
};

export enum BobOrderPaymentStatus {
  Paid = 'paid',
  /** partially-paid */
  Unpaid = 'unpaid'
}

export type BobParcel = {
  __typename?: 'BobParcel';
  actual_height_cm?: Maybe<Scalars['String']>;
  actual_length_cm?: Maybe<Scalars['String']>;
  actual_weight_kg?: Maybe<Scalars['String']>;
  actual_width_cm?: Maybe<Scalars['String']>;
  custom_parcel_reference?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  is_additional?: Maybe<Scalars['String']>;
  package_id?: Maybe<Scalars['Int']>;
  provider_tracking_reference?: Maybe<Scalars['String']>;
  submitted_height_cm?: Maybe<Scalars['Float']>;
  submitted_length_cm?: Maybe<Scalars['Float']>;
  submitted_weight_kg?: Maybe<Scalars['Float']>;
  submitted_width_cm?: Maybe<Scalars['Float']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  tracking_reference?: Maybe<Scalars['String']>;
};

export type BobParcelInput = {
  custom_parcel_reference?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  submitted_height_cm?: InputMaybe<Scalars['Float']>;
  submitted_length_cm?: InputMaybe<Scalars['Float']>;
  submitted_weight_kg?: InputMaybe<Scalars['Float']>;
  submitted_width_cm?: InputMaybe<Scalars['Float']>;
};

export type BobProviderRateRequest = {
  __typename?: 'BobProviderRateRequest';
  failed_reason?: Maybe<Scalars['String']>;
  is_custom_account?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['Int']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_slug?: Maybe<Scalars['String']>;
  rate_response_id?: Maybe<Scalars['Int']>;
  responses?: Maybe<Array<Maybe<Scalars['Any']>>>;
  status?: Maybe<Scalars['String']>;
};

export type BobRate = {
  __typename?: 'BobRate';
  base_rate?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  liability_cover?: Maybe<BobLiabilityCover>;
  max_delivery_date?: Maybe<Scalars['String']>;
  min_delivery_date?: Maybe<Scalars['String']>;
  service_code?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  surcharges?: Maybe<Array<Maybe<Scalars['String']>>>;
  total_price?: Maybe<Scalars['Int']>;
};

export type BobRateItem = {
  description?: InputMaybe<Scalars['String']>;
  height_cm?: InputMaybe<Scalars['Float']>;
  length_cm?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  weight_kg?: InputMaybe<Scalars['Float']>;
  width_cm?: InputMaybe<Scalars['Float']>;
};

export type BobRateRequest = {
  __typename?: 'BobRateRequest';
  account?: Maybe<BobShipmentAccount>;
  account_id?: Maybe<Scalars['Int']>;
  collection_address?: Maybe<BobAddress>;
  declared_value?: Maybe<Scalars['Int']>;
  delivery_address?: Maybe<BobAddress>;
  id?: Maybe<Scalars['Int']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider_rate_requests?: Maybe<Array<Maybe<BobProviderRateRequest>>>;
  request_timeout?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  timeout?: Maybe<Scalars['Int']>;
  total_submitted_weight_kg?: Maybe<Scalars['Float']>;
  webhook_url?: Maybe<Scalars['String']>;
};

export type BobShipment = {
  __typename?: 'BobShipment';
  account?: Maybe<BobShipmentAccount>;
  account_id?: Maybe<Scalars['Int']>;
  billing_transactions?: Maybe<Array<Maybe<BobBillingBillingTransaction>>>;
  charged_amount?: Maybe<Scalars['Float']>;
  charged_weight_kg?: Maybe<Scalars['Int']>;
  collected_date?: Maybe<Scalars['String']>;
  collection_address?: Maybe<BobAddress>;
  collection_address_id?: Maybe<Scalars['Int']>;
  collection_after?: Maybe<Scalars['String']>;
  collection_before?: Maybe<Scalars['String']>;
  collection_contact_email?: Maybe<Scalars['String']>;
  collection_contact_mobile_number?: Maybe<Scalars['String']>;
  collection_contact_name?: Maybe<Scalars['String']>;
  collection_min_date?: Maybe<Scalars['String']>;
  courier_confirmed_rate?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['Int']>;
  created_by_user?: Maybe<BobUser>;
  custom_account?: Maybe<Scalars['Boolean']>;
  custom_account_code?: Maybe<Scalars['String']>;
  custom_tracking_reference?: Maybe<Scalars['String']>;
  declared_value?: Maybe<Scalars['String']>;
  delivered_date?: Maybe<Scalars['String']>;
  delivery_address?: Maybe<BobAddress>;
  delivery_address_id?: Maybe<Scalars['Int']>;
  delivery_contact_email?: Maybe<Scalars['String']>;
  delivery_contact_mobile_number?: Maybe<Scalars['String']>;
  delivery_contact_name?: Maybe<Scalars['String']>;
  failed_reason?: Maybe<Scalars['String']>;
  has_provider_doc?: Maybe<Scalars['Boolean']>;
  health_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_response_code?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  meta?: Maybe<BobShipmentMeta>;
  modified_by?: Maybe<Scalars['Int']>;
  modified_by_user?: Maybe<Scalars['String']>;
  next_retry_time?: Maybe<Scalars['String']>;
  order_fulfillment?: Maybe<Scalars['String']>;
  order_fulfillment_id?: Maybe<Scalars['Int']>;
  parcel_count?: Maybe<Scalars['Int']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider?: Maybe<BobShipmentProvider>;
  provider_id?: Maybe<Scalars['Int']>;
  provider_shipment_id?: Maybe<Scalars['String']>;
  provider_slug?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  rate_response_id?: Maybe<Scalars['Int']>;
  retry_count?: Maybe<Scalars['Int']>;
  service_level?: Maybe<BobShipmentServiceLevel>;
  service_level_code?: Maybe<Scalars['String']>;
  service_level_cut_off_time?: Maybe<Scalars['String']>;
  service_level_id?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submission_status?: Maybe<Scalars['String']>;
  submitted_weight_kg?: Maybe<Scalars['Float']>;
  surcharge?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  timeout?: Maybe<Scalars['Int']>;
  tracking_expiry_date?: Maybe<Scalars['String']>;
  tracking_last_event_time?: Maybe<Scalars['String']>;
  tracking_reference?: Maybe<Scalars['String']>;
};

export type BobShipmentAccount = {
  __typename?: 'BobShipmentAccount';
  account_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type BobShipmentMeta = {
  __typename?: 'BobShipmentMeta';
  collection_address_book_id?: Maybe<Scalars['Int']>;
  collection_reference?: Maybe<Scalars['String']>;
  estimated_collection_date?: Maybe<Scalars['String']>;
  estimated_delivery_date?: Maybe<Scalars['String']>;
  health_status_reason?: Maybe<Scalars['String']>;
  sl_collection_agent_id?: Maybe<Scalars['String']>;
  sl_collection_agent_zone?: Maybe<Scalars['String']>;
  sl_collection_branch?: Maybe<Scalars['String']>;
  sl_delivery_agent_id?: Maybe<Scalars['String']>;
  sl_delivery_agent_zone?: Maybe<Scalars['String']>;
  sl_delivery_branch?: Maybe<Scalars['String']>;
};

export type BobShipmentMovementEvent = {
  __typename?: 'BobShipmentMovementEvent';
  collected_time?: Maybe<Scalars['String']>;
  delivered_time?: Maybe<Scalars['String']>;
  in_transit_time?: Maybe<Scalars['String']>;
  out_for_delivery_time?: Maybe<Scalars['String']>;
};

export type BobShipmentProvider = {
  __typename?: 'BobShipmentProvider';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type BobShipmentServiceLevel = {
  __typename?: 'BobShipmentServiceLevel';
  code?: Maybe<Scalars['String']>;
  collection_cut_off_time?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  expected_delivery_time_hours?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type BobShipmentWaybill = {
  __typename?: 'BobShipmentWaybill';
  download_url?: Maybe<Scalars['String']>;
  file_history_id?: Maybe<Scalars['String']>;
  pdf_queued?: Maybe<Scalars['Boolean']>;
  shipments?: Maybe<Array<Maybe<BobShipment>>>;
  waybills_ready?: Maybe<Scalars['Boolean']>;
};

export type BobTrackingEvent = {
  __typename?: 'BobTrackingEvent';
  checkpoints?: Maybe<Array<Maybe<BobCheckpoint>>>;
  courier_logo?: Maybe<Scalars['String']>;
  courier_name?: Maybe<Scalars['String']>;
  courier_phone?: Maybe<Scalars['String']>;
  courier_slug?: Maybe<Scalars['String']>;
  custom_order_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_checkpoint_time?: Maybe<Scalars['String']>;
  merchant_logo?: Maybe<Scalars['String']>;
  merchant_name?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  service_level?: Maybe<Scalars['String']>;
  shipment_movement_events?: Maybe<BobShipmentMovementEvent>;
  shipment_time_created?: Maybe<Scalars['String']>;
  shipment_tracking_reference?: Maybe<Scalars['String']>;
  show_branding?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  status_friendly?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BobUser = {
  __typename?: 'BobUser';
  accepted_terms?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['Int']>;
  api_key?: Maybe<Scalars['String']>;
  created_by_user?: Maybe<BobUser>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  role_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BooleanOperator = {
  eq?: InputMaybe<Scalars['Boolean']>;
};

export type BreakDownItems = {
  __typename?: 'BreakDownItems';
  average: Scalars['Int'];
  excellent: Scalars['Int'];
  good: Scalars['Int'];
  poor: Scalars['Int'];
  veryGood: Scalars['Int'];
};

export type BulkProductStockInput = {
  cost_price: Scalars['Float'];
  personnel?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  qty: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
  sku: Scalars['String'];
};

export type CampaginCondition = {
  __typename?: 'CampaginCondition';
  Model: Scalars['String'];
  attribute: Scalars['String'];
  operator: ComparisonOperator;
  value: Scalars['Float'];
};

export type CampaginConditionInput = {
  Model: Scalars['String'];
  attribute: Scalars['String'];
  operator: ComparisonOperator;
  value: Scalars['Float'];
};

export type Campaign = {
  __typename?: 'Campaign';
  campaignImageUrl?: Maybe<Scalars['String']>;
  conditions: Array<CampaginCondition>;
  couponCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  id: Scalars['ID'];
  participation?: Maybe<CampaignParticipation>;
  startDate: Scalars['String'];
  title: Scalars['String'];
};

export type CampaignFilter = {
  endDate?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  startDate?: InputMaybe<DateOperator>;
  title?: InputMaybe<StringOperator>;
};

export type CampaignModel = {
  __typename?: 'CampaignModel';
  attributes: Array<Scalars['String']>;
  name: Scalars['String'];
  operators: Array<ComparisonOperator>;
};

export type CampaignParticipation = {
  __typename?: 'CampaignParticipation';
  earnedPoints: Scalars['Int'];
  totalPoints: Scalars['Int'];
};

export type CartAssignmentFilter = {
  order?: InputMaybe<CartFilter>;
  priority?: InputMaybe<NumberOperator>;
  rider_id?: InputMaybe<IdOperator>;
  status?: InputMaybe<StringOperator>;
};

export type CartConflict = {
  __typename?: 'CartConflict';
  allowReplace: Scalars['Boolean'];
  code: Scalars['String'];
  message: Scalars['String'];
};

export type CartFilter = {
  cart_number?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  customer_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  instantDelivery?: InputMaybe<BooleanOperator>;
  offline?: InputMaybe<BooleanOperator>;
  payment_id?: InputMaybe<StringOperator>;
  shop_id?: InputMaybe<IdOperator>;
  source?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  supplier_status?: InputMaybe<StringOperator>;
  tracking_code?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
  user_type?: InputMaybe<StringOperator>;
};

/** Cart item for the in-app cart, backed by duke_cart_items and enriched with product data. */
export type CartItem = {
  __typename?: 'CartItem';
  discount: Scalars['Float'];
  id: Scalars['ID'];
  inStock: Scalars['Boolean'];
  isFreeDelivery?: Maybe<Scalars['Boolean']>;
  lineSubtotal?: Maybe<Scalars['Float']>;
  lineTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<Product>;
  productSku: Scalars['ID'];
  profit: Scalars['Float'];
  profitType: ProfitType;
  quantity: Scalars['Int'];
  userId: Scalars['ID'];
};

export type CartOperationResult = {
  __typename?: 'CartOperationResult';
  cart?: Maybe<AppCart>;
  conflict?: Maybe<CartConflict>;
  success: Scalars['Boolean'];
};

export type Catalog = {
  __typename?: 'Catalog';
  banner: Scalars['String'];
  config?: Maybe<CollectionConfig>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFreeDelivery?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type CatalogCollection = {
  __typename?: 'CatalogCollection';
  catalog?: Maybe<Catalog>;
  collection?: Maybe<Catalog>;
  id?: Maybe<Scalars['ID']>;
};

export type CatalogConfigInput = {
  collection_id: Scalars['ID'];
  free_delivery_locations?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  is_free_delivery: Scalars['Boolean'];
  reduction_type?: InputMaybe<ReductionType>;
  reduction_value?: InputMaybe<Scalars['Float']>;
};

export type CatalogData = CatalogCollection | CategoryCollection | ProductCollection;

export type CatalogFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
};

export type CatalogInput = {
  banner: Scalars['String'];
  config?: InputMaybe<CatalogConfigInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type CatalogMedia = {
  __typename?: 'CatalogMedia';
  id?: Maybe<Scalars['ID']>;
  media?: Maybe<Scalars['String']>;
};

export enum CatalogType {
  Catalog = 'CATALOG',
  Category = 'CATEGORY',
  Product = 'PRODUCT'
}

export type CategoryCollection = {
  __typename?: 'CategoryCollection';
  category?: Maybe<ProductCategory>;
  collection?: Maybe<Catalog>;
  id?: Maybe<Scalars['ID']>;
};

export enum CategoryType {
  Digital = 'DIGITAL',
  Physical = 'PHYSICAL'
}

export enum ChangeBy {
  Ops = 'ops',
  Reseller = 'reseller'
}

export type ChangeTeamNameInput = {
  name: Scalars['String'];
  team_id: Scalars['ID'];
};

export enum ChannelType {
  Sms = 'sms',
  Whatsapp = 'whatsapp'
}

export type ChargeWalletInput = {
  amount: Scalars['Float'];
  currency: CurrencyInput;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  secret: Scalars['String'];
  wallet_id: Scalars['ID'];
};

export type ChargeWalletResponseDto = {
  __typename?: 'ChargeWalletResponseDTO';
  error?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSONObject']>;
  reference: Scalars['String'];
  status: Scalars['String'];
  transaction?: Maybe<Transaction>;
};

export type CheckTransactionInput = {
  reference: Scalars['String'];
  type: TransactionType;
};

export type CheckTransactionResponseDto = {
  __typename?: 'CheckTransactionResponseDTO';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  transaction?: Maybe<Transaction>;
};

export type CheckoutCart = {
  __typename?: 'CheckoutCart';
  addressId?: Maybe<Scalars['ID']>;
  country?: Maybe<Scalars['String']>;
  couponCode?: Maybe<Scalars['String']>;
  couponId?: Maybe<Scalars['ID']>;
  currency: Scalars['String'];
  customerId?: Maybe<Scalars['ID']>;
  customerPaid: Scalars['Boolean'];
  deliveryId?: Maybe<Scalars['ID']>;
  deliveryType?: Maybe<CheckoutDeliveryMethod>;
  eligibleDeliveryMethods: Array<CheckoutDeliveryMethod>;
  flags: CheckoutCartFlags;
  id: Scalars['ID'];
  items: Array<CheckoutCartItem>;
  paymentMethod?: Maybe<CheckoutPaymentMethod>;
  pricing: CheckoutCartPricing;
  updatedAt?: Maybe<Scalars['String']>;
  validation: CheckoutCartValidation;
  version: Scalars['Int'];
  walletBalance?: Maybe<Scalars['Float']>;
};

export type CheckoutCartConflict = {
  __typename?: 'CheckoutCartConflict';
  code: CheckoutConflictCode;
  message: Scalars['String'];
  resolvableBy: Array<CheckoutConflictResolution>;
};

export type CheckoutCartFlags = {
  __typename?: 'CheckoutCartFlags';
  allowInstantDelivery: Scalars['Boolean'];
  effectFreeDeliveryFromDiscount: Scalars['Boolean'];
  hasAliExpressProduct: Scalars['Boolean'];
  hasFreeDeliveryItem: Scalars['Boolean'];
  hasInstantDeliveryItem: Scalars['Boolean'];
};

export type CheckoutCartIssue = {
  __typename?: 'CheckoutCartIssue';
  code: Scalars['String'];
  message: Scalars['String'];
  severity: Scalars['String'];
};

export type CheckoutCartItem = {
  __typename?: 'CheckoutCartItem';
  id: Scalars['ID'];
  inhouse: Scalars['Boolean'];
  instantDelivery: Scalars['Boolean'];
  isFreeDelivery: Scalars['Boolean'];
  lineTotal: Scalars['Float'];
  product?: Maybe<Product>;
  productId: Scalars['ID'];
  productSku: Scalars['ID'];
  profit: Scalars['Float'];
  profitType: ProfitType;
  qty: Scalars['Int'];
  supplierId?: Maybe<Scalars['ID']>;
  unitPrice: Scalars['Float'];
};

export type CheckoutCartMutationResult = {
  __typename?: 'CheckoutCartMutationResult';
  cart: CheckoutCart;
  conflict?: Maybe<CheckoutCartConflict>;
};

export type CheckoutCartPricing = {
  __typename?: 'CheckoutCartPricing';
  amountToPay: Scalars['Float'];
  currency: Scalars['String'];
  deliveryFee: Scalars['Float'];
  deliveryFeeWaived: Scalars['Boolean'];
  discount: Scalars['Float'];
  forcedFullPayment: Scalars['Boolean'];
  forcedFullPaymentReason?: Maybe<Scalars['String']>;
  mustPayBeforeDelivery: Scalars['Boolean'];
  paymentMethod: CheckoutPaymentMethod;
  paymentRequirement: CheckoutPaymentRequirement;
  productsTotal: Scalars['Float'];
  profitTotal: Scalars['Float'];
  redeemableCashRewards: Scalars['Float'];
  redeemableFreeDelivery: Scalars['Float'];
  securityDeposit: Scalars['Float'];
  shippingCost: Scalars['Float'];
  total: Scalars['Float'];
  totalTotal: Scalars['Float'];
};

export type CheckoutCartValidation = {
  __typename?: 'CheckoutCartValidation';
  canPlaceOrder: Scalars['Boolean'];
  canProceedToPayment: Scalars['Boolean'];
  issues: Array<CheckoutCartIssue>;
  stockOk: Scalars['Boolean'];
};

export enum CheckoutConflictCode {
  AliexpressMix = 'ALIEXPRESS_MIX',
  FreeDeliveryMix = 'FREE_DELIVERY_MIX',
  InstantMix = 'INSTANT_MIX'
}

export enum CheckoutConflictResolution {
  NoExpressDelivery = 'NO_EXPRESS_DELIVERY',
  ReplaceCart = 'REPLACE_CART'
}

/**
 * Server-authoritative cart & checkout (additive). All money is Float at 2 dp
 * (currency is precise internally; display is x.xx). Reseller is derived from the
 * JWT — never from input. The legacy in-app cart (AppCart/CartItem) and
 * createOrder/chargeWallet stay untouched during rollout.
 * Reuses the existing `ProfitType` enum (amount | percent).
 */
export enum CheckoutDeliveryMethod {
  Delivery = 'DELIVERY',
  ExpressDelivery = 'EXPRESS_DELIVERY',
  Pickup = 'PICKUP'
}

export enum CheckoutFundingMethod {
  Card = 'CARD',
  Gateway = 'GATEWAY',
  Wallet = 'WALLET'
}

export type CheckoutPaymentIntent = {
  __typename?: 'CheckoutPaymentIntent';
  clientSecret?: Maybe<Scalars['String']>;
  gateway?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
};

export enum CheckoutPaymentMethod {
  Cod = 'COD',
  Pon = 'PON',
  Pop = 'POP'
}

export enum CheckoutPaymentRequirement {
  Deposit = 'DEPOSIT',
  Full = 'FULL',
  None = 'NONE'
}

export type ClaimCouponInput = {
  code: Scalars['String'];
  user_id: Scalars['ID'];
};

export type ClaimDiscountRequestDto = {
  discount_code: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
};

export type ClearStorefrontCartInput = {
  cart_id: Scalars['ID'];
};

export type ClientProductFilter = {
  catalog?: InputMaybe<CatalogFilter>;
  category?: InputMaybe<ProductCategoryFilter>;
  combination_string?: InputMaybe<StringOperator>;
  distributionChannels?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  main_stock?: InputMaybe<NumberOperator>;
  price?: InputMaybe<NumberOperator>;
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<StringOperator>;
  qty?: InputMaybe<NumberOperator>;
  random?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tags?: InputMaybe<StringOperator>;
  title?: InputMaybe<StringOperator>;
  uuid?: InputMaybe<StringOperator>;
};

export type ClosingBalance = {
  __typename?: 'ClosingBalance';
  balance: Scalars['Float'];
  closed: Scalars['Boolean'];
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  wallet_id: Scalars['ID'];
};

export type CollectionConfig = {
  __typename?: 'CollectionConfig';
  /** this array carries location ids if the collection is restricted to certain locations */
  free_delivery_locations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id: Scalars['ID'];
  is_free_delivery?: Maybe<Scalars['Boolean']>;
  /** The reduction type can be either percentage or amount */
  reduction_type?: Maybe<ReductionType>;
  /** The reduction value can be either a percentage or an amount depending on the reduction type */
  reduction_value?: Maybe<Scalars['Float']>;
};

export enum ComparisonOperator {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL'
}

export enum Condition {
  And = 'and',
  Or = 'or'
}

export enum CountryCode {
  Gh = 'GH',
  Ng = 'NG',
  Za = 'ZA'
}

export type CountryCodeOperator = {
  eq?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type Coupon = {
  __typename?: 'Coupon';
  cash_rewards?: Maybe<Scalars['Float']>;
  code: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  duration: Scalars['String'];
  durationValue: Scalars['Int'];
  expired: Scalars['Boolean'];
  expires_on?: Maybe<Scalars['DateTime']>;
  free_deliveries?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isOnboardingCoupon: Scalars['Boolean'];
  issueToAll: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  neverEnds: Scalars['Boolean'];
  number_of_days?: Maybe<Scalars['Int']>;
  redemption?: Maybe<CouponRedemption>;
  start_date?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  type: CouponType;
  updatedAt: Scalars['DateTime'];
};

export enum CouponDuration {
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type CouponFilter = {
  cash_rewards?: InputMaybe<NumberOperator>;
  code?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  createdAt?: InputMaybe<DateOperator>;
  expires_on?: InputMaybe<DateOperator>;
  free_deliveries?: InputMaybe<NumberOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  number_of_days?: InputMaybe<NumberOperator>;
  special?: InputMaybe<BooleanOperator>;
  type?: InputMaybe<CouponType>;
  user_id?: InputMaybe<IdOperator>;
};

export type CouponInput = {
  cash_rewards?: InputMaybe<Scalars['Float']>;
  code: Scalars['String'];
  duration: CouponDuration;
  duration_value: Scalars['Int'];
  free_deliveries?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  issueToAll: Scalars['Boolean'];
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  neverEnds: Scalars['Boolean'];
  start_date: Scalars['Date'];
  title?: InputMaybe<Scalars['String']>;
  type: CouponType;
};

export type CouponInsight = {
  __typename?: 'CouponInsight';
  totalConsumed?: Maybe<Scalars['Int']>;
  totalConsumedValue?: Maybe<Scalars['Float']>;
  totalRedemptions?: Maybe<Scalars['Int']>;
  totalRedemptionsValue?: Maybe<Scalars['Float']>;
};

export type CouponRedemption = {
  __typename?: 'CouponRedemption';
  cash_rewards_exhausted?: Maybe<Scalars['Float']>;
  coupon?: Maybe<Coupon>;
  coupon_id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  free_delivery_exhausted?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  redeemed: Scalars['Boolean'];
  reseller?: Maybe<User>;
  updatedAt: Scalars['DateTime'];
  user_id: Scalars['ID'];
};

export type CouponRedemptionFilter = {
  coupon_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  redeemed?: InputMaybe<Scalars['Boolean']>;
  user_id?: InputMaybe<IdOperator>;
};

export enum CouponType {
  CashRewards = 'cash_rewards',
  Combo = 'combo',
  FreeDelivery = 'free_delivery'
}

export type CreateCampaignInput = {
  campaignImageUrl?: InputMaybe<Scalars['String']>;
  conditions: Array<CampaginConditionInput>;
  couponCode: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['String'];
  startDate: Scalars['String'];
  title: Scalars['String'];
};

export type CreateCustomerInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateDeveloperInput = {
  country: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
};

export type CreateDigitalOrderInput = {
  customer_address_id?: InputMaybe<Scalars['ID']>;
  customer_id: Scalars['ID'];
  delivery_id?: InputMaybe<Scalars['ID']>;
  orderItems?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
  orderTotal: Scalars['Float'];
  supplier_id?: InputMaybe<Scalars['ID']>;
  user_id: Scalars['ID'];
};

export type CreateDiscountRequestDto = {
  amount?: InputMaybe<Scalars['Float']>;
  banner_url: Scalars['String'];
  code?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<UserType>;
  description: Scalars['String'];
  expiry_date: Scalars['String'];
  fixed_amount_allocation?: InputMaybe<FixedAmountAllocation>;
  is_draft: Scalars['Boolean'];
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locations_tagname?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['Float']>;
  product_condition?: InputMaybe<ProductCondition>;
  products?: InputMaybe<Array<Scalars['String']>>;
  redemptions_limit?: InputMaybe<Scalars['Int']>;
  start_date: Scalars['String'];
  type: DiscountType;
  user_id?: InputMaybe<Scalars['ID']>;
  valid_country: Scalars['String'];
};

export type CreateMemberInput = {
  developer_id: Scalars['ID'];
  role: MemberRole;
  team_id: Scalars['ID'];
};

export type CreatePaymentRequestInput = {
  amount: Scalars['Float'];
  description: Scalars['String'];
  destination_wallet_id?: InputMaybe<Scalars['ID']>;
  destination_wallet_type: WalletType;
  execution_date?: InputMaybe<Scalars['DateTime']>;
  idempotency_key: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSONObject']>;
  source_wallet_id?: InputMaybe<Scalars['ID']>;
  source_wallet_type: WalletType;
};

export type CreatePluginRequestDto = {
  banner_image?: InputMaybe<Scalars['String']>;
  category: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  developer?: InputMaybe<Scalars['String']>;
  endpoint: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
};

export type CreateSalesRequestDto = {
  country: Scalars['String'];
  currency: Scalars['String'];
  order_date?: InputMaybe<Scalars['String']>;
  order_id: Scalars['ID'];
  order_value: Scalars['Float'];
  payment_reference?: InputMaybe<Scalars['ID']>;
  product_cost: Scalars['Float'];
  product_price: Scalars['Float'];
  profit_added: Scalars['Float'];
  reseller_id?: InputMaybe<Scalars['ID']>;
  sku: Scalars['String'];
  supplier_id?: InputMaybe<Scalars['ID']>;
};

export type CreateSalesTargetCampaignInput = {
  cadence: SalesTargetCadence;
  country: CountryCode;
  description?: InputMaybe<Scalars['String']>;
  metric: SalesTargetMetric;
  name: Scalars['String'];
  periodEnd: Scalars['String'];
  periodStart: Scalars['String'];
  rewardDetails?: InputMaybe<Scalars['JSONObject']>;
  rewardDistribution: SalesTargetRewardDistribution;
  rewardDistributionConfig?: InputMaybe<Scalars['JSONObject']>;
  rewardType: SalesTargetRewardType;
  targetAmount: Scalars['Float'];
};

export type CreateSharedProductRequestDto = {
  product_cost_price: Scalars['Float'];
  product_id: Scalars['ID'];
  profit_added_by_reseller: Scalars['Float'];
  shared_by: Scalars['ID'];
  total_selling_price: Scalars['Float'];
};

export type CreateSharedProductResponseDto = {
  __typename?: 'CreateSharedProductResponseDto';
  sharedProduct?: Maybe<SharedProduct>;
};

export type CreateShopRequestDto = {
  /** Profile image */
  avatar?: InputMaybe<Scalars['String']>;
  /** The public-facing contact email address for the shop. Customers will use this email to communicate with the shop owner. */
  contactEmail: Scalars['String'];
  /** Country code of where shop is located */
  country: CountryCode;
  /** Backdrop banner image */
  coverImage?: InputMaybe<Scalars['String']>;
  /** Currency code the shop will receive payouts in. */
  currency: CurrencyCode;
  deliveryAgent?: InputMaybe<DeliveryAgent>;
  deliveryOption?: InputMaybe<DeliveryOption>;
  description?: InputMaybe<Scalars['String']>;
  /** The shop owner's email address. Tendo will use this email address to communicate with the shop owner. */
  email: Scalars['String'];
  /** Indicates whether shop is active */
  isActive?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<ShopLocationRequestDto>;
  /** Full name of shop */
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  paymentOptions: Array<InputMaybe<PaymentOption>>;
  phone: Scalars['String'];
  /** Tags used to identify the shop */
  shopTags: Array<InputMaybe<Scalars['String']>>;
  shopType: ShopType;
  shortUrl?: InputMaybe<Scalars['String']>;
  /** The host name only. Should NOT contain .mysoko.shop. */
  sokoWorldHostname: Scalars['String'];
};

export type CreateShopResponseDto = {
  __typename?: 'CreateShopResponseDto';
  shopId?: Maybe<Scalars['ID']>;
};

export type CreateStorefrontCartInput = {
  country?: InputMaybe<Scalars['String']>;
  identity?: InputMaybe<Scalars['String']>;
  items: Array<InputMaybe<StorefrontCartItemInput>>;
  shop_id: Scalars['ID'];
  status?: InputMaybe<StorefrontCartStatusType>;
};

export type CreateTeamCredentialInput = {
  scope: Array<Scalars['String']>;
  team_id: Scalars['ID'];
};

export type CreateTeamInput = {
  country?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateTopDealBannerInput = {
  url: Scalars['String'];
};

export type CreateUserAccountSecurityInput = {
  securityToken: Scalars['String'];
  securityType: AccountSecurityType;
  userType: UserType;
  user_id: Scalars['ID'];
};

export type CreateWalletInput = {
  currency: CurrencyInput;
  merchant_id: Scalars['ID'];
  wallet_type?: InputMaybe<WalletType>;
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String'];
  name: Scalars['String'];
};

export enum CurrencyCode {
  Ghs = 'GHS',
  Ngn = 'NGN',
  Zar = 'ZAR'
}

export type CurrencyInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export enum CurrencyType {
  Base = 'base',
  Fiat = 'fiat',
  Points = 'points'
}

export type CurrencyTypeOperator = {
  eq?: InputMaybe<CurrencyType>;
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Array<Maybe<CustomerAddress>>>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  reseller?: Maybe<User>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  area: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  landmark?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
};

export type CustomerAuthPayload = {
  __typename?: 'CustomerAuthPayload';
  token: Scalars['String'];
  user?: Maybe<Customer>;
};

export type CustomerFilter = {
  address?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type CustomerInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type CustomerLoginInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CustomerSubscription = {
  __typename?: 'CustomerSubscription';
  billing_cycle: BillingCycle;
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  next_billing_date: Scalars['Date'];
  status: SubscriptionStatus;
  subscription?: Maybe<Subscription>;
  subscription_id: Scalars['ID'];
  updated_at?: Maybe<Scalars['Date']>;
  user_email: Scalars['String'];
  user_id: Scalars['ID'];
};

export type CustomerSubscriptionInput = {
  billing_cycle: BillingCycle;
  created_at?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  next_billing_date: Scalars['Date'];
  status: SubscriptionStatus;
  subscription?: InputMaybe<SubscriptionInput>;
  subscription_id: Scalars['ID'];
  updated_at?: InputMaybe<Scalars['Date']>;
  user_email: Scalars['String'];
  user_id: Scalars['ID'];
};

export type DailyNetInflowSnapshot = {
  __typename?: 'DailyNetInflowSnapshot';
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  deliveredCod: NetInflowLineItemSummary;
  generatedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lockedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  netInflow: Scalars['Float'];
  profitPayouts: NetInflowLineItemSummary;
  regeneratedCount: Scalars['Int'];
  snapshotDate: Scalars['String'];
  status: NetInflowSnapshotStatus;
  timezone: Scalars['String'];
  totalInflows: Scalars['Float'];
  totalOutflows: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  walletDeposits: NetInflowLineItemSummary;
  walletWithdrawals: NetInflowLineItemSummary;
};

export type DateOperator = {
  after?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['DateTime']>;
  between?: InputMaybe<DateRange>;
  eq?: InputMaybe<Scalars['DateTime']>;
};

export type DateRange = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type DateRangeDto = {
  __typename?: 'DateRangeDTO';
  end?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
};

export type DateRangeFilter = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type DeleteUserAccountSecurityInput = {
  id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type DeliveredOrders = {
  __typename?: 'DeliveredOrders';
  cart_id?: Maybe<Scalars['ID']>;
  cart_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  date_to_credit?: Maybe<Scalars['Date']>;
  days_profit_has_delayed?: Maybe<Scalars['Int']>;
  deposit_refunded?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  order_id?: Maybe<Scalars['ID']>;
  order_number?: Maybe<Scalars['String']>;
  profit_added?: Maybe<Scalars['Float']>;
  profit_credit_status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Date']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type DeliveredOrdersFilter = {
  cart_id?: InputMaybe<IdOperator>;
  cart_number?: InputMaybe<StringOperator>;
  date_to_credit?: InputMaybe<DateOperator>;
  days_profit_has_delayed?: InputMaybe<NumberOperator>;
  id?: InputMaybe<IdOperator>;
  order_id?: InputMaybe<IdOperator>;
  order_number?: InputMaybe<StringOperator>;
  profit_credit_status?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type Delivery = {
  __typename?: 'Delivery';
  country?: Maybe<Scalars['String']>;
  hasInstantDelivery: Scalars['Boolean'];
  id: Scalars['ID'];
  instantDeliveryPrice?: Maybe<Scalars['Float']>;
  isPayOnline: Scalars['Boolean'];
  location: Scalars['String'];
  price: Scalars['Float'];
  remarks?: Maybe<Scalars['String']>;
  supplierId?: Maybe<Scalars['ID']>;
};

export enum DeliveryAgent {
  Shop = 'SHOP',
  Tendo = 'TENDO'
}

export type DeliveryFilter = {
  country?: InputMaybe<StringOperator>;
  hasInstantDelivery?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<StringOperator>;
  isPayOnline?: InputMaybe<BooleanOperator>;
  location?: InputMaybe<StringOperator>;
  price?: InputMaybe<NumberOperator>;
  remarks?: InputMaybe<StringOperator>;
  supplierId?: InputMaybe<IdOperator>;
};

export type DeliveryInput = {
  hasInstantDelivery: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  instantDeliveryPrice?: InputMaybe<Scalars['Float']>;
  isPayOnline: Scalars['Boolean'];
  location: Scalars['String'];
  price: Scalars['Float'];
  remarks?: InputMaybe<Scalars['String']>;
  supplierId?: InputMaybe<Scalars['ID']>;
};

export enum DeliveryOption {
  Manual = 'Manual',
  Swoove = 'Swoove'
}

export type DeliveryPricesInput = {
  address: Scalars['String'];
  destination?: InputMaybe<Latlng>;
  source?: InputMaybe<Latlng>;
};

export type DeliveryZone = {
  __typename?: 'DeliveryZone';
  base_price: Scalars['Float'];
  coordinates: Array<LatLng>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DeliveryZonesFilter = {
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
};

export type DeliveryZonesInput = {
  base_price: Scalars['Float'];
  coordinates: Array<InputMaybe<Scalars['Any']>>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type Details = {
  dob?: InputMaybe<Scalars['Date']>;
  gender?: InputMaybe<Scalars['String']>;
  referred_by?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type Developer = {
  __typename?: 'Developer';
  id: Scalars['ID'];
  memberships?: Maybe<Array<Maybe<Member>>>;
  reseller?: Maybe<User>;
  reseller_id: Scalars['ID'];
};

export type DeveloperLoginInput = {
  deviceToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type DeveloperResponse = {
  __typename?: 'DeveloperResponse';
  developer?: Maybe<Developer>;
  team?: Maybe<Team>;
  token?: Maybe<Scalars['String']>;
};

export type DigitalOrder = {
  __typename?: 'DigitalOrder';
  createdAt: Scalars['DateTime'];
  customer?: Maybe<Customer>;
  customerId: Scalars['ID'];
  deliveryMode: Scalars['String'];
  digitalDetails?: Maybe<Scalars['Any']>;
  id: Scalars['ID'];
  orderNumber: Scalars['String'];
  paymentReference?: Maybe<Scalars['String']>;
  paymentStatus: Scalars['String'];
  price: Scalars['Float'];
  product?: Maybe<Product>;
  productId: Scalars['ID'];
  profitAdded: Scalars['Float'];
  reseller?: Maybe<User>;
  resellerId: Scalars['ID'];
  status: Scalars['String'];
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['DateTime'];
};

export type DigitalOrderFilter = {
  id?: InputMaybe<IdOperator>;
  orderNumber?: InputMaybe<StringOperator>;
};

export type DigitalOrderInput = {
  customerId: Scalars['ID'];
  deliveryMode: Scalars['String'];
  digitalDetails?: InputMaybe<Scalars['Any']>;
  paymentReference?: InputMaybe<Scalars['String']>;
  paymentStatus: Scalars['String'];
  price: Scalars['Float'];
  productId: Scalars['ID'];
  profitAdded: Scalars['Float'];
  resellerId: Scalars['ID'];
  status: Scalars['String'];
  supplierId?: InputMaybe<Scalars['ID']>;
};

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  created_by?: Maybe<UserType>;
  description: Scalars['String'];
  expiry_date: Scalars['String'];
  fixed_amount_allocation?: Maybe<FixedAmountAllocation>;
  has_expired?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  is_draft: Scalars['Boolean'];
  locations?: Maybe<Array<Maybe<Scalars['String']>>>;
  locations_tagname?: Maybe<Scalars['String']>;
  number_of_times_used?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
  product_condition?: Maybe<ProductCondition>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  redemptions_limit?: Maybe<Scalars['Int']>;
  start_date: Scalars['String'];
  type: DiscountType;
  updated_at?: Maybe<Scalars['Date']>;
  user_id?: Maybe<Scalars['ID']>;
  valid_country: Scalars['String'];
};

export type DiscountFilter = {
  amount?: InputMaybe<NumberOperator>;
  code?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  created_by?: InputMaybe<StringOperator>;
  description?: InputMaybe<StringOperator>;
  expiry_date?: InputMaybe<DateOperator>;
  fixed_amount_allocation?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  is_draft?: InputMaybe<BooleanOperator>;
  locations?: InputMaybe<StringOperator>;
  number_of_times_used?: InputMaybe<NumberOperator>;
  percentage?: InputMaybe<NumberOperator>;
  redemptions_limit?: InputMaybe<NumberOperator>;
  start_date?: InputMaybe<DateOperator>;
  type?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
  user_id?: InputMaybe<IdOperator>;
  valid_country?: InputMaybe<StringOperator>;
};

export type DiscountProductCondition = {
  __typename?: 'DiscountProductCondition';
  condition: ProductCondition;
  created_at?: Maybe<Scalars['Date']>;
  discount_id: Scalars['ID'];
  id: Scalars['ID'];
  product?: Maybe<Product>;
  product_sku: Scalars['String'];
  updated_at?: Maybe<Scalars['Date']>;
};

export type DiscountProductConditionFilter = {
  condition?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  discount_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  product_sku?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
};

export type DiscountProductConditionRequestDto = {
  condition: ProductCondition;
  product_sku: Scalars['String'];
};

export enum DiscountType {
  FixedAmount = 'FIXED_AMOUNT',
  FreeDelivery = 'FREE_DELIVERY',
  Percentage = 'PERCENTAGE'
}

export type DiscountUseFilter = {
  country_code?: InputMaybe<StringOperator>;
  discount_code?: InputMaybe<StringOperator>;
  discount_id?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type DoesShopExistResponseDto = {
  __typename?: 'DoesShopExistResponseDto';
  shopExists?: Maybe<Scalars['Boolean']>;
};

export type DownloadWalletStatementInput = {
  dateRange?: InputMaybe<DateRangeFilter>;
  user_id: Scalars['ID'];
  wallet_id: Scalars['ID'];
};

export type EstimateTypeDetails = {
  __typename?: 'EstimateTypeDetails';
  icon?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FailedOrderCharge = {
  __typename?: 'FailedOrderCharge';
  amount: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  detectedAt: Scalars['DateTime'];
  detectionReason: FailedOrderChargeDetectionReason;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSONObject']>;
  paymentRequestId: Scalars['String'];
  refundPaymentRequestId?: Maybe<Scalars['String']>;
  refundTransactionId?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  reviewNotes?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  reviewedBy?: Maybe<Scalars['String']>;
  status: FailedOrderChargeStatus;
  transaction?: Maybe<Transaction>;
  transactionId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['String'];
  verifyAttemptCount: Scalars['Int'];
  walletId: Scalars['Int'];
};

export enum FailedOrderChargeDetectionReason {
  InlineRecheck = 'inline_recheck',
  Manual = 'manual',
  Sweep = 'sweep'
}

export type FailedOrderChargeFilter = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<FailedOrderChargeStatus>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FailedOrderChargePage = {
  __typename?: 'FailedOrderChargePage';
  items: Array<FailedOrderCharge>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  total: Scalars['Int'];
};

export enum FailedOrderChargeStatus {
  AlarmOrderAfterRefund = 'ALARM_ORDER_AFTER_REFUND',
  Detected = 'DETECTED',
  Refunded = 'REFUNDED',
  RefundFailed = 'REFUND_FAILED',
  RefundInProgress = 'REFUND_IN_PROGRESS',
  Rejected = 'REJECTED',
  ResolvedOrderCreated = 'RESOLVED_ORDER_CREATED',
  UnderReview = 'UNDER_REVIEW'
}

export enum FailedOrderReviewAction {
  ApproveRefund = 'APPROVE_REFUND',
  Reject = 'REJECT'
}

export type FeaturedCategories = {
  __typename?: 'FeaturedCategories';
  banners?: Maybe<Array<Maybe<Scalars['String']>>>;
  category?: Maybe<ProductCategory>;
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type FeaturedCategoriesFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
};

export type FeaturedCategoryInput = {
  category_id: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
};

export type FetchShopifyShopInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ShopifyShopFilter>;
};

export type FetchShopifyShopsInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ShopifyShopFilter>;
  pagination?: InputMaybe<Pagination>;
};

export type FetchUserInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
  pagination?: InputMaybe<Pagination>;
};

export enum FixedAmountAllocation {
  ProductSpecific = 'PRODUCT_SPECIFIC',
  TotalAmount = 'TOTAL_AMOUNT'
}

export type ForexRate = {
  __typename?: 'ForexRate';
  createdAt?: Maybe<Scalars['Date']>;
  ghs?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  ngn?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  zar?: Maybe<Scalars['Float']>;
};

export type ForexRateFilter = {
  createdAt?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
};

export type ForexRateInput = {
  ghs?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  ngn?: InputMaybe<Scalars['Float']>;
  zar?: InputMaybe<Scalars['Float']>;
};

export type GeneratedAliExpressProduct = {
  __typename?: 'GeneratedAliExpressProduct';
  aliexpress_ds_product_get_response?: Maybe<AliexpressDsProductGetResponse>;
  code?: Maybe<Scalars['String']>;
  request_id?: Maybe<Scalars['String']>;
};

export type GetCustomerInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type GetDeveloperFilter = {
  email?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  reseller_id?: InputMaybe<IdOperator>;
  username?: InputMaybe<StringOperator>;
};

export type GetDeveloperInput = {
  filter?: InputMaybe<GetDeveloperFilter>;
};

export type GetDevelopersInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<GetDeveloperFilter>;
  pagination?: InputMaybe<Pagination>;
};

export type GetRehookLeaderboardInput = {
  /** Activity ID */
  activity_id?: InputMaybe<Scalars['String']>;
  /** Campaign ID */
  campaign_id: Scalars['String'];
  /** Page number (default: 1) */
  page?: InputMaybe<Scalars['Int']>;
  /** Rehook ID / Source ID of the customer */
  source_id?: InputMaybe<Scalars['String']>;
};

export type GetSalesRequestDto = {
  filter?: InputMaybe<SalesFilter>;
  pagination: Pagination;
};

export type GetSharedProductRequestDto = {
  shared_product_id: Scalars['ID'];
};

export type GetShopResponseDto = {
  __typename?: 'GetShopResponseDto';
  shop?: Maybe<Shop>;
};

export type GetShopsRequestDto = {
  filter?: InputMaybe<ShopFilter>;
  pagination: Pagination;
};

export type GetStorefrontTransactionsInput = {
  condition?: InputMaybe<Condition>;
  filter: StorefrontTransactionFilter;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SortOrder>;
};

export type GetSupplierPickupLocationInput = {
  supplier_id: Scalars['String'];
};

export type GetSupportedProvidersInput = {
  country: CountryCode;
  filter?: InputMaybe<PaystackBanksFilter>;
};

export type GetTeamFilter = {
  id?: InputMaybe<IdOperator>;
  service_id?: InputMaybe<StringOperator>;
};

export type GetTeamInput = {
  filter?: InputMaybe<GetTeamFilter>;
};

export type GetTeamsFilter = {
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  service_id?: InputMaybe<StringOperator>;
};

export type GetTeamsInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<GetTeamsFilter>;
  pagination?: InputMaybe<Pagination>;
};

export type GetTransactionsInput = {
  condition?: InputMaybe<Condition>;
  filter: TransactionFilter;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SortOrder>;
};

export type GetWalletBalanceInput = {
  dateRange?: InputMaybe<DateRangeFilter>;
  wallet_id: Scalars['ID'];
};

export type GetWalletFilter = {
  currency_type?: InputMaybe<CurrencyTypeOperator>;
  merchant_id?: InputMaybe<IdOperator>;
  wallet_id?: InputMaybe<IdOperator>;
};

export type GetWalletInput = {
  filter?: InputMaybe<GetWalletFilter>;
};

export type GetWalletPayoutsInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<WalletPayoutFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SortOrder>;
};

export type GetWalletTransactionsInput = {
  filter?: InputMaybe<TransactionFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SortOrder>;
  wallet_id: Scalars['ID'];
};

export enum GoalCategory {
  MakeMoney = 'MAKE_MONEY',
  NotSure = 'NOT_SURE',
  TryOut = 'TRY_OUT'
}

export type IdOperator = {
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  notIn?: InputMaybe<Array<Scalars['ID']>>;
};

export enum IncomeCategory {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type InitiateCardSetupInput = {
  integration_id: Scalars['String'];
  supplier_email: Scalars['String'];
  supplier_phone: Scalars['String'];
};

export type InnerAeSkuPropertyDtos = {
  __typename?: 'InnerAeSkuPropertyDtos';
  ae_sku_property_d_t_o?: Maybe<Array<Maybe<AeSkuPropertyDto>>>;
};

export type Latlng = {
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
};

export type LatLng = {
  __typename?: 'LatLng';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type LatLngInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type LeaderBoardConfig = {
  __typename?: 'LeaderBoardConfig';
  firstPlaceBonusCashPoints?: Maybe<Scalars['Float']>;
  firstPlaceBonusDeliveries?: Maybe<Scalars['Int']>;
  secondPlaceBonusCashPoints?: Maybe<Scalars['Float']>;
  secondPlaceBonusDeliveries?: Maybe<Scalars['Int']>;
  thirdPlaceBonusCashPoints?: Maybe<Scalars['Float']>;
  thirdPlaceBonusDeliveries?: Maybe<Scalars['Int']>;
};

export type LeaderBoardConfigInput = {
  firstPlaceBonusCashPoints?: InputMaybe<Scalars['Float']>;
  firstPlaceBonusDeliveries?: InputMaybe<Scalars['Int']>;
  secondPlaceBonusCashPoints?: InputMaybe<Scalars['Float']>;
  secondPlaceBonusDeliveries?: InputMaybe<Scalars['Int']>;
  thirdPlaceBonusCashPoints?: InputMaybe<Scalars['Float']>;
  thirdPlaceBonusDeliveries?: InputMaybe<Scalars['Int']>;
};

export type LeaderBoardExemption = {
  __typename?: 'LeaderBoardExemption';
  country: CountryCode;
  createdAt: Scalars['String'];
  exemptedAt: Scalars['String'];
  exemptedBy: Scalars['String'];
  expiresAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  reason: LeaderBoardExemptionReason;
  updatedAt: Scalars['String'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export type LeaderBoardExemptionFilter = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<CountryCodeOperator>;
  id?: InputMaybe<IdOperator>;
  userId?: InputMaybe<IdOperator>;
};

export enum LeaderBoardExemptionReason {
  FraudFlag = 'fraud_flag',
  ManualOther = 'manual_other',
  StaffAccount = 'staff_account',
  TestUser = 'test_user'
}

export type Leaderboard = {
  __typename?: 'Leaderboard';
  points?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  reward?: Maybe<Scalars['String']>;
  source_id: Scalars['ID'];
};

export type LoadProductToShopify = {
  combination_string?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  media: Array<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product_id: Scalars['ID'];
  product_origin: ProductOrigin;
  qty: Scalars['Int'];
  sku: Scalars['String'];
  supplier_generic_name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  uuid: Scalars['String'];
};

export type LoadProductToShopifyInput = {
  integration_id?: InputMaybe<Scalars['ID']>;
  products?: InputMaybe<Array<LoadProductToShopify>>;
};

export enum LockStatus {
  Frozen = 'frozen',
  Limited = 'limited',
  Open = 'open'
}

export type LogisticsInfoDto = {
  __typename?: 'LogisticsInfoDto';
  delivery_time?: Maybe<Scalars['String']>;
  ship_to_country?: Maybe<Scalars['String']>;
};

export type MakePaymentInput = {
  amount: Scalars['Float'];
  currency: CurrencyInput;
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  phone: Scalars['String'];
  provider?: InputMaybe<PaystackMobileMoneyProvider>;
  reason_for_payment: ReasonForPayment;
  secret: Scalars['String'];
  wallet_id?: InputMaybe<Scalars['ID']>;
};

export type MakePaymentResponseDto = {
  __typename?: 'MakePaymentResponseDTO';
  error?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  url: Scalars['String'];
};

export type Member = {
  __typename?: 'Member';
  created_at?: Maybe<Scalars['Date']>;
  developer?: Maybe<Developer>;
  developer_id: Scalars['ID'];
  id: Scalars['ID'];
  role: MemberRole;
  team?: Maybe<Team>;
  team_id: Scalars['ID'];
  updated_at?: Maybe<Scalars['Date']>;
};

export enum MemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type MoneyOperator = {
  between?: InputMaybe<MoneyRange>;
  eq?: InputMaybe<Scalars['Money']>;
  gt?: InputMaybe<Scalars['Money']>;
  gte?: InputMaybe<Scalars['Money']>;
  lt?: InputMaybe<Scalars['Money']>;
  lte?: InputMaybe<Scalars['Money']>;
};

export type MoneyRange = {
  end: Scalars['Money'];
  start: Scalars['Money'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accountRegister: Auth;
  activateShop: Scalars['Boolean'];
  addBusinessDocuments?: Maybe<Scalars['Boolean']>;
  addCheckoutCartItem: CheckoutCartMutationResult;
  addComment?: Maybe<Scalars['Boolean']>;
  addCommentsToProduct?: Maybe<Scalars['Boolean']>;
  addCustomerToStorefrontCart?: Maybe<StorefrontCart>;
  addDeliveryToStorefrontCart?: Maybe<StorefrontCart>;
  addDeviceToken?: Maybe<Scalars['Boolean']>;
  addInstantDeliveryItems?: Maybe<Scalars['Boolean']>;
  addItemToStoreFrontCart?: Maybe<StorefrontCart>;
  addPaymentToStorefrontCart?: Maybe<StorefrontCart>;
  addPluginToUser?: Maybe<UserPlugin>;
  addProductConditionsToDiscount?: Maybe<Scalars['Boolean']>;
  addProductToShop?: Maybe<Scalars['Boolean']>;
  addProductToShopCollection?: Maybe<Scalars['Boolean']>;
  addProductsToCollection?: Maybe<Scalars['Boolean']>;
  addProductsToDiscount?: Maybe<Scalars['Boolean']>;
  addProductsToShopCollection?: Maybe<Scalars['Boolean']>;
  addSalesTargetExemption: SalesTargetExemption;
  addScopeToTeamCredential?: Maybe<TeamCredential>;
  addSupplierAgreementTerms?: Maybe<Scalars['Boolean']>;
  addSupplierBusinessDetails?: Maybe<Scalars['Boolean']>;
  addSupplierCategories: Scalars['Boolean'];
  addSupplierDeviceToken?: Maybe<Scalars['Boolean']>;
  addSupplierLocation?: Maybe<SupplierLocation>;
  addSupplierPaymentDetails?: Maybe<Scalars['Boolean']>;
  addTeamLogo?: Maybe<Team>;
  addTeamServiceAgreementTerms?: Maybe<TeamServiceAgreementTermsValue>;
  addToCart: CartOperationResult;
  addUserPaymentDetails?: Maybe<Scalars['Boolean']>;
  addUsersToCoupon?: Maybe<Scalars['Boolean']>;
  adjustStorefrontCartItemQuantity?: Maybe<StorefrontCart>;
  allowResellingOfProduct?: Maybe<Scalars['Boolean']>;
  applyCheckoutCoupon: CheckoutCartMutationResult;
  approvePartnership: Scalars['Boolean'];
  assignOrderToRider?: Maybe<Scalars['Boolean']>;
  authenticateWithToken: SupplierAuthPayload;
  banReseller?: Maybe<Scalars['Boolean']>;
  bobCancelShipment?: Maybe<BobShipment>;
  /** create new orders for accounts */
  bobCreateOrder?: Maybe<BobOrder>;
  bobCreateShipment?: Maybe<BobShipment>;
  bulkCreateProducts?: Maybe<Scalars['Boolean']>;
  bulkMarkSupplierProductInWarehouse?: Maybe<Scalars['Boolean']>;
  bulkPublishOrUnpublishProducts?: Maybe<Scalars['Boolean']>;
  bulkRemoveProducts?: Maybe<Scalars['Boolean']>;
  bulkUnMarkSupplierProductInWarehouse?: Maybe<Scalars['Boolean']>;
  bulkUpdateProductSock?: Maybe<Scalars['Boolean']>;
  bulkVerifyProducts?: Maybe<Scalars['Boolean']>;
  cancelSalesTargetCampaign: SalesTargetCampaign;
  changePassword?: Maybe<Scalars['Boolean']>;
  changeResellerSupplierShop?: Maybe<Scalars['Boolean']>;
  changeResellerUsername?: Maybe<Scalars['Boolean']>;
  changeSupplierEmail?: Maybe<Scalars['Boolean']>;
  changeSupplierPassword?: Maybe<Scalars['Boolean']>;
  changeSupplierStatus?: Maybe<Scalars['Boolean']>;
  changeTeamName?: Maybe<Team>;
  chargeWallet: ChargeWalletResponseDto;
  checkPasswordAvailability?: Maybe<Scalars['Boolean']>;
  claimCoupon?: Maybe<Scalars['Boolean']>;
  claimDiscount?: Maybe<Scalars['Boolean']>;
  clearCart: Scalars['Boolean'];
  clearCheckoutCart: CheckoutCartMutationResult;
  clearStorefrontCart?: Maybe<Scalars['Boolean']>;
  confirmOrderPayment: PlaceOrderResult;
  createAccountSecurity?: Maybe<UserAccountSecurity>;
  createAppBanner?: Maybe<Scalars['Boolean']>;
  createCampaign?: Maybe<Scalars['Boolean']>;
  createCatalog?: Maybe<Scalars['Boolean']>;
  createCollectionConfig?: Maybe<Scalars['Boolean']>;
  createCoupon?: Maybe<Scalars['Boolean']>;
  createCouponForUsers?: Maybe<Scalars['Boolean']>;
  createCustomer?: Maybe<Customer>;
  createCustomerAddress?: Maybe<CustomerAddress>;
  createDeliveryLocation: Scalars['Boolean'];
  createDeliveryZone?: Maybe<Scalars['Boolean']>;
  createDeveloper?: Maybe<DeveloperResponse>;
  createDigitalOrder: Scalars['String'];
  createDigitalOrderReminder?: Maybe<Scalars['Boolean']>;
  createDiscount?: Maybe<Discount>;
  createFeaturedCategory?: Maybe<Scalars['Boolean']>;
  createMonthlyIncomeGoal?: Maybe<Scalars['Boolean']>;
  createNotification?: Maybe<Notification>;
  createOfflineOrder?: Maybe<Scalars['Boolean']>;
  createOrder: Scalars['ID'];
  createPartnership: Scalars['Boolean'];
  createPickUpLocation: Scalars['Boolean'];
  createPlugin?: Maybe<Plugin>;
  createProduct?: Maybe<Scalars['Boolean']>;
  createProductCategory?: Maybe<Scalars['Boolean']>;
  createProductShipment?: Maybe<Scalars['Boolean']>;
  createProductTemplate?: Maybe<Scalars['Boolean']>;
  createPromoBanner?: Maybe<Scalars['Boolean']>;
  createReview: Scalars['Boolean'];
  createRider?: Maybe<Scalars['Boolean']>;
  createSalesTargetCampaign: SalesTargetCampaign;
  createSharedProduct: CreateSharedProductResponseDto;
  createShop: CreateShopResponseDto;
  createShopCollection?: Maybe<Scalars['Boolean']>;
  createStorefrontCart?: Maybe<StorefrontCart>;
  createSupplier?: Maybe<SupplierCreationResponse>;
  createSupplierCustomer?: Maybe<Customer>;
  createTerm: Scalars['Boolean'];
  createTopDeal?: Maybe<Scalars['Boolean']>;
  createTopDealBanner?: Maybe<Scalars['Boolean']>;
  createTrendingProduct?: Maybe<Scalars['Boolean']>;
  createWallet: WalletResponseDto;
  creditUserWalletWithDelayedOrders?: Maybe<Scalars['Boolean']>;
  customerSignIn?: Maybe<CustomerAuthPayload>;
  customerSignUp?: Maybe<CustomerAuthPayload>;
  customerSupplierSignUp?: Maybe<CustomerAuthPayload>;
  deleteAccountSecurity?: Maybe<Scalars['Boolean']>;
  deleteAppBanner?: Maybe<Scalars['Boolean']>;
  deleteCampaign?: Maybe<Scalars['Boolean']>;
  deleteCoupon?: Maybe<Scalars['Boolean']>;
  deleteDeliveryLocation: Scalars['Boolean'];
  deleteDeliveryZone?: Maybe<Scalars['Boolean']>;
  deleteDigitalOrder?: Maybe<Scalars['Boolean']>;
  deleteDiscount?: Maybe<Scalars['Boolean']>;
  deleteFeaturedCategory?: Maybe<Scalars['Boolean']>;
  deletePartnership: Scalars['Boolean'];
  deletePickUpLocation: Scalars['Boolean'];
  deletePlugin?: Maybe<Scalars['Boolean']>;
  deleteProductTemplate?: Maybe<Scalars['Boolean']>;
  deleteReseller?: Maybe<Scalars['Boolean']>;
  deleteTerm: Scalars['Boolean'];
  deleteTopDeal?: Maybe<Scalars['Boolean']>;
  deleteTrendingProduct?: Maybe<Scalars['Boolean']>;
  developerLogin?: Maybe<DeveloperResponse>;
  disableSupplier?: Maybe<Scalars['Boolean']>;
  dispatchTestNotification?: Maybe<Scalars['Boolean']>;
  editProductStat?: Maybe<Scalars['Boolean']>;
  enableSupplier?: Maybe<Scalars['Boolean']>;
  endLeaderBoardSession?: Maybe<Scalars['Boolean']>;
  exemptUserFromLeaderboard: LeaderBoardExemption;
  exportProducts: Scalars['String'];
  forgotPassword?: Maybe<Scalars['String']>;
  freezeWallet?: Maybe<WalletResponseDto>;
  generateAccessToken?: Maybe<Scalars['Boolean']>;
  getOrderOtp?: Maybe<Scalars['Boolean']>;
  initiateCardSetup?: Maybe<Scalars['String']>;
  inviteResellerBySupplier?: Maybe<Scalars['Boolean']>;
  joinSupplierResellerNetwork?: Maybe<Scalars['Boolean']>;
  loadProductsToShopify?: Maybe<Scalars['Boolean']>;
  lockNetInflowSnapshot: Array<DailyNetInflowSnapshot>;
  makeExternalPayment?: Maybe<Scalars['String']>;
  makePayment?: Maybe<Scalars['String']>;
  makeRequestForProduct?: Maybe<Scalars['Boolean']>;
  makeWalletWithdrawal: ChargeWalletResponseDto;
  markAllNotificationsAsRead?: Maybe<Scalars['Boolean']>;
  markCouponAsExpired: Scalars['Boolean'];
  markNotificationAsRead?: Maybe<Notification>;
  markSalesTargetRewardFulfilled: SalesTargetCampaign;
  markSupplierProductInWarehouse?: Maybe<Scalars['Boolean']>;
  onPurchaseSharedProduct?: Maybe<OnPurchaseSharedProductResponseDto>;
  opsAttendToProduct?: Maybe<Scalars['Boolean']>;
  placeOrder: PlaceOrderResult;
  processManualProfitPayout?: Maybe<Scalars['Boolean']>;
  processOrder?: Maybe<Scalars['Boolean']>;
  processProfitPayout?: Maybe<Scalars['Boolean']>;
  publishOrUnpublishProduct?: Maybe<Scalars['Boolean']>;
  refundOrderPurchaseTransaction: OrderPurchaseRefundResult;
  refundResellerSecurityDeposit?: Maybe<Scalars['Boolean']>;
  refundResellerSecurityDepositBulk?: Maybe<Scalars['Boolean']>;
  regenerateNetInflowSnapshot: Array<DailyNetInflowSnapshot>;
  regenerateTeamCredential?: Maybe<TeamCredential>;
  rejectPartnership: Scalars['Boolean'];
  releaseAccount?: Maybe<Scalars['Boolean']>;
  releaseUserAccount?: Maybe<Scalars['Boolean']>;
  removeCatalog?: Maybe<Scalars['Boolean']>;
  removeCategory?: Maybe<Scalars['Boolean']>;
  removeCheckoutCartItem: CheckoutCartMutationResult;
  removeCheckoutCoupon: CheckoutCartMutationResult;
  removeCollectionConfig?: Maybe<Scalars['Boolean']>;
  removeCustomer?: Maybe<Scalars['Boolean']>;
  removeCustomerAddress?: Maybe<Scalars['Boolean']>;
  removeFailedItems?: Maybe<Scalars['Boolean']>;
  removeFromCart: AppCart;
  removeInstantDeliveryItems?: Maybe<Scalars['Boolean']>;
  removeItemFromStorefrontCart?: Maybe<StorefrontCart>;
  removeLeaderboardExemption: Scalars['Boolean'];
  removePluginFromUser?: Maybe<Scalars['Boolean']>;
  removeProduct?: Maybe<Scalars['Boolean']>;
  removeProductCategory?: Maybe<Scalars['Boolean']>;
  removeProductCombination?: Maybe<Scalars['Boolean']>;
  removeProductConditionsFromDiscount?: Maybe<Scalars['Boolean']>;
  removeProductFromCollection?: Maybe<Scalars['Boolean']>;
  removeProductFromShop?: Maybe<Scalars['Boolean']>;
  removeProductImage?: Maybe<Scalars['Boolean']>;
  removePromoBanner?: Maybe<Scalars['Boolean']>;
  removeResellerBySupplier?: Maybe<Scalars['Boolean']>;
  removeReview?: Maybe<Scalars['Boolean']>;
  removeRider?: Maybe<Scalars['Boolean']>;
  removeSalesTargetExemption: Scalars['Boolean'];
  removeShopCollection?: Maybe<Scalars['Boolean']>;
  removeShopifyShop?: Maybe<Scalars['Boolean']>;
  removeSupplier?: Maybe<Scalars['Boolean']>;
  removeTopDealsBanners?: Maybe<Scalars['Boolean']>;
  removeUser?: Maybe<Scalars['Boolean']>;
  removeVariation?: Maybe<Scalars['Boolean']>;
  reportOrderIssueByRider?: Maybe<Scalars['Boolean']>;
  requestChangeEmail?: Maybe<Scalars['Boolean']>;
  requestChangePhone?: Maybe<Scalars['Boolean']>;
  requestChangeSupplierPhone?: Maybe<Scalars['Boolean']>;
  requestEmailVerification?: Maybe<Scalars['String']>;
  requestOTP: RequestOtpResponse;
  requestPhoneVerification?: Maybe<PhoneVerificationOutPut>;
  requestRiderOTP: RequestOtpResponse;
  requestSupplierEmailVerification: Scalars['String'];
  requestSupplierOTP?: Maybe<RequestSupplierOtpResponse>;
  requestSupplierPartnershipOnProducts?: Maybe<Scalars['Boolean']>;
  requestSupplierPhoneVerification: RequestSupplierPhoneVerificationResponse;
  resetPassword?: Maybe<Scalars['Boolean']>;
  resetSupplierPassword?: Maybe<Scalars['Boolean']>;
  resetUserAccount?: Maybe<Scalars['Boolean']>;
  retryProcessingItems?: Maybe<Scalars['Boolean']>;
  reverseTransaction?: Maybe<Transaction>;
  reviewFailedOrderCharge: FailedOrderCharge;
  reviewOrder: Scalars['Boolean'];
  sendMarketingPushNotification?: Maybe<Scalars['Boolean']>;
  sendSupplierResetPasswordMail?: Maybe<Scalars['Boolean']>;
  setCheckoutCartAddress: CheckoutCartMutationResult;
  setCheckoutCartCustomer: CheckoutCartMutationResult;
  setCheckoutCartDelivery: CheckoutCartMutationResult;
  setCheckoutCartDeliveryType: CheckoutCartMutationResult;
  setCheckoutCartPaymentMethod: CheckoutCartMutationResult;
  setSupplierPickupLocation?: Maybe<Scalars['Boolean']>;
  setSupplierProductMarkup?: Maybe<Scalars['Boolean']>;
  setupAccount: RequestOtpResponse;
  setupCard?: Maybe<Scalars['String']>;
  socialMediaLogin?: Maybe<Auth>;
  stripeAccountSession?: Maybe<Scalars['String']>;
  stripeExternalBankAccount?: Maybe<Scalars['Boolean']>;
  submitChargeOTP?: Maybe<PaystackSuccess>;
  supplierResellerLogin?: Maybe<Auth>;
  supplierSignIn: SupplierAuthPayload;
  suspendReseller?: Maybe<Scalars['Boolean']>;
  syncShopifyProducts?: Maybe<Scalars['Boolean']>;
  toggleCategoryState: Scalars['Boolean'];
  toggleFreeDelivery: Scalars['Boolean'];
  unMarkSupplierProductInWarehouse?: Maybe<Scalars['Boolean']>;
  unlockNetInflowSnapshot: Array<DailyNetInflowSnapshot>;
  unlockWallet?: Maybe<WalletResponseDto>;
  unshareProduct: Scalars['Boolean'];
  updateAccountSecurity?: Maybe<UserAccountSecurity>;
  updateAppBanner?: Maybe<Scalars['Boolean']>;
  updateCampaign?: Maybe<Campaign>;
  updateCartItem: AppCart;
  updateCatalog?: Maybe<Scalars['Boolean']>;
  updateCheckoutCartItem: CheckoutCartMutationResult;
  updateCollectionConfig?: Maybe<Scalars['Boolean']>;
  updateCoupon?: Maybe<Scalars['Boolean']>;
  updateCustomer?: Maybe<Scalars['Boolean']>;
  updateCustomerAddressOnOrder?: Maybe<Scalars['Boolean']>;
  updateDeliveryLocation: Scalars['Boolean'];
  updateDeliveryZone?: Maybe<Scalars['Boolean']>;
  updateDigitalOrder?: Maybe<Scalars['Boolean']>;
  updateDiscount?: Maybe<Discount>;
  updateForexRate?: Maybe<Scalars['Boolean']>;
  updateOpsConfig: Scalars['Boolean'];
  updateOrderDetailsOps?: Maybe<Scalars['Boolean']>;
  updateOrderSKU?: Maybe<Scalars['Boolean']>;
  updateOrderStatusByRider?: Maybe<Scalars['Boolean']>;
  updatePartnership: Scalars['Boolean'];
  updatePickUpLocation: Scalars['Boolean'];
  updatePlugin?: Maybe<Scalars['Boolean']>;
  updateProduct?: Maybe<Scalars['Boolean']>;
  updateProductCategories?: Maybe<Scalars['Boolean']>;
  updateProductCategory?: Maybe<Scalars['Boolean']>;
  updateProductCategoryAndTags?: Maybe<Scalars['Boolean']>;
  updateProductCombination?: Maybe<Scalars['Boolean']>;
  updateProductDistribution?: Maybe<Scalars['Boolean']>;
  updateProductInformation?: Maybe<Scalars['Boolean']>;
  updateProductInstantDeliveryState?: Maybe<Scalars['Boolean']>;
  updateProductInventory?: Maybe<Scalars['Boolean']>;
  updateProductLikeState?: Maybe<Scalars['Boolean']>;
  updateProductMedia?: Maybe<Scalars['Boolean']>;
  updateProductSaveState?: Maybe<Scalars['Boolean']>;
  updateProductShipment?: Maybe<Scalars['Boolean']>;
  updateProductStatus?: Maybe<Scalars['Boolean']>;
  updateProductStock?: Maybe<Scalars['Boolean']>;
  updateProductTemplate?: Maybe<Scalars['Boolean']>;
  updateProductVariation?: Maybe<Scalars['Boolean']>;
  updatePromoBanner?: Maybe<Scalars['Boolean']>;
  updateRider?: Maybe<Scalars['Boolean']>;
  updateSalesTargetCampaign: SalesTargetCampaign;
  updateShopCollection?: Maybe<Scalars['Boolean']>;
  updateShopDetails: UpdateShopDetailsResponseDto;
  updateStorefrontCartStatus?: Maybe<Scalars['Boolean']>;
  updateSupplier: Scalars['Boolean'];
  updateSupplierAgreementTerms?: Maybe<Scalars['Boolean']>;
  updateSupplierBusinessContact?: Maybe<Scalars['Boolean']>;
  updateSupplierBusinessDetails?: Maybe<Scalars['Boolean']>;
  updateSupplierDetails?: Maybe<Scalars['Boolean']>;
  updateSupplierGenericName?: Maybe<Scalars['Boolean']>;
  updateSupplierPayment?: Maybe<SupplierPaymentDetails>;
  updateSupplierProfile?: Maybe<Scalars['Boolean']>;
  updateSupplierShopDetails: UpdateShopDetailsResponseDto;
  updateSupplierShopSlug?: Maybe<Shop>;
  updateSupplierType?: Maybe<Scalars['Boolean']>;
  updateTerm: Scalars['Boolean'];
  updateUserDetails?: Maybe<Scalars['Boolean']>;
  updateVariation?: Maybe<Scalars['Boolean']>;
  updaterResellerShopSlug?: Maybe<Shop>;
  userLogin?: Maybe<Auth>;
  verifyAccountSecurity?: Maybe<User>;
  verifyAliExpressProduct?: Maybe<Scalars['Boolean']>;
  verifyEmail?: Maybe<Scalars['Boolean']>;
  verifyOTP?: Maybe<Scalars['Boolean']>;
  verifyOrderOtp?: Maybe<Scalars['Boolean']>;
  verifyProduct?: Maybe<Scalars['Boolean']>;
  verifyRiderOTP: RiderAuth;
  verifySupplierAccount?: Maybe<Scalars['Boolean']>;
  verifySupplierBusiness?: Maybe<Scalars['Boolean']>;
  verifySupplierOTP?: Maybe<Scalars['Boolean']>;
  walletPayoutDecision?: Maybe<WalletPayoutResponseDto>;
};


export type MutationAccountRegisterArgs = {
  input?: InputMaybe<AccountRegisterInput>;
};


export type MutationActivateShopArgs = {
  data: ActivateShopRequestDto;
};


export type MutationAddBusinessDocumentsArgs = {
  input?: InputMaybe<AddBusinessDocumentInput>;
};


export type MutationAddCheckoutCartItemArgs = {
  input: AddCheckoutCartItemInput;
};


export type MutationAddCommentArgs = {
  input?: InputMaybe<AddCommentInput>;
};


export type MutationAddCommentsToProductArgs = {
  input?: InputMaybe<AddCommentsToProductInput>;
};


export type MutationAddCustomerToStorefrontCartArgs = {
  input: AddCustomerToStorefrontCartInput;
};


export type MutationAddDeliveryToStorefrontCartArgs = {
  input: AddDeliveryToStorefrontCartInput;
};


export type MutationAddDeviceTokenArgs = {
  device: Scalars['String'];
  token: Scalars['String'];
  user_id: Scalars['ID'];
};


export type MutationAddInstantDeliveryItemsArgs = {
  skus: Array<Scalars['String']>;
};


export type MutationAddItemToStoreFrontCartArgs = {
  input: AddItemToStorefrontCartInput;
};


export type MutationAddPaymentToStorefrontCartArgs = {
  input: AddPaymentToStorefrontCartInput;
};


export type MutationAddPluginToUserArgs = {
  data: AddPluginToUserRequestDto;
};


export type MutationAddProductConditionsToDiscountArgs = {
  input: Array<AddProductConditionToDiscountRequestDto>;
};


export type MutationAddProductToShopArgs = {
  product_id: Scalars['ID'];
  profit_added: Scalars['Float'];
  shop_id: Scalars['ID'];
};


export type MutationAddProductToShopCollectionArgs = {
  collection_id: Scalars['ID'];
  product_id: Scalars['ID'];
};


export type MutationAddProductsToCollectionArgs = {
  input?: InputMaybe<AddProductsToCollectionInput>;
};


export type MutationAddProductsToDiscountArgs = {
  discountId: Scalars['ID'];
  productSKUs: Array<Scalars['String']>;
};


export type MutationAddProductsToShopCollectionArgs = {
  collection_id: Scalars['ID'];
  product_ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationAddSalesTargetExemptionArgs = {
  input: AddSalesTargetExemptionInput;
};


export type MutationAddScopeToTeamCredentialArgs = {
  input: AddScopeToTeamCredentialInput;
};


export type MutationAddSupplierAgreementTermsArgs = {
  input?: InputMaybe<AddSupplierAgreementTermsInput>;
};


export type MutationAddSupplierBusinessDetailsArgs = {
  input?: InputMaybe<SupplierBusinessInput>;
};


export type MutationAddSupplierCategoriesArgs = {
  categories: Array<Scalars['ID']>;
  supplier_id: Scalars['ID'];
};


export type MutationAddSupplierDeviceTokenArgs = {
  input?: InputMaybe<SupplierAddDeviceTokenInput>;
};


export type MutationAddSupplierLocationArgs = {
  input?: InputMaybe<AddSupplierLocationInput>;
};


export type MutationAddSupplierPaymentDetailsArgs = {
  input?: InputMaybe<AddSupplierPaymentInput>;
};


export type MutationAddTeamLogoArgs = {
  input: AddTeamLogoInput;
};


export type MutationAddTeamServiceAgreementTermsArgs = {
  input: AddTeamServiceAgreementTermsInput;
};


export type MutationAddToCartArgs = {
  input: AddToCartInput;
};


export type MutationAddUserPaymentDetailsArgs = {
  input?: InputMaybe<UserPaymentInput>;
};


export type MutationAddUsersToCouponArgs = {
  input: UsersCouponInput;
};


export type MutationAdjustStorefrontCartItemQuantityArgs = {
  input: AdjustStorefrontCartItemQuantityInput;
};


export type MutationAllowResellingOfProductArgs = {
  id: Scalars['ID'];
};


export type MutationApplyCheckoutCouponArgs = {
  code: Scalars['String'];
};


export type MutationApprovePartnershipArgs = {
  id: Scalars['ID'];
  term_id: Scalars['ID'];
};


export type MutationAssignOrderToRiderArgs = {
  orderId: Scalars['ID'];
  priority: Scalars['Int'];
  riderId: Scalars['ID'];
};


export type MutationAuthenticateWithTokenArgs = {
  input?: InputMaybe<AuthenticateWithTokenInput>;
};


export type MutationBanResellerArgs = {
  input?: InputMaybe<BanResellerInput>;
};


export type MutationBobCancelShipmentArgs = {
  data: BobCancelShipmentRequestDto;
};


export type MutationBobCreateOrderArgs = {
  data: BobCreateOrderRequestDto;
};


export type MutationBobCreateShipmentArgs = {
  data: BobCreateShipmentRequestDto;
};


export type MutationBulkCreateProductsArgs = {
  products?: InputMaybe<Array<InputMaybe<TempCreateProductInput>>>;
};


export type MutationBulkMarkSupplierProductInWarehouseArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationBulkPublishOrUnpublishProductsArgs = {
  ids: Array<Scalars['ID']>;
  personnel: Scalars['String'];
  published: Scalars['Boolean'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationBulkRemoveProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationBulkUnMarkSupplierProductInWarehouseArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationBulkUpdateProductSockArgs = {
  input?: InputMaybe<Array<BulkProductStockInput>>;
};


export type MutationBulkVerifyProductsArgs = {
  input: Array<VerifyProductInput>;
};


export type MutationCancelSalesTargetCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordInput>;
};


export type MutationChangeResellerSupplierShopArgs = {
  reseller_id: Scalars['ID'];
  supplier_shop_id: Scalars['ID'];
};


export type MutationChangeResellerUsernameArgs = {
  input?: InputMaybe<ChangeResellerUsernameInput>;
};


export type MutationChangeSupplierEmailArgs = {
  input?: InputMaybe<SupplierEmailChangeInput>;
};


export type MutationChangeSupplierPasswordArgs = {
  input?: InputMaybe<SupplierPasswordChangeInput>;
};


export type MutationChangeSupplierStatusArgs = {
  id: Scalars['ID'];
  supplier_status?: InputMaybe<Scalars['String']>;
};


export type MutationChangeTeamNameArgs = {
  input: ChangeTeamNameInput;
};


export type MutationChargeWalletArgs = {
  input: ChargeWalletInput;
};


export type MutationCheckPasswordAvailabilityArgs = {
  input?: InputMaybe<CheckPasswordAvailabilityInput>;
};


export type MutationClaimCouponArgs = {
  input: ClaimCouponInput;
};


export type MutationClaimDiscountArgs = {
  input: ClaimDiscountRequestDto;
};


export type MutationClearCartArgs = {
  user_id: Scalars['ID'];
};


export type MutationClearStorefrontCartArgs = {
  input: ClearStorefrontCartInput;
};


export type MutationConfirmOrderPaymentArgs = {
  idempotencyKey: Scalars['ID'];
  reference: Scalars['String'];
};


export type MutationCreateAccountSecurityArgs = {
  input: CreateUserAccountSecurityInput;
};


export type MutationCreateAppBannerArgs = {
  input: AppBannerInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCatalogArgs = {
  input?: InputMaybe<CatalogInput>;
};


export type MutationCreateCollectionConfigArgs = {
  input?: InputMaybe<CatalogConfigInput>;
};


export type MutationCreateCouponArgs = {
  input: CouponInput;
};


export type MutationCreateCouponForUsersArgs = {
  input: UsersCouponInput;
};


export type MutationCreateCustomerArgs = {
  input?: InputMaybe<CustomerInput>;
};


export type MutationCreateCustomerAddressArgs = {
  customer_id: Scalars['ID'];
  input?: InputMaybe<AddressInput>;
};


export type MutationCreateDeliveryLocationArgs = {
  input: DeliveryInput;
};


export type MutationCreateDeliveryZoneArgs = {
  input?: InputMaybe<DeliveryZonesInput>;
};


export type MutationCreateDeveloperArgs = {
  input: CreateDeveloperInput;
};


export type MutationCreateDigitalOrderArgs = {
  input: DigitalOrderInput;
};


export type MutationCreateDigitalOrderReminderArgs = {
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
};


export type MutationCreateDiscountArgs = {
  input: CreateDiscountRequestDto;
};


export type MutationCreateFeaturedCategoryArgs = {
  banners?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['ID'];
  color: Scalars['String'];
};


export type MutationCreateMonthlyIncomeGoalArgs = {
  goal: GoalCategory;
  incomeCategory: IncomeCategory;
  user_id: Scalars['ID'];
};


export type MutationCreateNotificationArgs = {
  body?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationCreateOfflineOrderArgs = {
  input?: InputMaybe<Array<InputMaybe<OfflineOrdersInput>>>;
};


export type MutationCreateOrderArgs = {
  input?: InputMaybe<OrderCreateInput>;
};


export type MutationCreatePartnershipArgs = {
  client: Scalars['ID'];
  contractor: Scalars['ID'];
  name: Scalars['String'];
  skus: Array<Scalars['String']>;
};


export type MutationCreatePickUpLocationArgs = {
  input: PickUpInput;
};


export type MutationCreatePluginArgs = {
  data: CreatePluginRequestDto;
};


export type MutationCreateProductArgs = {
  input?: InputMaybe<CreateProductInput>;
};


export type MutationCreateProductCategoryArgs = {
  input?: InputMaybe<ProductCategoryInput>;
};


export type MutationCreateProductShipmentArgs = {
  input?: InputMaybe<ProductShipmentInput>;
};


export type MutationCreateProductTemplateArgs = {
  body?: InputMaybe<Array<TemplateInput>>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type MutationCreatePromoBannerArgs = {
  input?: InputMaybe<PromoBannerInput>;
};


export type MutationCreateReviewArgs = {
  input: ReviewInput;
};


export type MutationCreateRiderArgs = {
  input: RiderInput;
};


export type MutationCreateSalesTargetCampaignArgs = {
  input: CreateSalesTargetCampaignInput;
};


export type MutationCreateSharedProductArgs = {
  input: CreateSharedProductRequestDto;
};


export type MutationCreateShopArgs = {
  data: CreateShopRequestDto;
};


export type MutationCreateShopCollectionArgs = {
  input?: InputMaybe<ShopCollectionInput>;
};


export type MutationCreateStorefrontCartArgs = {
  input: CreateStorefrontCartInput;
};


export type MutationCreateSupplierArgs = {
  input?: InputMaybe<SupplierInput>;
};


export type MutationCreateSupplierCustomerArgs = {
  input?: InputMaybe<CustomerInput>;
  supplier_id: Scalars['ID'];
};


export type MutationCreateTermArgs = {
  input: TermInput;
};


export type MutationCreateTopDealArgs = {
  productId: Scalars['ID'];
};


export type MutationCreateTopDealBannerArgs = {
  input: CreateTopDealBannerInput;
};


export type MutationCreateTrendingProductArgs = {
  productId: Scalars['ID'];
};


export type MutationCreateWalletArgs = {
  input: CreateWalletInput;
};


export type MutationCreditUserWalletWithDelayedOrdersArgs = {
  orders: Array<InputMaybe<Scalars['ID']>>;
  paid_security_deposit?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCustomerSignInArgs = {
  input?: InputMaybe<CustomerLoginInput>;
};


export type MutationCustomerSignUpArgs = {
  input?: InputMaybe<CustomerInput>;
  user_id: Scalars['ID'];
};


export type MutationCustomerSupplierSignUpArgs = {
  input?: InputMaybe<CustomerInput>;
  supplier_id: Scalars['ID'];
};


export type MutationDeleteAccountSecurityArgs = {
  input: DeleteUserAccountSecurityInput;
};


export type MutationDeleteAppBannerArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCampaignArgs = {
  filter?: InputMaybe<CampaignFilter>;
};


export type MutationDeleteCouponArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDeliveryLocationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDeliveryZoneArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDigitalOrderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDiscountArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFeaturedCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePartnershipArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePickUpLocationArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePluginArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProductTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteResellerArgs = {
  input?: InputMaybe<DeleteResellerInput>;
};


export type MutationDeleteTermArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTopDealArgs = {
  productId: Scalars['ID'];
};


export type MutationDeleteTrendingProductArgs = {
  productId: Scalars['ID'];
};


export type MutationDeveloperLoginArgs = {
  input: DeveloperLoginInput;
};


export type MutationDisableSupplierArgs = {
  id: Scalars['ID'];
  notes: Scalars['String'];
};


export type MutationDispatchTestNotificationArgs = {
  message: Scalars['String'];
  pushToken?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
};


export type MutationEditProductStatArgs = {
  input: EditProductStatInput;
};


export type MutationEnableSupplierArgs = {
  enableProducts?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationEndLeaderBoardSessionArgs = {
  id: Scalars['ID'];
};


export type MutationExemptUserFromLeaderboardArgs = {
  country: CountryCode;
  expiresAt?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  reason: LeaderBoardExemptionReason;
  userId: Scalars['ID'];
};


export type MutationExportProductsArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
};


export type MutationForgotPasswordArgs = {
  input?: InputMaybe<ForgotPasswordInput>;
};


export type MutationFreezeWalletArgs = {
  wallet_id: Scalars['ID'];
};


export type MutationGenerateAccessTokenArgs = {
  code: Scalars['String'];
};


export type MutationGetOrderOtpArgs = {
  customer_id: Scalars['ID'];
  order_id: Scalars['ID'];
};


export type MutationInitiateCardSetupArgs = {
  input?: InputMaybe<InitiateCardSetupInput>;
};


export type MutationInviteResellerBySupplierArgs = {
  email: Scalars['String'];
  supplier_id: Scalars['ID'];
  terms_id: Scalars['ID'];
};


export type MutationJoinSupplierResellerNetworkArgs = {
  reseller_id: Scalars['ID'];
  supplier_id: Scalars['ID'];
  terms_id: Scalars['ID'];
};


export type MutationLoadProductsToShopifyArgs = {
  input?: InputMaybe<LoadProductToShopifyInput>;
};


export type MutationLockNetInflowSnapshotArgs = {
  currency?: InputMaybe<Scalars['String']>;
  snapshotDate: Scalars['String'];
};


export type MutationMakeExternalPaymentArgs = {
  input: MakePaymentInput;
};


export type MutationMakePaymentArgs = {
  input: MakePaymentInput;
};


export type MutationMakeRequestForProductArgs = {
  input?: InputMaybe<MakeRequestForProduct>;
};


export type MutationMakeWalletWithdrawalArgs = {
  input: WalletWithdrawalInput;
};


export type MutationMarkCouponAsExpiredArgs = {
  id: Scalars['ID'];
};


export type MutationMarkNotificationAsReadArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationMarkSalesTargetRewardFulfilledArgs = {
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
};


export type MutationMarkSupplierProductInWarehouseArgs = {
  id: Scalars['ID'];
};


export type MutationOnPurchaseSharedProductArgs = {
  input?: InputMaybe<OnPurchaseSharedProductRequestDto>;
};


export type MutationOpsAttendToProductArgs = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  media?: InputMaybe<Array<Scalars['String']>>;
  personnel?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationPlaceOrderArgs = {
  input: PlaceOrderInput;
};


export type MutationProcessManualProfitPayoutArgs = {
  cart_number: Scalars['String'];
};


export type MutationProcessOrderArgs = {
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type MutationProcessProfitPayoutArgs = {
  orderId: Scalars['ID'];
};


export type MutationPublishOrUnpublishProductArgs = {
  id: Scalars['ID'];
  personnel: Scalars['String'];
  published: Scalars['Boolean'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationRefundOrderPurchaseTransactionArgs = {
  notes?: InputMaybe<Scalars['String']>;
  reference: Scalars['String'];
};


export type MutationRefundResellerSecurityDepositArgs = {
  paid?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
};


export type MutationRefundResellerSecurityDepositBulkArgs = {
  paid?: InputMaybe<Scalars['Boolean']>;
  references: Array<InputMaybe<Scalars['String']>>;
};


export type MutationRegenerateNetInflowSnapshotArgs = {
  snapshotDate: Scalars['String'];
};


export type MutationRegenerateTeamCredentialArgs = {
  input: CreateTeamCredentialInput;
};


export type MutationRejectPartnershipArgs = {
  id: Scalars['ID'];
};


export type MutationReleaseAccountArgs = {
  userId: Scalars['ID'];
};


export type MutationRemoveCatalogArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCheckoutCartItemArgs = {
  itemId: Scalars['ID'];
};


export type MutationRemoveCollectionConfigArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCustomerArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCustomerAddressArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveFailedItemsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationRemoveFromCartArgs = {
  cart_item_id: Scalars['ID'];
  user_id: Scalars['ID'];
};


export type MutationRemoveInstantDeliveryItemsArgs = {
  skus: Array<Scalars['String']>;
};


export type MutationRemoveItemFromStorefrontCartArgs = {
  input?: InputMaybe<RemoveItemFromStorefrontCartInput>;
};


export type MutationRemoveLeaderboardExemptionArgs = {
  id: Scalars['ID'];
};


export type MutationRemovePluginFromUserArgs = {
  filter: UserPluginFilter;
};


export type MutationRemoveProductArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveProductCategoryArgs = {
  category_id: Scalars['ID'];
  product_id: Scalars['ID'];
};


export type MutationRemoveProductCombinationArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveProductConditionsFromDiscountArgs = {
  productConditionIds: Array<Scalars['ID']>;
};


export type MutationRemoveProductFromCollectionArgs = {
  input?: InputMaybe<AddProductsToCollectionInput>;
};


export type MutationRemoveProductFromShopArgs = {
  product_id: Scalars['ID'];
  shop_id: Scalars['ID'];
};


export type MutationRemoveProductImageArgs = {
  id: Scalars['ID'];
};


export type MutationRemovePromoBannerArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveResellerBySupplierArgs = {
  reseller_id: Scalars['ID'];
  supplier_id: Scalars['ID'];
};


export type MutationRemoveReviewArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveRiderArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveSalesTargetExemptionArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveShopCollectionArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveShopifyShopArgs = {
  supplier_id: Scalars['ID'];
};


export type MutationRemoveSupplierArgs = {
  filter?: InputMaybe<SupplierFilter>;
};


export type MutationRemoveTopDealsBannersArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveVariationArgs = {
  id: Scalars['ID'];
};


export type MutationReportOrderIssueByRiderArgs = {
  input: RiderIssueReportInput;
};


export type MutationRequestChangeEmailArgs = {
  input?: InputMaybe<RequestChangeEmailInput>;
};


export type MutationRequestChangePhoneArgs = {
  input?: InputMaybe<RequestChangePhoneInput>;
};


export type MutationRequestChangeSupplierPhoneArgs = {
  input?: InputMaybe<RequestChangeSupplierPhoneInput>;
};


export type MutationRequestEmailVerificationArgs = {
  input?: InputMaybe<RequestEmailVerificationInput>;
};


export type MutationRequestOtpArgs = {
  input?: InputMaybe<RequestOtpInput>;
};


export type MutationRequestPhoneVerificationArgs = {
  input?: InputMaybe<CheckPasswordAvailabilityInput>;
};


export type MutationRequestRiderOtpArgs = {
  input?: InputMaybe<RequestRiderOtpInput>;
};


export type MutationRequestSupplierEmailVerificationArgs = {
  input?: InputMaybe<RequestEmailVerificationInput>;
};


export type MutationRequestSupplierOtpArgs = {
  input?: InputMaybe<RequestOtpInput>;
};


export type MutationRequestSupplierPartnershipOnProductsArgs = {
  product_skus: Array<Scalars['String']>;
  supplier_id: Scalars['ID'];
};


export type MutationRequestSupplierPhoneVerificationArgs = {
  input?: InputMaybe<RequestSupplierPhoneVerificationInput>;
};


export type MutationResetPasswordArgs = {
  input?: InputMaybe<ResetPasswordInput>;
};


export type MutationResetSupplierPasswordArgs = {
  input?: InputMaybe<SupplierPasswordResetInput>;
};


export type MutationResetUserAccountArgs = {
  userId: Scalars['ID'];
};


export type MutationRetryProcessingItemsArgs = {
  country: Scalars['String'];
};


export type MutationReverseTransactionArgs = {
  input: ReverseTransactionInput;
};


export type MutationReviewFailedOrderChargeArgs = {
  action: FailedOrderReviewAction;
  id: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};


export type MutationReviewOrderArgs = {
  orderId: Scalars['ID'];
  rating: Scalars['Int'];
  review?: InputMaybe<Scalars['String']>;
};


export type MutationSendMarketingPushNotificationArgs = {
  message: Scalars['String'];
  title: Scalars['String'];
};


export type MutationSendSupplierResetPasswordMailArgs = {
  input?: InputMaybe<SupplierPasswordResetMailInput>;
};


export type MutationSetCheckoutCartAddressArgs = {
  addressId: Scalars['ID'];
};


export type MutationSetCheckoutCartCustomerArgs = {
  customerId: Scalars['ID'];
};


export type MutationSetCheckoutCartDeliveryArgs = {
  deliveryId: Scalars['ID'];
};


export type MutationSetCheckoutCartDeliveryTypeArgs = {
  deliveryType: CheckoutDeliveryMethod;
};


export type MutationSetCheckoutCartPaymentMethodArgs = {
  method: CheckoutPaymentMethod;
};


export type MutationSetSupplierPickupLocationArgs = {
  input?: InputMaybe<SetSupplierPickupLocationInput>;
};


export type MutationSetSupplierProductMarkupArgs = {
  input?: InputMaybe<SetSupplierProductMarkupInput>;
};


export type MutationSetupAccountArgs = {
  input?: InputMaybe<SetupAccountInput>;
};


export type MutationSocialMediaLoginArgs = {
  nonce?: InputMaybe<Scalars['String']>;
  platform: SocialPlatform;
  token: Scalars['String'];
};


export type MutationStripeAccountSessionArgs = {
  input?: InputMaybe<StripeAccountSessionInput>;
};


export type MutationStripeExternalBankAccountArgs = {
  supplier_id?: InputMaybe<Scalars['ID']>;
};


export type MutationSubmitChargeOtpArgs = {
  input: SubmitChargeOtpInput;
};


export type MutationSupplierResellerLoginArgs = {
  input?: InputMaybe<SupplierUserLoginInput>;
};


export type MutationSupplierSignInArgs = {
  deviceToken?: InputMaybe<Scalars['String']>;
  emailOrPhone: Scalars['String'];
  password: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationSuspendResellerArgs = {
  input?: InputMaybe<SuspendResellerInput>;
};


export type MutationSyncShopifyProductsArgs = {
  input: SyncShopifyProductInput;
};


export type MutationToggleCategoryStateArgs = {
  id: Scalars['ID'];
  state: Scalars['Boolean'];
};


export type MutationToggleFreeDeliveryArgs = {
  id: Scalars['ID'];
};


export type MutationUnMarkSupplierProductInWarehouseArgs = {
  id: Scalars['ID'];
};


export type MutationUnlockNetInflowSnapshotArgs = {
  currency?: InputMaybe<Scalars['String']>;
  snapshotDate: Scalars['String'];
};


export type MutationUnlockWalletArgs = {
  wallet_id: Scalars['ID'];
};


export type MutationUnshareProductArgs = {
  input: UnshareProductRequestDto;
};


export type MutationUpdateAccountSecurityArgs = {
  input: UpdateUserAccountSecurityInput;
};


export type MutationUpdateAppBannerArgs = {
  input: AppBannerInput;
};


export type MutationUpdateCampaignArgs = {
  data: UpdateCampaignInput;
  filter?: InputMaybe<CampaignFilter>;
};


export type MutationUpdateCartItemArgs = {
  input: UpdateCartItemInput;
};


export type MutationUpdateCatalogArgs = {
  input?: InputMaybe<CatalogInput>;
};


export type MutationUpdateCheckoutCartItemArgs = {
  itemId: Scalars['ID'];
  profit?: InputMaybe<Scalars['Float']>;
  profitType?: InputMaybe<ProfitType>;
  qty?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateCollectionConfigArgs = {
  input?: InputMaybe<CatalogConfigInput>;
};


export type MutationUpdateCouponArgs = {
  input: CouponInput;
};


export type MutationUpdateCustomerArgs = {
  input?: InputMaybe<CustomerInput>;
};


export type MutationUpdateCustomerAddressOnOrderArgs = {
  customer_address_id: Scalars['ID'];
  order_id: Scalars['ID'];
};


export type MutationUpdateDeliveryLocationArgs = {
  input: DeliveryInput;
};


export type MutationUpdateDeliveryZoneArgs = {
  input?: InputMaybe<DeliveryZonesInput>;
};


export type MutationUpdateDigitalOrderArgs = {
  id: Scalars['ID'];
  input: DigitalOrderInput;
};


export type MutationUpdateDiscountArgs = {
  data: UpdateDiscountData;
  filter: DiscountFilter;
};


export type MutationUpdateForexRateArgs = {
  input?: InputMaybe<ForexRateInput>;
};


export type MutationUpdateOpsConfigArgs = {
  country?: InputMaybe<Scalars['String']>;
  deliveryLimitForPaymentOnDelivery?: InputMaybe<Scalars['Int']>;
  deliveryPaymentThreshold?: InputMaybe<Scalars['Int']>;
  leaderboardConfig?: InputMaybe<LeaderBoardConfigInput>;
  payableSecurityDeposit?: InputMaybe<Scalars['Int']>;
  paymentCap?: InputMaybe<Scalars['Int']>;
  paymentThreshold?: InputMaybe<Scalars['Int']>;
  pickUpPaymentThreshold?: InputMaybe<Scalars['Int']>;
  supplierDashboardUrl?: InputMaybe<Scalars['String']>;
  whatsAppCommunityLink?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrderDetailsOpsArgs = {
  cart_id: Scalars['ID'];
  delivery_id?: InputMaybe<Scalars['ID']>;
  delivery_price: Scalars['Float'];
  order_id: Scalars['ID'];
  quantity: Scalars['Int'];
};


export type MutationUpdateOrderSkuArgs = {
  id: Scalars['ID'];
  sku: Scalars['ID'];
};


export type MutationUpdateOrderStatusByRiderArgs = {
  notes?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  orderItems: Array<Scalars['ID']>;
  status: Scalars['String'];
};


export type MutationUpdatePartnershipArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  skus?: InputMaybe<Array<Scalars['String']>>;
  supplier_id?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdatePickUpLocationArgs = {
  input: PickUpInput;
};


export type MutationUpdatePluginArgs = {
  data: UpdatePluginRequestDto;
};


export type MutationUpdateProductArgs = {
  input?: InputMaybe<CreateProductInput>;
};


export type MutationUpdateProductCategoriesArgs = {
  input: UpdateProductCategoriesInput;
};


export type MutationUpdateProductCategoryArgs = {
  input?: InputMaybe<ProductCategoryInput>;
};


export type MutationUpdateProductCategoryAndTagsArgs = {
  input?: InputMaybe<ProductCategoryAndTagsInput>;
};


export type MutationUpdateProductCombinationArgs = {
  input?: InputMaybe<ProductCombinationInput>;
};


export type MutationUpdateProductDistributionArgs = {
  input?: InputMaybe<UpdateProductDistributionInput>;
};


export type MutationUpdateProductInformationArgs = {
  input?: InputMaybe<ProductInformationInput>;
};


export type MutationUpdateProductInstantDeliveryStateArgs = {
  id: Scalars['ID'];
  instantDelivery: Scalars['Boolean'];
  personnel: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateProductInventoryArgs = {
  input?: InputMaybe<ProductInventoryInput>;
};


export type MutationUpdateProductLikeStateArgs = {
  input: EditProductStatInput;
};


export type MutationUpdateProductMediaArgs = {
  input?: InputMaybe<ProductMediaInput>;
};


export type MutationUpdateProductSaveStateArgs = {
  input: EditProductStatInput;
};


export type MutationUpdateProductShipmentArgs = {
  input?: InputMaybe<ProductShipmentInput>;
};


export type MutationUpdateProductStatusArgs = {
  input?: InputMaybe<UpdateProductStatusInput>;
};


export type MutationUpdateProductStockArgs = {
  input: ProductStockInput;
};


export type MutationUpdateProductTemplateArgs = {
  body?: InputMaybe<Array<TemplateInput>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateProductVariationArgs = {
  input?: InputMaybe<UpdateVariationInput>;
};


export type MutationUpdatePromoBannerArgs = {
  input?: InputMaybe<PromoBannerInput>;
};


export type MutationUpdateRiderArgs = {
  id: Scalars['ID'];
  input: RiderInput;
};


export type MutationUpdateSalesTargetCampaignArgs = {
  id: Scalars['ID'];
  input: UpdateSalesTargetCampaignInput;
};


export type MutationUpdateShopCollectionArgs = {
  input?: InputMaybe<ShopCollectionInput>;
};


export type MutationUpdateShopDetailsArgs = {
  data: UpdateShopDetailsRequestDto;
  premium_subscription?: InputMaybe<CustomerSubscriptionInput>;
};


export type MutationUpdateStorefrontCartStatusArgs = {
  input: UpdateStorefrontCartStatusInput;
};


export type MutationUpdateSupplierArgs = {
  input?: InputMaybe<SupplierInput>;
};


export type MutationUpdateSupplierAgreementTermsArgs = {
  input?: InputMaybe<AddSupplierAgreementTermsInput>;
};


export type MutationUpdateSupplierBusinessContactArgs = {
  input?: InputMaybe<UpdateSupplierBusinessContactInput>;
};


export type MutationUpdateSupplierBusinessDetailsArgs = {
  input?: InputMaybe<UpdateSupplierBusinessDetailsInput>;
};


export type MutationUpdateSupplierDetailsArgs = {
  input?: InputMaybe<UpdateSupplierDetailsInput>;
};


export type MutationUpdateSupplierGenericNameArgs = {
  input: VerifySupplierBusinessInput;
};


export type MutationUpdateSupplierPaymentArgs = {
  input?: InputMaybe<UpdateSupplierPaymentInput>;
};


export type MutationUpdateSupplierProfileArgs = {
  input?: InputMaybe<SupplierProfileUpdateInput>;
};


export type MutationUpdateSupplierShopDetailsArgs = {
  data: UpdateShopDetailsRequestDto;
};


export type MutationUpdateSupplierShopSlugArgs = {
  data: UpdateSupplierSlugInput;
};


export type MutationUpdateSupplierTypeArgs = {
  id: Scalars['ID'];
  supplier_type: SupplierType;
};


export type MutationUpdateTermArgs = {
  input: TermInput;
};


export type MutationUpdateUserDetailsArgs = {
  input?: InputMaybe<UpdateUserDetailsInput>;
};


export type MutationUpdateVariationArgs = {
  input?: InputMaybe<VariationInput>;
};


export type MutationUpdaterResellerShopSlugArgs = {
  data: UpdateResellerSlugInput;
};


export type MutationUserLoginArgs = {
  input?: InputMaybe<UserLoginInput>;
};


export type MutationVerifyAccountSecurityArgs = {
  input: VerifyUserAccountSecurityInput;
};


export type MutationVerifyAliExpressProductArgs = {
  input: VerifyAliExpressProductInput;
};


export type MutationVerifyEmailArgs = {
  input?: InputMaybe<VerifyEmailInput>;
};


export type MutationVerifyOtpArgs = {
  input?: InputMaybe<VerifyOtpInput>;
};


export type MutationVerifyOrderOtpArgs = {
  customer_id: Scalars['ID'];
  order_id: Scalars['ID'];
  otp: Scalars['String'];
};


export type MutationVerifyProductArgs = {
  input: VerifyProductInput;
};


export type MutationVerifyRiderOtpArgs = {
  input?: InputMaybe<VerifyOtpInput>;
};


export type MutationVerifySupplierAccountArgs = {
  input?: InputMaybe<VerifySupplierAccountInput>;
};


export type MutationVerifySupplierBusinessArgs = {
  input: VerifySupplierBusinessInput;
};


export type MutationVerifySupplierOtpArgs = {
  input?: InputMaybe<VerifySupplierOtpInput>;
};


export type MutationWalletPayoutDecisionArgs = {
  input: WalletPayoutRequestDecision;
};

export type NetInflowDrilldownItem = {
  __typename?: 'NetInflowDrilldownItem';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  metadata?: Maybe<Scalars['JSONObject']>;
  occurredAt: Scalars['DateTime'];
  reference: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type NetInflowDrilldownResult = {
  __typename?: 'NetInflowDrilldownResult';
  count: Scalars['Int'];
  currency: Scalars['String'];
  items: Array<NetInflowDrilldownItem>;
  lineItem: NetInflowLineItem;
  snapshotDate: Scalars['String'];
  total: Scalars['Float'];
};

export enum NetInflowFilter {
  Custom = 'custom',
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export enum NetInflowLineItem {
  DeliveredCod = 'delivered_cod',
  ProfitPayouts = 'profit_payouts',
  WalletDeposits = 'wallet_deposits',
  WalletWithdrawals = 'wallet_withdrawals'
}

export type NetInflowLineItemSummary = {
  __typename?: 'NetInflowLineItemSummary';
  count: Scalars['Int'];
  total: Scalars['Float'];
};

export type NetInflowSnapshotFilterInput = {
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  filter: NetInflowFilter;
  startDate?: InputMaybe<Scalars['String']>;
};

export type NetInflowSnapshotResult = {
  __typename?: 'NetInflowSnapshotResult';
  dailyBreakdown: Array<DailyNetInflowSnapshot>;
  endDate: Scalars['String'];
  filter: NetInflowFilter;
  startDate: Scalars['String'];
  totals: Array<NetInflowSnapshotTotals>;
};

export enum NetInflowSnapshotStatus {
  Locked = 'locked',
  Open = 'open'
}

export type NetInflowSnapshotTotals = {
  __typename?: 'NetInflowSnapshotTotals';
  currency: Scalars['String'];
  deliveredCod: NetInflowLineItemSummary;
  netInflow: Scalars['Float'];
  profitPayouts: NetInflowLineItemSummary;
  totalInflows: Scalars['Float'];
  totalOutflows: Scalars['Float'];
  walletDeposits: NetInflowLineItemSummary;
  walletWithdrawals: NetInflowLineItemSummary;
};

export type Notification = {
  __typename?: 'Notification';
  body?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type?: Maybe<NotificationType>;
};

export type NotificationFilter = {
  id?: InputMaybe<IdOperator>;
  read?: InputMaybe<BooleanOperator>;
  type?: InputMaybe<NotificationType>;
  user_id?: InputMaybe<IdOperator>;
};

export enum NotificationType {
  Newsletter = 'Newsletter',
  System = 'System',
  User = 'User'
}

export type NumberOperator = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

export type NumberRange = {
  end: Scalars['Float'];
  start: Scalars['Float'];
};

export type OfflineOrder = {
  __typename?: 'OfflineOrder';
  area: Scalars['String'];
  batchId: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['Date'];
  customerEmail?: Maybe<Scalars['String']>;
  customerName: Scalars['String'];
  customerPhone: Scalars['String'];
  deliveryAmount: Scalars['Float'];
  deliveryLocation: Scalars['ID'];
  id: Scalars['ID'];
  productSku: Scalars['ID'];
  profit: Scalars['Float'];
  quantity: Scalars['Int'];
  remark: Scalars['String'];
  resellerPhone: Scalars['String'];
  totalAmount: Scalars['Float'];
  updatedAt: Scalars['Date'];
};

/** this schema is for offline sales */
export type OfflineOrdersInput = {
  area: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  customerEmail?: InputMaybe<Scalars['String']>;
  customerName: Scalars['String'];
  customerPhone: Scalars['String'];
  deliveryAmount: Scalars['Float'];
  deliveryLocation: Scalars['ID'];
  productSku: Scalars['ID'];
  profit: Scalars['Float'];
  quantity: Scalars['Int'];
  resellerPhone: Scalars['String'];
  totalAmount: Scalars['Float'];
};

export type OfflineSaleInput = {
  address?: InputMaybe<AddressInput>;
  address_id?: InputMaybe<Scalars['ID']>;
  customer_id?: InputMaybe<Scalars['ID']>;
  delivery_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
  payment_type?: InputMaybe<Scalars['String']>;
  shop_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  supplier_id?: InputMaybe<Scalars['ID']>;
  total_amount?: InputMaybe<Scalars['Float']>;
};

export type OnDiscountUseRequestDto = {
  discount_code: Scalars['String'];
  discount_id: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
};

export type OnPurchaseSharedProductRequestDto = {
  product_id: Scalars['ID'];
  profit_added_by_reseller: Scalars['Int'];
  total_selling_price: Scalars['Int'];
};

export type OnPurchaseSharedProductResponseDto = {
  __typename?: 'OnPurchaseSharedProductResponseDto';
  productId?: Maybe<Scalars['ID']>;
};

export type OpsConfig = {
  __typename?: 'OpsConfig';
  country: Scalars['String'];
  deliveryLimitForPaymentOnDelivery: Scalars['Int'];
  deliveryPaymentThreshold: Scalars['Int'];
  id: Scalars['ID'];
  leaderboardConfig?: Maybe<LeaderBoardConfig>;
  payableSecurityDeposit: Scalars['Int'];
  paymentCap: Scalars['Int'];
  paymentThreshold: Scalars['Int'];
  pickUpPaymentThreshold: Scalars['Int'];
  supplierDashboardUrl?: Maybe<Scalars['String']>;
  whatsAppCommunityLink?: Maybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  address?: Maybe<CustomerAddress>;
  cart_number: Scalars['String'];
  country: Scalars['String'];
  coupon_id?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  customer?: Maybe<Customer>;
  customer_address_id?: Maybe<Scalars['ID']>;
  customer_id: Scalars['ID'];
  customer_paid: Scalars['Boolean'];
  delivery?: Maybe<Delivery>;
  delivery_amount?: Maybe<Scalars['Float']>;
  delivery_id?: Maybe<Scalars['ID']>;
  delivery_instructions?: Maybe<Scalars['String']>;
  delivery_type: Scalars['String'];
  discount?: Maybe<Scalars['Float']>;
  free_delivery?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  instantDelivery?: Maybe<Scalars['Boolean']>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  order_total: Scalars['Float'];
  payment?: Maybe<Transaction>;
  payment_id?: Maybe<Scalars['ID']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_type: Scalars['String'];
  reseller?: Maybe<User>;
  security_deposit?: Maybe<Scalars['Float']>;
  security_deposit_paid?: Maybe<Scalars['Boolean']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  source: Scalars['String'];
  supplier?: Maybe<Supplier>;
  supplier_id?: Maybe<Scalars['ID']>;
  tracking_code?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  user_id: Scalars['ID'];
  user_type: Scalars['String'];
};

export type OrderComment = {
  __typename?: 'OrderComment';
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  staff_name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type OrderCreateInput = {
  address_id?: InputMaybe<Scalars['ID']>;
  couponCode?: InputMaybe<Scalars['String']>;
  coupon_id?: InputMaybe<Scalars['ID']>;
  customer_id: Scalars['ID'];
  customer_paid: Scalars['Boolean'];
  delivery_amount: Scalars['Float'];
  delivery_id?: InputMaybe<Scalars['ID']>;
  delivery_type?: InputMaybe<Scalars['String']>;
  discount: Scalars['Float'];
  estimate_id?: InputMaybe<Scalars['ID']>;
  free_delivery?: InputMaybe<Scalars['Boolean']>;
  hasPreviousOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  instantDelivery?: InputMaybe<Scalars['Boolean']>;
  payment_id?: InputMaybe<Scalars['String']>;
  payment_status?: InputMaybe<Scalars['String']>;
  payment_type?: InputMaybe<Scalars['String']>;
  products: Array<OrderProductInput>;
  reseller: Scalars['ID'];
  security_deposit?: InputMaybe<Scalars['Float']>;
  shipping_cost?: InputMaybe<Scalars['Float']>;
  shop_id?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  supplier_id?: InputMaybe<Scalars['ID']>;
  supplier_status?: InputMaybe<Scalars['String']>;
  total_amount: Scalars['Float'];
};

export type OrderFilter = {
  cart_number?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  customer_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  instantDelivery?: InputMaybe<BooleanOperator>;
  offline?: InputMaybe<BooleanOperator>;
  orderId?: InputMaybe<IdOperator>;
  orderNumber?: InputMaybe<StringOperator>;
  payment_id?: InputMaybe<StringOperator>;
  productId?: InputMaybe<IdOperator>;
  sku?: InputMaybe<IdOperator>;
  source?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  supplier_status?: InputMaybe<StringOperator>;
  tracking_code?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
  user_type?: InputMaybe<StringOperator>;
};

export type OrderGraphData = {
  __typename?: 'OrderGraphData';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type OrderHistory = {
  __typename?: 'OrderHistory';
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  ops_personel?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type OrderInput = {
  cartNumber?: InputMaybe<Scalars['String']>;
  customer_address_id?: InputMaybe<Scalars['ID']>;
  customer_id: Scalars['ID'];
  delivery_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  orderTotal: Scalars['Float'];
  supplier_id?: InputMaybe<Scalars['ID']>;
  user_id: Scalars['ID'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  comments?: Maybe<Array<Maybe<OrderComment>>>;
  createdAt?: Maybe<Scalars['Date']>;
  history?: Maybe<Array<Maybe<OrderHistory>>>;
  id: Scalars['ID'];
  order?: Maybe<Order>;
  orderNumber?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<Product>;
  profitAdded?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  sku: Scalars['ID'];
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  supplier_status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum OrderKind {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Tendo = 'TENDO'
}

export type OrderProductFilter = {
  created_at?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  orderId?: InputMaybe<NumberOperator>;
  orderNumber?: InputMaybe<StringOperator>;
  price?: InputMaybe<NumberOperator>;
  profitAdded?: InputMaybe<NumberOperator>;
  quantity?: InputMaybe<NumberOperator>;
  sku?: InputMaybe<StringOperator>;
  source?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_status?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
};

export type OrderProductInput = {
  cost_price?: InputMaybe<Scalars['Float']>;
  discount?: InputMaybe<Scalars['Float']>;
  price: Scalars['Float'];
  product_id: Scalars['ID'];
  profitAdded: Scalars['Float'];
  qty: Scalars['Int'];
};

export type OrderPurchaseRefundResult = {
  __typename?: 'OrderPurchaseRefundResult';
  failedOrderChargeId: Scalars['ID'];
  message: Scalars['String'];
  refundTransactionId?: Maybe<Scalars['String']>;
  status: FailedOrderChargeStatus;
  success: Scalars['Boolean'];
};

export type OrderReview = {
  __typename?: 'OrderReview';
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order_id: Scalars['ID'];
  rating: Scalars['Float'];
};

export type OrderSort = {
  field?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Sort>;
};

export type OrderStats = {
  __typename?: 'OrderStats';
  ordersAllTime: Scalars['Int'];
  ordersMonth: Scalars['Int'];
  ordersToday: Scalars['Int'];
  ordersWeek: Scalars['Int'];
  ordersYear: Scalars['Int'];
};

export type OrderStatsStats = {
  __typename?: 'OrderStatsStats';
  totalCancelled: Scalars['Int'];
  totalDelivered: Scalars['Int'];
  totalPending: Scalars['Int'];
  totalSuccessful: Scalars['Int'];
};

export enum OrderStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Intransit = 'INTRANSIT',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Returned = 'RETURNED'
}

export type OrderStatusesStats = {
  __typename?: 'OrderStatusesStats';
  totalCancelled: Scalars['Int'];
  totalDelivered: Scalars['Int'];
  totalPending: Scalars['Int'];
  totalSuccessful: Scalars['Int'];
};

export type PackageInfoDto = {
  __typename?: 'PackageInfoDto';
  base_unit?: Maybe<Scalars['String']>;
  gross_weight?: Maybe<Scalars['String']>;
  package_height?: Maybe<Scalars['String']>;
  package_length?: Maybe<Scalars['String']>;
  package_type?: Maybe<Scalars['String']>;
  package_width?: Maybe<Scalars['String']>;
  product_unit?: Maybe<Scalars['String']>;
};

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PaginationResponse = {
  __typename?: 'PaginationResponse';
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type Partnership = {
  __typename?: 'Partnership';
  client_id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  products: Array<Product>;
  skus: Array<Scalars['String']>;
  status: PartnershipStatus;
  supplier_id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type PartnershipFilter = {
  client_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  status?: InputMaybe<PartnershipStatus>;
  supplier_id?: InputMaybe<IdOperator>;
};

export enum PartnershipStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type PastLeaderboardIntervals = {
  __typename?: 'PastLeaderboardIntervals';
  activity_id?: Maybe<Scalars['String']>;
  end_date_time?: Maybe<Scalars['String']>;
  recurrence_type?: Maybe<Scalars['String']>;
  recurrence_type_value?: Maybe<Scalars['Int']>;
  start_date_time?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type PaymentInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  provider: Scalars['String'];
};

export enum PaymentOption {
  Cash = 'Cash',
  Online = 'Online'
}

export enum PaystackAccountType {
  Business = 'business',
  Personal = 'personal'
}

export type PaystackBankChargeInput = {
  account_number: Scalars['String'];
  code: Scalars['String'];
};

export type PaystackBankListResponse = {
  __typename?: 'PaystackBankListResponse';
  data?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackBanksFilter = {
  country?: InputMaybe<Scalars['String']>;
  gateway?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<Scalars['String']>;
  perPage?: InputMaybe<Scalars['Int']>;
  previous?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PaystackGhanaBankType>;
  use_cursor?: InputMaybe<Scalars['Boolean']>;
};

export type PaystackChargeInput = {
  amount: Scalars['Float'];
  currency: CurrencyInput;
  email: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSONObject']>;
  reference: Scalars['String'];
};

export type PaystackChargeSubmitBirthdayInput = {
  birthday: Scalars['DateTime'];
  reference: Scalars['String'];
};

export type PaystackChargeSubmitOtpInput = {
  otp: Scalars['String'];
  reference: Scalars['String'];
};

export type PaystackChargeSubmitPhoneInput = {
  phone: Scalars['String'];
  reference: Scalars['String'];
};

export type PaystackChargeSubmitPinInput = {
  pin: Scalars['String'];
  reference: Scalars['String'];
};

export type PaystackError = {
  __typename?: 'PaystackError';
  data?: Maybe<Scalars['JSONObject']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export enum PaystackGhanaBankType {
  Ghipps = 'ghipps',
  MobileMoney = 'mobile_money'
}

export type PaystackInitializeBankTransferChargeInput = {
  bank: PaystackBankChargeInput;
  charge: PaystackChargeInput;
};

export type PaystackInitializeMobileMoneyChargeInput = {
  charge: PaystackChargeInput;
  mobile_money: PaystackMobileMoneyChargeInput;
};

export type PaystackInitializeTransactionInput = {
  amount: Scalars['Float'];
  authorization_code?: InputMaybe<Scalars['String']>;
  currency: CurrencyInput;
  email: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSONObject']>;
  reference: Scalars['String'];
};

export type PaystackMobileMoneyChargeInput = {
  phone: Scalars['String'];
  provider: PaystackMobileMoneyProvider;
};

export enum PaystackMobileMoneyProvider {
  Atl = 'atl',
  Mtn = 'mtn',
  Vod = 'vod'
}

export type PaystackResolveAccountInput = {
  account_number: Scalars['String'];
  bank_code: Scalars['String'];
};

export type PaystackSuccess = {
  __typename?: 'PaystackSuccess';
  data?: Maybe<Scalars['JSONObject']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type PaystackValidateAccountInput = {
  account_name?: InputMaybe<Scalars['String']>;
  account_number: Scalars['String'];
  account_type?: InputMaybe<Scalars['String']>;
  bank_code: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  /** Customer’s mode of identity. This could be one of: [ identityNumber, passportNumber, businessRegistrationNumber ] */
  document_number?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
};

export type PhoneVerificationOutPut = {
  __typename?: 'PhoneVerificationOutPut';
  code?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type PickUpInput = {
  google_location: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  latitude: Scalars['String'];
  location: Scalars['String'];
  longitude: Scalars['String'];
  remarks?: InputMaybe<Scalars['String']>;
};

export type Pickup = {
  __typename?: 'Pickup';
  country?: Maybe<Scalars['String']>;
  google_location?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
};

export type PlaceOrderFundingInput = {
  gateway?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<CheckoutFundingMethod>;
  returnUrl?: InputMaybe<Scalars['String']>;
};

export type PlaceOrderInput = {
  cartId: Scalars['ID'];
  customerPaid: Scalars['Boolean'];
  expectedTotal: Scalars['Float'];
  funding?: InputMaybe<PlaceOrderFundingInput>;
  idempotencyKey: Scalars['ID'];
};

export type PlaceOrderResult = {
  __typename?: 'PlaceOrderResult';
  cart?: Maybe<CheckoutCart>;
  message?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  paymentIntent?: Maybe<CheckoutPaymentIntent>;
  status: PlaceOrderStatus;
};

export enum PlaceOrderStatus {
  Duplicate = 'DUPLICATE',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  PriceChanged = 'PRICE_CHANGED',
  RequiresPaymentAction = 'REQUIRES_PAYMENT_ACTION',
  StockUnavailable = 'STOCK_UNAVAILABLE',
  Success = 'SUCCESS'
}

export type Plugin = {
  __typename?: 'Plugin';
  banner_image?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  created_at?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  developer?: Maybe<Scalars['String']>;
  endpoint: Scalars['String'];
  id: Scalars['ID'];
  is_installed_by_current_user?: Maybe<Scalars['Boolean']>;
  logo: Scalars['String'];
  name: Scalars['String'];
  updated_at?: Maybe<Scalars['Date']>;
  verified: Scalars['Boolean'];
};

export type PluginFilter = {
  banner_image?: InputMaybe<StringOperator>;
  category?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  description?: InputMaybe<StringOperator>;
  developer?: InputMaybe<StringOperator>;
  endpoint?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  logo?: InputMaybe<StringOperator>;
  name?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type Product = {
  __typename?: 'Product';
  attended_to?: Maybe<Scalars['Boolean']>;
  avatar: Scalars['String'];
  categories?: Maybe<Array<Maybe<ProductCategory>>>;
  combination_string?: Maybe<Scalars['String']>;
  combinations?: Maybe<Array<Maybe<ProductCombination>>>;
  comments?: Maybe<Array<Maybe<ProductComment>>>;
  cost_price: Scalars['Float'];
  country?: Maybe<CountryCode>;
  created_at?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  digitalDetails?: Maybe<Scalars['Any']>;
  discount?: Maybe<Discount>;
  distributionChannels?: Maybe<Array<Maybe<Scalars['String']>>>;
  extra_information?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inhouse?: Maybe<Scalars['Boolean']>;
  instantDelivery?: Maybe<Scalars['Boolean']>;
  likesCount?: Maybe<Scalars['Float']>;
  limited_stock?: Maybe<Scalars['Boolean']>;
  main_stock?: Maybe<Scalars['Int']>;
  maximumDeliveryTime?: Maybe<Scalars['Int']>;
  media?: Maybe<Array<Maybe<ProductAvatar>>>;
  minimumDeliveryTime?: Maybe<Scalars['Int']>;
  minimumOrderQuantity?: Maybe<Scalars['Int']>;
  overalReview: Scalars['Float'];
  price: Scalars['Float'];
  productType?: Maybe<ProductType>;
  product_origin?: Maybe<ProductOrigin>;
  profit_added?: Maybe<Scalars['Float']>;
  published: Scalars['Boolean'];
  qty?: Maybe<Scalars['Int']>;
  resell: Scalars['Boolean'];
  reviewBreakDown: ReviewBreakDown;
  reviews?: Maybe<Array<Review>>;
  savesCount?: Maybe<Scalars['Float']>;
  sharesCount?: Maybe<Scalars['Float']>;
  shippingCost?: Maybe<Scalars['Float']>;
  shop_id?: Maybe<Scalars['ID']>;
  sku: Scalars['String'];
  status?: Maybe<ProductStatus>;
  supplier?: Maybe<Supplier>;
  supplier_cost?: Maybe<Scalars['Float']>;
  supplier_id?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
  transit_stock?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['Date']>;
  uuid?: Maybe<Scalars['String']>;
  variations?: Maybe<Array<Maybe<Variation>>>;
  verified?: Maybe<Scalars['Boolean']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ProductAvatar = {
  __typename?: 'ProductAvatar';
  avatar?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  product_id?: Maybe<Scalars['ID']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  avatar?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<ProductCategory>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parent?: Maybe<Scalars['ID']>;
  type?: Maybe<CategoryType>;
};

export type ProductCategoryAndTagsInput = {
  categories?: InputMaybe<Array<Scalars['ID']>>;
  personnel?: InputMaybe<Scalars['String']>;
  product_id: Scalars['ID'];
  published?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProductStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCategoryCount = {
  __typename?: 'ProductCategoryCount';
  category: Scalars['String'];
  count: Scalars['Int'];
};

export type ProductCategoryFilter = {
  country?: InputMaybe<StringOperator>;
  description?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  parent?: InputMaybe<NumberOperator>;
  random?: InputMaybe<Scalars['Boolean']>;
  shop_id?: InputMaybe<IdOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  type?: InputMaybe<StringOperator>;
};

export type ProductCategoryInput = {
  avatar?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  parent?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<CategoryType>;
};

export type ProductCollection = {
  __typename?: 'ProductCollection';
  collection?: Maybe<Catalog>;
  id?: Maybe<Scalars['ID']>;
  product?: Maybe<Product>;
};

export type ProductCombination = {
  __typename?: 'ProductCombination';
  available_stock: Scalars['Int'];
  combination_string: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  price: Scalars['Float'];
  sku: Scalars['String'];
};

export type ProductCombinationFilter = {
  available_stock?: InputMaybe<NumberOperator>;
  combination_string?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  price?: InputMaybe<MoneyOperator>;
  sku?: InputMaybe<StringOperator>;
};

export type ProductCombinationInput = {
  avatar: Scalars['String'];
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  combination_string: Scalars['String'];
  cost_price: Scalars['Float'];
  id?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  price: Scalars['Float'];
  qty: Scalars['Int'];
  sku: Scalars['String'];
};

export type ProductComment = {
  __typename?: 'ProductComment';
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  staff_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export enum ProductCondition {
  In = 'IN',
  NotIn = 'NOT_IN'
}

export enum ProductDistinctField {
  AttendedTo = 'attended_to',
  Avatar = 'avatar',
  CombinationString = 'combination_string',
  CostPrice = 'cost_price',
  Country = 'country',
  CreatedAt = 'created_at',
  Currency = 'currency',
  Description = 'description',
  Id = 'id',
  Inhouse = 'inhouse',
  LimitedStock = 'limited_stock',
  Price = 'price',
  Published = 'published',
  Qty = 'qty',
  ShopId = 'shop_id',
  Sku = 'sku',
  Title = 'title',
  UpdatedAt = 'updated_at',
  Uuid = 'uuid',
  Verified = 'verified',
  Weight = 'weight'
}

export type ProductHistory = {
  __typename?: 'ProductHistory';
  action?: Maybe<Scalars['String']>;
  actor?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  id?: Maybe<Scalars['ID']>;
  newSnapshot?: Maybe<Scalars['Any']>;
  notes?: Maybe<Scalars['String']>;
  oldSnapshot?: Maybe<Scalars['Any']>;
  product_id: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type ProductHistoryFilter = {
  action?: InputMaybe<StringOperator>;
  product_id?: InputMaybe<IdOperator>;
};

export type ProductIdConverterResult = {
  __typename?: 'ProductIdConverterResult';
  main_product_id?: Maybe<Scalars['String']>;
  sub_product_id?: Maybe<SubProductId>;
};

export type ProductInformationInput = {
  cost_price?: InputMaybe<Scalars['Float']>;
  country?: InputMaybe<CountryCode>;
  currency?: InputMaybe<CurrencyCode>;
  description?: InputMaybe<Scalars['String']>;
  extra_information?: InputMaybe<Scalars['String']>;
  maximumDeliveryTime?: InputMaybe<Scalars['Int']>;
  minimumDeliveryTime?: InputMaybe<Scalars['Int']>;
  minimumOrderQuantity?: InputMaybe<Scalars['Int']>;
  personnel?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product_id: Scalars['ID'];
  published?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  sku: Scalars['String'];
  status?: InputMaybe<ProductStatus>;
  supplier_cost?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type ProductInventoryHistory = {
  __typename?: 'ProductInventoryHistory';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  new_cost_price: Scalars['Float'];
  new_price: Scalars['Float'];
  new_quantity: Scalars['Int'];
  old_cost_price: Scalars['Float'];
  old_price: Scalars['Float'];
  old_quantity: Scalars['Int'];
  product_id: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type ProductInventoryHistoryFilter = {
  product_id?: InputMaybe<IdOperator>;
};

export type ProductInventoryInput = {
  cost_price?: InputMaybe<Scalars['Float']>;
  limited_stock?: InputMaybe<Scalars['Boolean']>;
  personnel?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product_id: Scalars['ID'];
  published?: InputMaybe<Scalars['Boolean']>;
  qty?: InputMaybe<Scalars['Int']>;
  reason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProductStatus>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type ProductMediaInput = {
  avatar?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  personnel?: InputMaybe<Scalars['String']>;
  product_id: Scalars['ID'];
  published?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProductStatus>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type ProductMetricsFilter = {
  country: StringOperator;
  published?: InputMaybe<BooleanOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export enum ProductOrigin {
  InHouse = 'IN_HOUSE',
  Magento = 'MAGENTO',
  Shopify = 'SHOPIFY',
  SupplierOfflineCatalogue = 'SUPPLIER_OFFLINE_CATALOGUE',
  SupplierTendoOnlineCatalogue = 'SUPPLIER_TENDO_ONLINE_CATALOGUE',
  Woocommence = 'WOOCOMMENCE'
}

export enum ProductPolicy {
  Resell = 'RESELL',
  Supplier = 'SUPPLIER'
}

export type ProductRequest = {
  __typename?: 'ProductRequest';
  id: Scalars['ID'];
  product?: Maybe<Product>;
  qty?: Maybe<Scalars['Int']>;
  shop_id?: Maybe<Scalars['ID']>;
  status?: Maybe<ProductRequestStatus>;
};

export enum ProductRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ProductSalesReport = {
  __typename?: 'ProductSalesReport';
  currency?: Maybe<Scalars['String']>;
  product_id: Scalars['ID'];
  sku: Scalars['String'];
  total_order_value: Scalars['Float'];
  total_orders: Scalars['Int'];
  total_product_cost: Scalars['Float'];
  total_product_price: Scalars['Float'];
  total_profit_added: Scalars['Float'];
};

export type ProductSalesReportInput = {
  from?: InputMaybe<Scalars['String']>;
  product_id: Scalars['ID'];
  to?: InputMaybe<Scalars['String']>;
};

export type ProductShipment = {
  __typename?: 'ProductShipment';
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<ShipmentItem>>>;
  shipmentCode?: Maybe<Scalars['String']>;
  shipmentDescription?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ProductShipmentFilter = {
  id?: InputMaybe<IdOperator>;
  sku?: InputMaybe<StringOperator>;
};

export type ProductShipmentInput = {
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<InputMaybe<ShipmentItemItem>>>;
  shipmentCode?: InputMaybe<Scalars['String']>;
  shipmentDescription?: InputMaybe<Scalars['String']>;
};

export type ProductSort = {
  field: ProductDistinctField;
  order: SortOrder;
};

export enum ProductStat {
  Likes = 'LIKES',
  Saves = 'SAVES'
}

export enum ProductStatEditType {
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT'
}

export enum ProductStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ProductStockHistoryItem = {
  __typename?: 'ProductStockHistoryItem';
  createdAt: Scalars['Date'];
  exhausted: Scalars['Boolean'];
  id: Scalars['ID'];
  price?: Maybe<Scalars['Float']>;
  product_id: Scalars['ID'];
  qty: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type ProductStockInput = {
  id: Scalars['ID'];
  personnel?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  qty: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};

export type ProductTemplate = {
  __typename?: 'ProductTemplate';
  body?: Maybe<Array<Template>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum ProductType {
  Digital = 'Digital',
  Physical = 'Physical'
}

export type ProductsStats = {
  __typename?: 'ProductsStats';
  total_in_stock: Scalars['Int'];
  total_in_transit: Scalars['Int'];
  total_out_stock: Scalars['Int'];
  total_unique_products: Scalars['Int'];
};

export type ProfitRevenueStats = {
  __typename?: 'ProfitRevenueStats';
  allTimeRevenue?: Maybe<Scalars['Float']>;
  dayRevenue?: Maybe<Scalars['Float']>;
  monthRevenue?: Maybe<Scalars['Float']>;
  weekRevenue?: Maybe<Scalars['Float']>;
  yearRevenue?: Maybe<Scalars['Float']>;
};

export enum ProfitType {
  Amount = 'amount',
  Percent = 'percent'
}

export type PromoBanner = {
  __typename?: 'PromoBanner';
  active: Scalars['Boolean'];
  country: Scalars['String'];
  id: Scalars['ID'];
  screen: Scalars['String'];
  url: Scalars['String'];
};

export type PromoBannerFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
};

export type PromoBannerInput = {
  active: Scalars['Boolean'];
  country: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  screen: Scalars['String'];
  url: Scalars['String'];
};

export enum QuantityAdjustmentType {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

export type Query = {
  __typename?: 'Query';
  appBanner?: Maybe<AppBanner>;
  appBanners?: Maybe<Array<AppBanner>>;
  bobGetCourierRates?: Maybe<BobGetCourierRatesResponseDto>;
  /** Get order fulfillments */
  bobGetOrderFulfillments?: Maybe<BobGetOrderFulfillmentsResponseDto>;
  bobGetOrders?: Maybe<BobGetOrdersResponseDto>;
  bobGetRateRequests?: Maybe<BobGetRateRequestsResponseDto>;
  /** Get rates at checkout */
  bobGetRatesAtCheckout?: Maybe<BobGetRatesAtCheckoutResponseDto>;
  bobGetShipmentWaybill?: Maybe<BobShipmentWaybill>;
  bobGetShipments?: Maybe<BobGetShipmentsResponseDto>;
  bobGetTrackingEvents?: Maybe<Array<Maybe<BobTrackingEvent>>>;
  canRefundOrderPurchaseTransaction: Scalars['Boolean'];
  checkStockAvailability?: Maybe<Array<Maybe<StockAvailability>>>;
  checkTransaction?: Maybe<CheckTransactionResponseDto>;
  confirmCardSetup?: Maybe<Scalars['Boolean']>;
  deliveryLocation?: Maybe<Delivery>;
  deliveryLocations?: Maybe<Array<Maybe<Delivery>>>;
  deliveryLocationsLength: Scalars['Int'];
  doesShopDomainExist: SokoWorldDomainExistsResponseDto;
  doesShopExist: DoesShopExistResponseDto;
  downloadWalletStatement?: Maybe<WalletStatementDto>;
  featuredCategories?: Maybe<Array<FeaturedCategories>>;
  findDeliveryZone?: Maybe<DeliveryZone>;
  getActiveTendoLeaderBoard?: Maybe<TendoLeaderBoard>;
  getActiveTendoLeaderBoardPositions: Array<TendoLeaderBoardPosition>;
  getAliExpressProduct?: Maybe<GeneratedAliExpressProduct>;
  getAliExpressProducts?: Maybe<AliExpressProductResponse>;
  getAllDelayedProfitPayoutDeliveredOrders?: Maybe<Array<Maybe<DeliveredOrders>>>;
  getAllTimeActiveUsers?: Maybe<Scalars['Any']>;
  getAppCart?: Maybe<AppCart>;
  getAssignedOrdersForRider?: Maybe<Array<Maybe<Order>>>;
  getAssignedOrdersForRiderLength: Scalars['Int'];
  getCampaign?: Maybe<Campaign>;
  getCampaignModels?: Maybe<Array<Maybe<CampaignModel>>>;
  getCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  getCampaignsCount?: Maybe<Scalars['Int']>;
  getCart?: Maybe<Order>;
  getCarts?: Maybe<Array<Maybe<Order>>>;
  getCartsLength: Scalars['Int'];
  getCatalog: Catalog;
  getCatalogs?: Maybe<Array<Maybe<Catalog>>>;
  getCatalogsLength: Scalars['Int'];
  getCategoryMedia: Array<Maybe<ProductAvatar>>;
  getCheckoutCart: CheckoutCart;
  getCollectionProducts?: Maybe<Array<Maybe<Product>>>;
  getCollectionProductsLength: Scalars['Int'];
  getCoupon?: Maybe<Coupon>;
  getCouponRedemptions?: Maybe<Array<Maybe<CouponRedemption>>>;
  getCouponRedemptionsLength: Scalars['Int'];
  getCoupons?: Maybe<Array<Coupon>>;
  getCouponsLength: Scalars['Int'];
  getCurentForexRate?: Maybe<ForexRate>;
  getCustomer?: Maybe<Customer>;
  getCustomers?: Maybe<Array<Maybe<Customer>>>;
  getCustomersLength: Scalars['Int'];
  getDailyActiveUsers?: Maybe<Scalars['Any']>;
  getDailyOrdersSummary?: Maybe<Scalars['Any']>;
  getDelayedProfitPayouts?: Maybe<Array<Maybe<OrderItem>>>;
  getDelayedProfitPayoutsLength: Scalars['Int'];
  getDeliveredOrders?: Maybe<Array<Maybe<DeliveredOrders>>>;
  getDeliveryPrices?: Maybe<Array<AutogeneratedMainType>>;
  getDeliveryZone?: Maybe<DeliveryZone>;
  getDeliveryZones?: Maybe<Array<DeliveryZone>>;
  getDeliveryZonesLength: Scalars['Int'];
  getDeveloper?: Maybe<Developer>;
  getDevelopers?: Maybe<Array<Maybe<Developer>>>;
  getDigitalOrder?: Maybe<DigitalOrder>;
  getDigitalOrders?: Maybe<Array<Maybe<DigitalOrder>>>;
  getDigitalOrdersLength: Scalars['Int'];
  getDiscount?: Maybe<Discount>;
  getDiscountProductCondition?: Maybe<DiscountProductCondition>;
  getDiscountProductConditions?: Maybe<Array<Maybe<DiscountProductCondition>>>;
  getDiscountProductConditionsLength: Scalars['Int'];
  getDiscounts?: Maybe<Array<Maybe<Discount>>>;
  getDiscountsLength: Scalars['Int'];
  getFailedOfflineOrders?: Maybe<Array<OfflineOrder>>;
  getFailedOfflineOrdersLength: Scalars['Int'];
  getForexRates?: Maybe<Array<ForexRate>>;
  getInsightOnCoupon?: Maybe<CouponInsight>;
  getLeaderboardExemptions: Array<LeaderBoardExemption>;
  getLeaderboardExemptionsLength: Scalars['Int'];
  getMainCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  getMonthlyActiveUsers?: Maybe<Scalars['Any']>;
  getMyActiveSalesTargetCampaigns: Array<SalesTargetCampaign>;
  getMySalesTargetContribution: Scalars['Float'];
  getNetInflowSnapshotDrilldown: NetInflowDrilldownResult;
  getNetInflowSnapshots: NetInflowSnapshotResult;
  getNineMonthsActiveUsers?: Maybe<Scalars['Any']>;
  getNumberOfTimesDiscountWasUsed?: Maybe<Scalars['Int']>;
  getOpsConfig?: Maybe<OpsConfig>;
  getOrder?: Maybe<OrderItem>;
  getOrderStatusesStats?: Maybe<OrderStatsStats>;
  getOrders?: Maybe<Array<Maybe<OrderItem>>>;
  getOrdersLength: Scalars['Int'];
  getPartnership?: Maybe<Partnership>;
  getPartnerships: Array<Partnership>;
  getPartnershipsLength: Scalars['Int'];
  getPickUpLocation?: Maybe<Pickup>;
  getPickUpLocations?: Maybe<Array<Pickup>>;
  getPickUpLocationsLength: Scalars['Int'];
  getPlugin?: Maybe<Plugin>;
  getPlugins?: Maybe<Array<Maybe<Plugin>>>;
  getPositionInTendoLeaderBoard?: Maybe<TendoLeaderBoardPosition>;
  getProduct?: Maybe<Product>;
  getProductAssignedCategories?: Maybe<Array<ProductCategory>>;
  getProductCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  getProductCategoriesLength: Scalars['Int'];
  getProductCategory?: Maybe<ProductCategory>;
  getProductCombination: Scalars['Int'];
  getProductCombinations?: Maybe<Array<Maybe<ProductCombination>>>;
  getProductCombinationsLength: Scalars['Int'];
  getProductDiscount?: Maybe<Discount>;
  getProductHistory?: Maybe<Array<Maybe<ProductHistory>>>;
  getProductInventoryHistory?: Maybe<Array<Maybe<ProductInventoryHistory>>>;
  getProductMargins?: Maybe<Scalars['Any']>;
  getProductRequests?: Maybe<Array<Maybe<ProductRequest>>>;
  getProductSalesReport?: Maybe<ProductSalesReport>;
  getProductStockUpdateHistory?: Maybe<Array<Maybe<ProductStockHistoryItem>>>;
  getProductStockUpdateHistoryLength: Scalars['Int'];
  getProductTemplate?: Maybe<ProductTemplate>;
  getProductTemplates?: Maybe<Array<ProductTemplate>>;
  getProductTemplatesLength?: Maybe<Scalars['Int']>;
  getProducts?: Maybe<Array<Maybe<Product>>>;
  getProductsCountByCategories?: Maybe<Array<Maybe<ProductCategoryCount>>>;
  getProductsForAdmin?: Maybe<Array<Maybe<Product>>>;
  getProductsForAdminLength: Scalars['Int'];
  getProductsForMobileApp?: Maybe<Array<Maybe<Product>>>;
  getProductsForMobileAppLength: Scalars['Int'];
  getProductsForSupplierApp?: Maybe<Array<Maybe<Product>>>;
  getProductsForSupplierAppLength: Scalars['Int'];
  getProductsForSupplierDashboard?: Maybe<Array<Maybe<Product>>>;
  getProductsForSupplierDashboardLength: Scalars['Int'];
  getProductsForWebApp?: Maybe<Array<Maybe<Product>>>;
  getProductsForWebAppLength: Scalars['Int'];
  getProductsLength?: Maybe<Scalars['Int']>;
  getProductsLikedByUser: Array<Maybe<Product>>;
  getProductsMetrics?: Maybe<ProductsStats>;
  getProductsSavedByUser: Array<Maybe<Product>>;
  getProductsSharedByUser: Array<Maybe<SharedProduct>>;
  getProductsShipments?: Maybe<Array<Maybe<ProductShipment>>>;
  getPromoBanner?: Maybe<PromoBanner>;
  getPromoBanners?: Maybe<Array<Maybe<PromoBanner>>>;
  getPromoBannersLength: Scalars['Int'];
  getRandomProducts?: Maybe<Array<Maybe<Product>>>;
  getRecentOrderForUser?: Maybe<Order>;
  getRehookLeaderboard?: Maybe<RehookLeaderboard>;
  getRevenueFromProfit?: Maybe<ProfitRevenueStats>;
  getReview: Review;
  getReviews?: Maybe<Array<Maybe<Review>>>;
  getReviewsLength: Scalars['Int'];
  getRider?: Maybe<Rider>;
  getRiderIssueReports?: Maybe<Array<RiderIssueReport>>;
  getRiderIssueReportsLength: Scalars['Int'];
  getRiders?: Maybe<Array<Rider>>;
  getRidersLength: Scalars['Int'];
  getSKU?: Maybe<Scalars['String']>;
  getSales?: Maybe<Array<Maybe<Sales>>>;
  getSalesTargetCampaign?: Maybe<SalesTargetCampaign>;
  getSalesTargetCampaigns: Array<SalesTargetCampaign>;
  getSalesTargetCampaignsLength: Scalars['Int'];
  getSalesTargetContributors: Array<SalesTargetContributorRow>;
  getSelfCheckoutCustomer?: Maybe<Customer>;
  getSelfCheckoutLink?: Maybe<Scalars['String']>;
  getSharedProduct: SharedProduct;
  getSharedProducts?: Maybe<Array<Maybe<SharedProduct>>>;
  getShop?: Maybe<Shop>;
  getShopCollection?: Maybe<ShopCollection>;
  getShopCollectionProducts?: Maybe<Array<Maybe<Product>>>;
  getShopCollectionProductsLength: Scalars['Int'];
  getShopCollections?: Maybe<Array<ShopCollection>>;
  getShopCollectionsLength: Scalars['Int'];
  getShopProducts?: Maybe<Array<Maybe<Product>>>;
  getShopProductsLength: Scalars['Int'];
  getShopifyShop?: Maybe<ShopifyShop>;
  getShopifyShops?: Maybe<Array<Maybe<ShopifyShop>>>;
  getShops?: Maybe<Array<Shop>>;
  getShopsLength: Scalars['Int'];
  getSixMonthsActiveUsers?: Maybe<Scalars['Any']>;
  getStorefrontCart?: Maybe<StorefrontCart>;
  getStorefrontCarts?: Maybe<StorefrontCartsReturnType>;
  getStorefrontCartsLength?: Maybe<Scalars['Int']>;
  getStorefrontTransaction?: Maybe<Transaction>;
  getStorefrontTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getSubCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  getSupplier?: Maybe<Supplier>;
  getSupplierAccountHistory?: Maybe<Array<SupplierAccountHistory>>;
  getSupplierAccountHistoryLength: Scalars['Int'];
  getSupplierBusinessPickupLocations?: Maybe<Array<Maybe<SupplierLocation>>>;
  getSupplierDailyOrdersSummary?: Maybe<Scalars['Any']>;
  getSupplierOrdersByStatusSummary?: Maybe<OrderStatusesStats>;
  getSupplierPickupLocation?: Maybe<SupplierLocation>;
  getSupplierStats?: Maybe<SupplierStats>;
  getSupplierWallets?: Maybe<Array<Maybe<WalletResponseDto>>>;
  getSuppliers?: Maybe<Array<Supplier>>;
  getSuppliersLength: Scalars['Int'];
  getSupportedCurrencies?: Maybe<Array<Maybe<SupportedCurrenciesResponseDto>>>;
  getSupportedProviders?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  getTeam?: Maybe<Team>;
  getTeams?: Maybe<Array<Maybe<Team>>>;
  getTendoLeaderBoardPositions?: Maybe<Array<TendoLeaderBoardPosition>>;
  getTendoLeaderBoardPositionsLength: Scalars['Int'];
  getTendoLeaderBoards: Array<TendoLeaderBoard>;
  getTendoLeaderBoardsLength: Scalars['Int'];
  getTerm?: Maybe<Terms>;
  getTerms?: Maybe<Array<Terms>>;
  getTermsLength: Scalars['Int'];
  getThreeMonthsActiveUsers?: Maybe<Scalars['Any']>;
  getTopProducts: TopProductsResponseDto;
  getTopResellersForTheWeek?: Maybe<Array<Maybe<TopReseller>>>;
  getTopResellersForTheWeekByOrderCount?: Maybe<Array<Maybe<TopReseller>>>;
  getTransaction?: Maybe<Transaction>;
  getTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getTransactionsCount?: Maybe<Scalars['Int']>;
  getUnverifiedProducts?: Maybe<Array<Maybe<Product>>>;
  getUser?: Maybe<User>;
  getUserAccountSecurity?: Maybe<Array<Maybe<UserAccountSecurity>>>;
  getUserCoupons?: Maybe<Array<CouponRedemption>>;
  getUserCouponsLength: Scalars['Int'];
  getUserDelayedOrders?: Maybe<Array<Maybe<OrderItem>>>;
  getUserNotification?: Maybe<UserNotification>;
  getUserNotifications?: Maybe<Array<Maybe<UserNotification>>>;
  getUserNotificationsLength: Scalars['Int'];
  getUserPaymentDetails?: Maybe<Array<UserPayment>>;
  getUserPlugins?: Maybe<Array<Maybe<UserPlugin>>>;
  getUserReferralsMetrics?: Maybe<UserReferralMetrics>;
  getUserWallet?: Maybe<WalletResponseDto>;
  getUserWallets?: Maybe<Array<Maybe<WalletResponseDto>>>;
  getUsers?: Maybe<Array<Maybe<User>>>;
  getUsersLength: Scalars['Int'];
  getVariation: Scalars['Int'];
  getVariations?: Maybe<Array<Maybe<Variation>>>;
  getVariationsLength: Scalars['Int'];
  getWalletBalance?: Maybe<WalletBalanceDto>;
  getWalletPayout?: Maybe<WalletPayoutResponseDto>;
  getWalletPayouts?: Maybe<Array<Maybe<WalletPayoutResponseDto>>>;
  getWalletPayoutsCount?: Maybe<Scalars['Int']>;
  getWalletTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getWalletTransactionsCount?: Maybe<Scalars['Int']>;
  getWeeklyActiveUsers?: Maybe<Scalars['Any']>;
  getWeeklyActiveUsersGraph?: Maybe<Scalars['Any']>;
  getYearActiveUsers?: Maybe<Scalars['Any']>;
  getYesterDayActiveUser?: Maybe<Scalars['Any']>;
  isProductInShop?: Maybe<Scalars['Boolean']>;
  isProductLikedByUser?: Maybe<Scalars['Boolean']>;
  isProductSavedByUser?: Maybe<Scalars['Boolean']>;
  isProductSharedByUser?: Maybe<Scalars['Boolean']>;
  isSkuAvailable?: Maybe<Scalars['Boolean']>;
  listFailedOrderCharges: FailedOrderChargePage;
  listSalesTargetExemptions: Array<SalesTargetExemption>;
  loadShopifyProducts?: Maybe<Array<Maybe<ShopifyLoadedProduct>>>;
  me?: Maybe<User>;
  newArrivals?: Maybe<Array<Product>>;
  newArrivalsLength: Scalars['Int'];
  notifications?: Maybe<Array<Maybe<Notification>>>;
  onBoardingCouponExistsAndNotConsumed?: Maybe<Scalars['Boolean']>;
  orderGraphStats?: Maybe<Array<Maybe<OrderGraphData>>>;
  orderStats?: Maybe<OrderStats>;
  topDeals?: Maybe<Array<Product>>;
  topDealsBanners?: Maybe<Array<TopDealBanner>>;
  topDealsLength: Scalars['Int'];
  trendingProducts?: Maybe<Array<Product>>;
  user?: Maybe<User>;
  userGraphStats?: Maybe<Array<Maybe<UserGraphData>>>;
  userStats?: Maybe<UserStats>;
  users?: Maybe<Array<Maybe<User>>>;
  verifyAccountDetails?: Maybe<Scalars['JSONObject']>;
  verifyAuth: Auth;
};


export type QueryAppBannerArgs = {
  filter: AppBannerFilter;
};


export type QueryAppBannersArgs = {
  filter?: InputMaybe<AppBannerFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryBobGetCourierRatesArgs = {
  data: BobGetCourierRatesRequestDto;
};


export type QueryBobGetOrderFulfillmentsArgs = {
  data: BobGetOrderFulfillmentsRequestDto;
};


export type QueryBobGetOrdersArgs = {
  data: BobGetOrdersRequestDto;
};


export type QueryBobGetRateRequestsArgs = {
  data: BobGetRateRequestsRequestDto;
};


export type QueryBobGetRatesAtCheckoutArgs = {
  data: BobGetRatesAtCheckoutRequestDto;
};


export type QueryBobGetShipmentWaybillArgs = {
  data: BobGetShipmentWaybillRequestDto;
};


export type QueryBobGetShipmentsArgs = {
  data: BobGetShipmentsRequestDto;
};


export type QueryBobGetTrackingEventsArgs = {
  data: BobGetTrackingEventsRequestDto;
};


export type QueryCanRefundOrderPurchaseTransactionArgs = {
  reference: Scalars['String'];
};


export type QueryCheckStockAvailabilityArgs = {
  skus: Array<StockAvailabilityInput>;
};


export type QueryCheckTransactionArgs = {
  input: CheckTransactionInput;
};


export type QueryConfirmCardSetupArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDeliveryLocationArgs = {
  filter: DeliveryFilter;
};


export type QueryDeliveryLocationsArgs = {
  filter?: InputMaybe<DeliveryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryDeliveryLocationsLengthArgs = {
  filter?: InputMaybe<DeliveryFilter>;
};


export type QueryDoesShopDomainExistArgs = {
  data: SokoWorldDomainExistsRequestDto;
};


export type QueryDoesShopExistArgs = {
  filter: ShopFilter;
};


export type QueryDownloadWalletStatementArgs = {
  input: DownloadWalletStatementInput;
};


export type QueryFeaturedCategoriesArgs = {
  filter?: InputMaybe<FeaturedCategoriesFilter>;
};


export type QueryFindDeliveryZoneArgs = {
  location?: InputMaybe<LatLngInput>;
};


export type QueryGetActiveTendoLeaderBoardPositionsArgs = {
  limit: Scalars['Int'];
};


export type QueryGetAliExpressProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetAliExpressProductsArgs = {
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetAppCartArgs = {
  user_id: Scalars['ID'];
};


export type QueryGetAssignedOrdersForRiderArgs = {
  filter?: InputMaybe<CartAssignmentFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetAssignedOrdersForRiderLengthArgs = {
  filter?: InputMaybe<CartAssignmentFilter>;
};


export type QueryGetCampaignArgs = {
  filter?: InputMaybe<CampaignFilter>;
};


export type QueryGetCampaignsArgs = {
  filter?: InputMaybe<CampaignFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCampaignsCountArgs = {
  filter?: InputMaybe<CampaignFilter>;
};


export type QueryGetCartArgs = {
  filter?: InputMaybe<CartFilter>;
};


export type QueryGetCartsArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<CartFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCartsLengthArgs = {
  filter?: InputMaybe<CartFilter>;
};


export type QueryGetCatalogArgs = {
  filter?: InputMaybe<CatalogFilter>;
};


export type QueryGetCatalogsArgs = {
  filter?: InputMaybe<CatalogFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCatalogsLengthArgs = {
  filter?: InputMaybe<CatalogFilter>;
};


export type QueryGetCategoryMediaArgs = {
  filter: ProductCategoryFilter;
  pagination: Pagination;
};


export type QueryGetCollectionProductsArgs = {
  filter?: InputMaybe<CatalogFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCollectionProductsLengthArgs = {
  filter?: InputMaybe<CatalogFilter>;
};


export type QueryGetCouponArgs = {
  filter: CouponFilter;
};


export type QueryGetCouponRedemptionsArgs = {
  filter: CouponRedemptionFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCouponRedemptionsLengthArgs = {
  filter: CouponRedemptionFilter;
};


export type QueryGetCouponsArgs = {
  filter?: InputMaybe<CouponFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCouponsLengthArgs = {
  filter?: InputMaybe<CouponFilter>;
};


export type QueryGetCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
};


export type QueryGetCustomersArgs = {
  filter?: InputMaybe<CustomerFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCustomersLengthArgs = {
  filter?: InputMaybe<CustomerFilter>;
};


export type QueryGetDailyOrdersSummaryArgs = {
  country: Scalars['String'];
  from: Scalars['Date'];
  to: Scalars['Date'];
};


export type QueryGetDelayedProfitPayoutsArgs = {
  country: Scalars['String'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDelayedProfitPayoutsLengthArgs = {
  country: Scalars['String'];
};


export type QueryGetDeliveredOrdersArgs = {
  filter?: InputMaybe<DeliveredOrdersFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDeliveryPricesArgs = {
  input?: InputMaybe<DeliveryPricesInput>;
};


export type QueryGetDeliveryZoneArgs = {
  filter?: InputMaybe<DeliveryZonesFilter>;
};


export type QueryGetDeliveryZonesArgs = {
  filter?: InputMaybe<DeliveryZonesFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDeliveryZonesLengthArgs = {
  filter?: InputMaybe<DeliveryZonesFilter>;
};


export type QueryGetDeveloperArgs = {
  input: GetDeveloperInput;
};


export type QueryGetDevelopersArgs = {
  input: GetDevelopersInput;
};


export type QueryGetDigitalOrderArgs = {
  filter: DigitalOrderFilter;
};


export type QueryGetDigitalOrdersArgs = {
  filter?: InputMaybe<DigitalOrderFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDigitalOrdersLengthArgs = {
  filter?: InputMaybe<DigitalOrderFilter>;
};


export type QueryGetDiscountArgs = {
  filter: DiscountFilter;
};


export type QueryGetDiscountProductConditionArgs = {
  filter: DiscountProductConditionFilter;
};


export type QueryGetDiscountProductConditionsArgs = {
  filter?: InputMaybe<DiscountProductConditionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDiscountProductConditionsLengthArgs = {
  filter?: InputMaybe<DiscountProductConditionFilter>;
};


export type QueryGetDiscountsArgs = {
  filter?: InputMaybe<DiscountFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDiscountsLengthArgs = {
  filter?: InputMaybe<DiscountFilter>;
};


export type QueryGetFailedOfflineOrdersArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetForexRatesArgs = {
  filter?: InputMaybe<ForexRateFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetInsightOnCouponArgs = {
  id: Scalars['ID'];
};


export type QueryGetLeaderboardExemptionsArgs = {
  filter?: InputMaybe<LeaderBoardExemptionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetLeaderboardExemptionsLengthArgs = {
  filter?: InputMaybe<LeaderBoardExemptionFilter>;
};


export type QueryGetMainCategoriesArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetMyActiveSalesTargetCampaignsArgs = {
  cadence?: InputMaybe<SalesTargetCadence>;
  country: CountryCode;
};


export type QueryGetMySalesTargetContributionArgs = {
  campaignId: Scalars['ID'];
};


export type QueryGetNetInflowSnapshotDrilldownArgs = {
  currency: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  lineItem: NetInflowLineItem;
  offset?: InputMaybe<Scalars['Int']>;
  snapshotDate: Scalars['String'];
};


export type QueryGetNetInflowSnapshotsArgs = {
  filter: NetInflowSnapshotFilterInput;
};


export type QueryGetNumberOfTimesDiscountWasUsedArgs = {
  input: DiscountUseFilter;
};


export type QueryGetOpsConfigArgs = {
  country?: InputMaybe<Scalars['String']>;
};


export type QueryGetOrderArgs = {
  filter?: InputMaybe<OrderFilter>;
};


export type QueryGetOrderStatusesStatsArgs = {
  country: Scalars['String'];
};


export type QueryGetOrdersArgs = {
  filter?: InputMaybe<OrderFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<OrderSort>;
};


export type QueryGetOrdersLengthArgs = {
  filter?: InputMaybe<OrderFilter>;
};


export type QueryGetPartnershipArgs = {
  filter: PartnershipFilter;
};


export type QueryGetPartnershipsArgs = {
  filter?: InputMaybe<PartnershipFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPartnershipsLengthArgs = {
  filter?: InputMaybe<PartnershipFilter>;
};


export type QueryGetPickUpLocationArgs = {
  filter?: InputMaybe<DeliveryFilter>;
};


export type QueryGetPickUpLocationsArgs = {
  filter?: InputMaybe<DeliveryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPickUpLocationsLengthArgs = {
  filter?: InputMaybe<DeliveryFilter>;
};


export type QueryGetPluginArgs = {
  filter: PluginFilter;
};


export type QueryGetPluginsArgs = {
  filter?: InputMaybe<PluginFilter>;
  pagination?: InputMaybe<Pagination>;
  supplier_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetPositionInTendoLeaderBoardArgs = {
  userId: Scalars['ID'];
};


export type QueryGetProductArgs = {
  filter?: InputMaybe<ProductFilter>;
};


export type QueryGetProductAssignedCategoriesArgs = {
  product_id: Scalars['ID'];
};


export type QueryGetProductCategoriesArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductCategoriesLengthArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
};


export type QueryGetProductCategoryArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
};


export type QueryGetProductCombinationArgs = {
  filter?: InputMaybe<ProductCombinationFilter>;
};


export type QueryGetProductCombinationsArgs = {
  filter?: InputMaybe<ProductCombinationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductCombinationsLengthArgs = {
  filter?: InputMaybe<ProductCombinationFilter>;
};


export type QueryGetProductDiscountArgs = {
  productSKU?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductHistoryArgs = {
  filter: ProductHistoryFilter;
  pagination: Pagination;
};


export type QueryGetProductInventoryHistoryArgs = {
  filter: ProductInventoryHistoryFilter;
  pagination: Pagination;
};


export type QueryGetProductRequestsArgs = {
  filter?: InputMaybe<ProductRequestFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductSalesReportArgs = {
  input: ProductSalesReportInput;
};


export type QueryGetProductStockUpdateHistoryArgs = {
  filter: ProductInventoryHistoryFilter;
  pagination: Pagination;
};


export type QueryGetProductStockUpdateHistoryLengthArgs = {
  filter: ProductInventoryHistoryFilter;
};


export type QueryGetProductTemplateArgs = {
  filter: TemplateFilter;
};


export type QueryGetProductTemplatesArgs = {
  filter?: InputMaybe<TemplateFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductTemplatesLengthArgs = {
  filter?: InputMaybe<TemplateFilter>;
};


export type QueryGetProductsArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsCountByCategoriesArgs = {
  supplier_id: Scalars['ID'];
};


export type QueryGetProductsForAdminArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForAdminLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
};


export type QueryGetProductsForMobileAppArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ClientProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForMobileAppLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ClientProductFilter>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForSupplierAppArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<SupplierProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForSupplierAppLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<SupplierProductFilter>;
};


export type QueryGetProductsForSupplierDashboardArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<SupplierProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForSupplierDashboardLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<SupplierProductFilter>;
};


export type QueryGetProductsForWebAppArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ClientProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForWebAppLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ClientProductFilter>;
};


export type QueryGetProductsLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
};


export type QueryGetProductsLikedByUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetProductsMetricsArgs = {
  filter: ProductMetricsFilter;
};


export type QueryGetProductsSavedByUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetProductsSharedByUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetProductsShipmentsArgs = {
  filter?: InputMaybe<ProductShipmentFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPromoBannerArgs = {
  screen: Scalars['String'];
};


export type QueryGetPromoBannersArgs = {
  filter?: InputMaybe<PromoBannerFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPromoBannersLengthArgs = {
  filter?: InputMaybe<PromoBannerFilter>;
};


export type QueryGetRandomProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetRecentOrderForUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetRehookLeaderboardArgs = {
  input: GetRehookLeaderboardInput;
};


export type QueryGetRevenueFromProfitArgs = {
  country: Scalars['String'];
};


export type QueryGetReviewArgs = {
  filter: ReviewFilter;
};


export type QueryGetReviewsArgs = {
  filter?: InputMaybe<ReviewFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetReviewsLengthArgs = {
  filter: ReviewFilter;
};


export type QueryGetRiderArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<RiderFilter>;
};


export type QueryGetRiderIssueReportsArgs = {
  filter?: InputMaybe<RiderIssueReportFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetRiderIssueReportsLengthArgs = {
  filter?: InputMaybe<RiderIssueReportFilter>;
};


export type QueryGetRidersArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<RiderFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetRidersLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<RiderFilter>;
};


export type QueryGetSalesArgs = {
  filter?: InputMaybe<SalesFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSalesTargetCampaignArgs = {
  id: Scalars['ID'];
};


export type QueryGetSalesTargetCampaignsArgs = {
  filter?: InputMaybe<SalesTargetCampaignFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSalesTargetCampaignsLengthArgs = {
  filter?: InputMaybe<SalesTargetCampaignFilter>;
};


export type QueryGetSalesTargetContributorsArgs = {
  campaignId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetSelfCheckoutCustomerArgs = {
  input: GetCustomerInput;
};


export type QueryGetSelfCheckoutLinkArgs = {
  shared_product_id: Scalars['ID'];
};


export type QueryGetSharedProductArgs = {
  input: GetSharedProductRequestDto;
};


export type QueryGetSharedProductsArgs = {
  filter?: InputMaybe<SharedProductFilter>;
  pagination?: InputMaybe<Pagination>;
  productFilter?: InputMaybe<ProductFilter>;
};


export type QueryGetShopArgs = {
  filter: ShopFilter;
};


export type QueryGetShopCollectionArgs = {
  filter: ShopCollectionFilter;
};


export type QueryGetShopCollectionProductsArgs = {
  filter: ShopCollectionProductsFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetShopCollectionProductsLengthArgs = {
  filter: ShopCollectionProductsFilter;
};


export type QueryGetShopCollectionsArgs = {
  filter?: InputMaybe<ShopCollectionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetShopCollectionsLengthArgs = {
  filter?: InputMaybe<ShopCollectionFilter>;
};


export type QueryGetShopProductsArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ShopProductsFilter>;
  pagination?: InputMaybe<Pagination>;
  shop_id: Scalars['ID'];
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetShopProductsLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ShopProductsFilter>;
  shop_id: Scalars['ID'];
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetShopifyShopArgs = {
  input?: InputMaybe<FetchShopifyShopInput>;
};


export type QueryGetShopifyShopsArgs = {
  input?: InputMaybe<FetchShopifyShopsInput>;
};


export type QueryGetShopsArgs = {
  filter?: InputMaybe<ShopFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetShopsLengthArgs = {
  filter?: InputMaybe<ShopFilter>;
};


export type QueryGetStorefrontCartArgs = {
  filter?: InputMaybe<StorefrontCartFilter>;
};


export type QueryGetStorefrontCartsArgs = {
  filter?: InputMaybe<StorefrontCartFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetStorefrontCartsLengthArgs = {
  filter?: InputMaybe<StorefrontCartFilter>;
};


export type QueryGetStorefrontTransactionArgs = {
  input: GetStorefrontTransactionsInput;
};


export type QueryGetStorefrontTransactionsArgs = {
  input: GetStorefrontTransactionsInput;
};


export type QueryGetSubCategoriesArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSupplierArgs = {
  filter?: InputMaybe<SupplierFilter>;
};


export type QueryGetSupplierAccountHistoryArgs = {
  pagination?: InputMaybe<Pagination>;
  supplier_id: Scalars['ID'];
};


export type QueryGetSupplierAccountHistoryLengthArgs = {
  supplier_id: Scalars['ID'];
};


export type QueryGetSupplierBusinessPickupLocationsArgs = {
  filter?: InputMaybe<SupplierLocationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSupplierDailyOrdersSummaryArgs = {
  from: Scalars['Date'];
  id: Scalars['ID'];
  to: Scalars['Date'];
};


export type QueryGetSupplierOrdersByStatusSummaryArgs = {
  from: Scalars['Date'];
  supplier_id: Scalars['ID'];
  to: Scalars['Date'];
};


export type QueryGetSupplierPickupLocationArgs = {
  input?: InputMaybe<GetSupplierPickupLocationInput>;
};


export type QueryGetSupplierStatsArgs = {
  supplier_id: Scalars['ID'];
};


export type QueryGetSupplierWalletsArgs = {
  user_id: Scalars['ID'];
};


export type QueryGetSuppliersArgs = {
  filter?: InputMaybe<SupplierFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSuppliersLengthArgs = {
  filter?: InputMaybe<SupplierFilter>;
};


export type QueryGetSupportedCurrenciesArgs = {
  input?: InputMaybe<SupportedCurrencyFilter>;
};


export type QueryGetSupportedProvidersArgs = {
  input?: InputMaybe<GetSupportedProvidersInput>;
};


export type QueryGetTeamArgs = {
  input: GetTeamInput;
};


export type QueryGetTeamsArgs = {
  input: GetTeamsInput;
};


export type QueryGetTendoLeaderBoardPositionsArgs = {
  filter: TendoLeaderBoardFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetTendoLeaderBoardPositionsLengthArgs = {
  filter: TendoLeaderBoardFilter;
};


export type QueryGetTendoLeaderBoardsArgs = {
  filter?: InputMaybe<TendoLeaderBoardFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetTendoLeaderBoardsLengthArgs = {
  filter?: InputMaybe<TendoLeaderBoardFilter>;
};


export type QueryGetTermArgs = {
  filter?: InputMaybe<TermsFilter>;
};


export type QueryGetTermsArgs = {
  filter?: InputMaybe<TermsFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetTermsLengthArgs = {
  filter?: InputMaybe<TermsFilter>;
};


export type QueryGetTopProductsArgs = {
  input: TopProductsRequestDto;
};


export type QueryGetTopResellersForTheWeekArgs = {
  country: Scalars['String'];
};


export type QueryGetTopResellersForTheWeekByOrderCountArgs = {
  country: Scalars['String'];
};


export type QueryGetTransactionArgs = {
  input: GetTransactionsInput;
};


export type QueryGetTransactionsArgs = {
  input: GetTransactionsInput;
};


export type QueryGetTransactionsCountArgs = {
  input: GetTransactionsInput;
};


export type QueryGetUnverifiedProductsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
};


export type QueryGetUserAccountSecurityArgs = {
  filter?: InputMaybe<AccountSecurityFilter>;
};


export type QueryGetUserCouponsArgs = {
  filter?: InputMaybe<CouponRedemptionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserCouponsLengthArgs = {
  filter?: InputMaybe<CouponRedemptionFilter>;
};


export type QueryGetUserDelayedOrdersArgs = {
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetUserNotificationArgs = {
  filter?: InputMaybe<NotificationFilter>;
};


export type QueryGetUserNotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserNotificationsLengthArgs = {
  filter?: InputMaybe<NotificationFilter>;
};


export type QueryGetUserPaymentDetailsArgs = {
  filter?: InputMaybe<UserPaymentFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserPluginsArgs = {
  filter?: InputMaybe<UserPluginFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserReferralsMetricsArgs = {
  username: Scalars['String'];
};


export type QueryGetUserWalletArgs = {
  input: GetWalletInput;
};


export type QueryGetUserWalletsArgs = {
  user_id: Scalars['ID'];
};


export type QueryGetUsersArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUsersLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
};


export type QueryGetVariationArgs = {
  filter?: InputMaybe<VariationFilter>;
};


export type QueryGetVariationsArgs = {
  filter?: InputMaybe<VariationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetVariationsLengthArgs = {
  filter?: InputMaybe<VariationFilter>;
};


export type QueryGetWalletBalanceArgs = {
  input?: InputMaybe<GetWalletBalanceInput>;
};


export type QueryGetWalletPayoutArgs = {
  input: GetWalletPayoutsInput;
};


export type QueryGetWalletPayoutsArgs = {
  input: GetWalletPayoutsInput;
};


export type QueryGetWalletPayoutsCountArgs = {
  input?: InputMaybe<GetWalletPayoutsInput>;
};


export type QueryGetWalletTransactionsArgs = {
  input: GetWalletTransactionsInput;
};


export type QueryGetWalletTransactionsCountArgs = {
  input: GetWalletTransactionsInput;
};


export type QueryIsProductInShopArgs = {
  product_id: Scalars['ID'];
  shop_id: Scalars['ID'];
};


export type QueryIsProductLikedByUserArgs = {
  input: IsProductLikedByUserInput;
};


export type QueryIsProductSavedByUserArgs = {
  input: IsProductSavedByUserInput;
};


export type QueryIsProductSharedByUserArgs = {
  input: IsProductSharedByUserInput;
};


export type QueryIsSkuAvailableArgs = {
  sku: Scalars['String'];
};


export type QueryListFailedOrderChargesArgs = {
  filter?: InputMaybe<FailedOrderChargeFilter>;
};


export type QueryListSalesTargetExemptionsArgs = {
  campaignId: Scalars['ID'];
};


export type QueryLoadShopifyProductsArgs = {
  integrationId: Scalars['ID'];
};


export type QueryNewArrivalsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryOnBoardingCouponExistsAndNotConsumedArgs = {
  userCreatedAt?: InputMaybe<Scalars['Date']>;
};


export type QueryOrderStatsArgs = {
  country: Scalars['String'];
};


export type QueryTopDealsArgs = {
  filter?: InputMaybe<FeaturedCategoriesFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryTopDealsBannersArgs = {
  filter?: InputMaybe<FeaturedCategoriesFilter>;
};


export type QueryTopDealsLengthArgs = {
  filter?: InputMaybe<ProductFilter>;
};


export type QueryTrendingProductsArgs = {
  filter?: InputMaybe<TrendingProductsFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserStatsArgs = {
  country: Scalars['String'];
};


export type QueryUsersArgs = {
  input?: InputMaybe<FetchUserInput>;
};


export type QueryVerifyAccountDetailsArgs = {
  input: PaystackValidateAccountInput;
};


export type QueryVerifyAuthArgs = {
  input?: InputMaybe<VerifyEmailInput>;
};

export enum ReasonForPayment {
  /** payment record created when a customer makes payment for an order on either the storefront or the self-checkout(future) */
  OrderPurchase = 'order_purchase',
  /** payment record created when reseller makes payment to be credited to their wallet */
  WalletTopup = 'wallet_topup'
}

export enum ReductionType {
  Amount = 'amount',
  Percentage = 'percentage'
}

export type RehookLeaderboard = {
  __typename?: 'RehookLeaderboard';
  leaderboard?: Maybe<Array<Maybe<Leaderboard>>>;
  leaderboard_reward_given?: Maybe<Scalars['Boolean']>;
  my_rank?: Maybe<Leaderboard>;
  number_of_participants?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  past_leaderboard_intervals?: Maybe<Array<Maybe<PastLeaderboardIntervals>>>;
  reward_brackets?: Maybe<Array<Maybe<RewardBrackets>>>;
};

export type RemoveItemFromStorefrontCartInput = {
  cart_id: Scalars['ID'];
  item: StorefrontCartItemInput;
};

export type RequestOtpResponse = {
  __typename?: 'RequestOTPResponse';
  token?: Maybe<Scalars['String']>;
};

export type RequestRiderOtpInput = {
  channel?: InputMaybe<ChannelType>;
  phone?: InputMaybe<Scalars['String']>;
};

export type RequestSupplierOtpResponse = {
  __typename?: 'RequestSupplierOTPResponse';
  token?: Maybe<Scalars['String']>;
};

export type RequestSupplierPhoneVerificationResponse = {
  __typename?: 'RequestSupplierPhoneVerificationResponse';
  code: Scalars['String'];
  token: Scalars['String'];
};

export type Result = {
  __typename?: 'Result';
  ae_item_base_info_dto?: Maybe<AeItemBaseInfoDto>;
  ae_item_properties?: Maybe<AeItemProperty>;
  ae_item_sku_info_dtos?: Maybe<AeItemSkuInfoDtos>;
  ae_multimedia_info_dto?: Maybe<AeMultimediaInfoDto>;
  ae_store_info?: Maybe<AeStoreInfo>;
  has_whole_sale?: Maybe<Scalars['String']>;
  logistics_info_dto?: Maybe<LogisticsInfoDto>;
  package_info_dto?: Maybe<PackageInfoDto>;
  product_id_converter_result?: Maybe<ProductIdConverterResult>;
};

export type ReverseTransactionInput = {
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  ops_personnel?: InputMaybe<Scalars['String']>;
  reference: Scalars['String'];
  secret: Scalars['String'];
};

export type Review = {
  __typename?: 'Review';
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  rating: Scalars['Float'];
  user_id: Scalars['ID'];
};

export type ReviewBreakDown = {
  __typename?: 'ReviewBreakDown';
  breakDown: BreakDownItems;
  totalReviews: Scalars['Int'];
};

export type ReviewFilter = {
  id?: InputMaybe<IdOperator>;
  product_id?: InputMaybe<IdOperator>;
};

export type ReviewInput = {
  comment?: InputMaybe<Scalars['String']>;
  product_id: Scalars['ID'];
  rating: Scalars['Int'];
  user_id: Scalars['ID'];
};

export type RewardBrackets = {
  __typename?: 'RewardBrackets';
  is_minimum_value?: Maybe<Scalars['Boolean']>;
  position?: Maybe<Scalars['String']>;
  range?: Maybe<Array<Maybe<Scalars['Int']>>>;
  reward_value?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type Rider = {
  __typename?: 'Rider';
  country: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  profilePicture?: Maybe<Scalars['String']>;
};

export type RiderAuth = {
  __typename?: 'RiderAuth';
  rider: Rider;
  token: Scalars['String'];
};

export type RiderFilter = {
  country?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  firstName?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  lastName?: InputMaybe<StringOperator>;
  phoneNumber?: InputMaybe<StringOperator>;
};

export type RiderInput = {
  country: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  profilePicture?: InputMaybe<Scalars['String']>;
};

export type RiderIssueReport = {
  __typename?: 'RiderIssueReport';
  assignment_id?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  issue_type: Scalars['String'];
  order?: Maybe<Order>;
  order_id: Scalars['ID'];
  rider?: Maybe<Rider>;
  rider_id: Scalars['ID'];
  status: RiderIssueStatus;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type RiderIssueReportFilter = {
  issue_type?: InputMaybe<StringOperator>;
  order_id?: InputMaybe<IdOperator>;
  rider_id?: InputMaybe<IdOperator>;
  status?: InputMaybe<StringOperator>;
};

export type RiderIssueReportInput = {
  description: Scalars['String'];
  issue_type: Scalars['String'];
  order_id: Scalars['ID'];
};

export enum RiderIssueStatus {
  Dismissed = 'DISMISSED',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type Root = {
  __typename?: 'Root';
  name: Scalars['String'];
};

export enum Service_Agreement_Terms {
  Commission = 'COMMISSION',
  Custom = 'CUSTOM',
  FixedFee = 'FIXED_FEE',
  Markup = 'MARKUP'
}

export enum Service_Agreement_Terms_Unit {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Sales = {
  __typename?: 'Sales';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order_date?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['ID']>;
  order_value: Scalars['Int'];
  payment_reference?: Maybe<Scalars['ID']>;
  product_cost: Scalars['Int'];
  product_price?: Maybe<Scalars['Float']>;
  profit_added: Scalars['Int'];
  reseller_id?: Maybe<Scalars['ID']>;
  sku?: Maybe<Scalars['String']>;
  supplier_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type SalesFilter = {
  country?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<StringOperator>;
  currency?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  order_date?: InputMaybe<StringOperator>;
  order_id?: InputMaybe<IdOperator>;
  order_value?: InputMaybe<NumberOperator>;
  payment_reference?: InputMaybe<IdOperator>;
  product_cost?: InputMaybe<NumberOperator>;
  product_price?: InputMaybe<NumberOperator>;
  profit_added?: InputMaybe<NumberOperator>;
  reseller_id?: InputMaybe<IdOperator>;
  sku?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  updated_at?: InputMaybe<StringOperator>;
};

export enum SalesTargetCadence {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

export type SalesTargetCampaign = {
  __typename?: 'SalesTargetCampaign';
  cadence: SalesTargetCadence;
  country: CountryCode;
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  exemptions?: Maybe<Array<SalesTargetExemption>>;
  id: Scalars['ID'];
  metric: SalesTargetMetric;
  name: Scalars['String'];
  periodEnd: Scalars['String'];
  periodStart: Scalars['String'];
  progress?: Maybe<SalesTargetProgress>;
  rewardDetails?: Maybe<Scalars['JSONObject']>;
  rewardDistribution: SalesTargetRewardDistribution;
  rewardDistributionConfig?: Maybe<Scalars['JSONObject']>;
  rewardType: SalesTargetRewardType;
  status: SalesTargetStatus;
  targetAmount: Scalars['Float'];
  updatedAt: Scalars['String'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type SalesTargetCampaignFilter = {
  activePeriodOnly?: InputMaybe<Scalars['Boolean']>;
  cadence?: InputMaybe<SalesTargetCadence>;
  country?: InputMaybe<CountryCodeOperator>;
  id?: InputMaybe<IdOperator>;
  status?: InputMaybe<SalesTargetStatus>;
};

export type SalesTargetContributorRow = {
  __typename?: 'SalesTargetContributorRow';
  contribution: Scalars['Float'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export type SalesTargetExemption = {
  __typename?: 'SalesTargetExemption';
  campaignId: Scalars['ID'];
  createdAt: Scalars['String'];
  exemptedAt: Scalars['String'];
  exemptedBy: Scalars['String'];
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  reason: SalesTargetExemptionReason;
  updatedAt: Scalars['String'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export enum SalesTargetExemptionReason {
  FraudFlag = 'fraud_flag',
  ManualOther = 'manual_other',
  StaffAccount = 'staff_account',
  TestUser = 'test_user'
}

export enum SalesTargetMetric {
  OrderCount = 'order_count',
  SalesAmount = 'sales_amount'
}

export type SalesTargetProgress = {
  __typename?: 'SalesTargetProgress';
  currentValue: Scalars['Float'];
  progressPercentage: Scalars['Float'];
  targetAmount: Scalars['Float'];
};

export enum SalesTargetRewardDistribution {
  AllQualifiers = 'all_qualifiers',
  SingleWinner = 'single_winner',
  TopN = 'top_n'
}

export enum SalesTargetRewardType {
  External = 'external',
  Internal = 'internal'
}

export enum SalesTargetStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Fulfilled = 'fulfilled'
}

export type SelectOption = {
  __typename?: 'SelectOption';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SelectOptionInput = {
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SetSupplierPickupLocationInput = {
  location_id: Scalars['String'];
  supplier_id: Scalars['String'];
};

export type SetSupplierProductMarkupInput = {
  markup_amount: Scalars['Float'];
  markup_value: Scalars['Float'];
  personnel?: InputMaybe<Scalars['String']>;
  product_id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
  supplier_agreement: SupplierAgreement;
  supplier_id: Scalars['ID'];
};

export enum Settlement {
  Commission = 'Commission',
  Markup = 'Markup'
}

export type SharedProduct = {
  __typename?: 'SharedProduct';
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  long_url: Scalars['String'];
  number_of_times_sold: Scalars['Int'];
  product?: Maybe<Product>;
  product_cost_price: Scalars['Float'];
  product_id: Scalars['ID'];
  profit_added_by_reseller: Scalars['Float'];
  reseller?: Maybe<User>;
  self_checkout_link?: Maybe<Scalars['String']>;
  shared_by: Scalars['ID'];
  short_url: Scalars['String'];
  total_accumulated_profit: Scalars['Float'];
  total_accumulated_sales: Scalars['Float'];
  total_selling_price: Scalars['Float'];
  updated_at?: Maybe<Scalars['Date']>;
};

export type SharedProductFilter = {
  id?: InputMaybe<IdOperator>;
  long_url?: InputMaybe<StringOperator>;
  number_of_times_sold?: InputMaybe<NumberOperator>;
  product_cost_price?: InputMaybe<NumberOperator>;
  product_id?: InputMaybe<IdOperator>;
  profit_added_by_reseller?: InputMaybe<NumberOperator>;
  shared_by?: InputMaybe<IdOperator>;
  short_url?: InputMaybe<StringOperator>;
  total_accumulated_profit?: InputMaybe<NumberOperator>;
  total_accumulated_sales?: InputMaybe<NumberOperator>;
  total_selling_price?: InputMaybe<NumberOperator>;
};

export type ShipmentItem = {
  __typename?: 'ShipmentItem';
  id: Scalars['ID'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};

export type ShipmentItemItem = {
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};

export type Shop = {
  __typename?: 'Shop';
  avatar?: Maybe<Scalars['String']>;
  /** The public-facing contact email address for the shop. Customers will use this email to communicate with the shop owner. */
  contactEmail?: Maybe<Scalars['String']>;
  country?: Maybe<CountryCode>;
  coverImage?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  /** The three letter code for the shop's currency. */
  currency?: Maybe<CurrencyCode>;
  /** Domain(s) the user has linked to their soko.world domain */
  customDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
  deliveryAgent?: Maybe<DeliveryAgent>;
  deliveryOption?: Maybe<DeliveryOption>;
  /** The shop's meta description used in search engine results. */
  description?: Maybe<Scalars['String']>;
  /** The shop owner's email address. Tendo will use this email address to communicate with the shop owner. */
  email?: Maybe<Scalars['String']>;
  /** Indicates whether shop has undergone onboarding and setup */
  hasBeenSetup?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** Indicates whether shop is still receiving traffic. Use case: freeing up .tendo.com domain for other users. */
  isActive?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Array<Maybe<ShopLocationModel>>>;
  /** Full name of the shop */
  name?: Maybe<Scalars['String']>;
  ownerId: Scalars['ID'];
  paymentOptions?: Maybe<Array<PaymentOption>>;
  phone?: Maybe<Scalars['String']>;
  /** The primary domain of the shop's online store. */
  primaryDomain?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['ID']>;
  /** Tags associated with shop to aid shop SEO */
  shopTags?: Maybe<Array<Scalars['String']>>;
  shopType?: Maybe<ShopType>;
  shortUrl?: Maybe<Scalars['String']>;
  /** auto-generated slug. Not to be sent as input payload */
  slug?: Maybe<Scalars['String']>;
  /** The shop's .tendo.com domain name */
  sokoWorldDomain?: Maybe<Scalars['String']>;
  supplierId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['String']>;
  /** Alias for primary domain */
  url?: Maybe<Scalars['String']>;
};

export type ShopCollection = {
  __typename?: 'ShopCollection';
  banner: Scalars['String'];
  id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type ShopCollectionFilter = {
  id?: InputMaybe<IdOperator>;
  shop_id?: InputMaybe<IdOperator>;
};

export type ShopCollectionInput = {
  banner: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  shop_id: Scalars['ID'];
};

export type ShopCollectionProductFilter = {
  collection_id?: InputMaybe<IdOperator>;
};

export type ShopCollectionProductsFilter = {
  collection_id?: InputMaybe<IdOperator>;
};

export type ShopFilter = {
  avatar?: InputMaybe<StringOperator>;
  contactEmail?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  coverImage?: InputMaybe<StringOperator>;
  createdAt?: InputMaybe<DateOperator>;
  currency?: InputMaybe<StringOperator>;
  deliveryAgent?: InputMaybe<StringOperator>;
  deliveryOption?: InputMaybe<StringOperator>;
  description?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  hasBeenSetup?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<IdOperator>;
  isActive?: InputMaybe<BooleanOperator>;
  name?: InputMaybe<StringOperator>;
  ownerId?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  primaryDomain?: InputMaybe<StringOperator>;
  shopType?: InputMaybe<StringOperator>;
  shortUrl?: InputMaybe<StringOperator>;
  slug?: InputMaybe<StringOperator>;
  sokoWorldDomain?: InputMaybe<StringOperator>;
  updatedAt?: InputMaybe<DateOperator>;
  url?: InputMaybe<StringOperator>;
};

export type ShopLocationModel = {
  __typename?: 'ShopLocationModel';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  lat: Scalars['Float'];
  long: Scalars['Float'];
  shop: Shop;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ShopLocationRequestDto = {
  lat: Scalars['Float'];
  long: Scalars['Float'];
};

export type ShopPaymentMethod = {
  __typename?: 'ShopPaymentMethod';
  created_at?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  secure_code?: Maybe<Scalars['String']>;
  shopify_id?: Maybe<Scalars['ID']>;
  supplier_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type ShopProductFilter = {
  shop_id?: InputMaybe<IdOperator>;
};

export type ShopProductsFilter = {
  catalog?: InputMaybe<CatalogFilter>;
  category?: InputMaybe<ProductCategoryFilter>;
  id?: InputMaybe<IdOperator>;
  price?: InputMaybe<NumberOperator>;
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<StringOperator>;
  qty?: InputMaybe<NumberOperator>;
  random?: InputMaybe<Scalars['Boolean']>;
  shopCollection?: InputMaybe<ShopCollectionProductFilter>;
  sku?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tags?: InputMaybe<StringOperator>;
  title?: InputMaybe<StringOperator>;
  uuid?: InputMaybe<StringOperator>;
};

export enum ShopType {
  Reseller = 'reseller',
  Supplier = 'supplier'
}

export type ShopifyCustomer = {
  address?: InputMaybe<AddressInput>;
  email: Scalars['String'];
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type ShopifyImage = {
  __typename?: 'ShopifyImage';
  created_at?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  position?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['ID']>;
  src?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  variant_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  width?: Maybe<Scalars['Int']>;
};

export type ShopifyLoadedProduct = {
  __typename?: 'ShopifyLoadedProduct';
  body_html?: Maybe<Scalars['String']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Maybe<ShopifyImage>>>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ShopifyOrderProductInput = {
  cost_price?: InputMaybe<Scalars['Float']>;
  price: Scalars['Float'];
  product_id: Scalars['ID'];
  qty: Scalars['Int'];
};

export type ShopifyResellingProducts = {
  __typename?: 'ShopifyResellingProducts';
  product?: Maybe<Scalars['ID']>;
  reseller_shop?: Maybe<Scalars['ID']>;
  supplier_shop?: Maybe<Scalars['ID']>;
};

export type ShopifyShop = {
  __typename?: 'ShopifyShop';
  country_code?: Maybe<Scalars['String']>;
  country_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  products?: Maybe<Array<Maybe<SyncShopifyProduct>>>;
  redirect_url?: Maybe<Scalars['String']>;
  shop: Scalars['String'];
  shop_currency?: Maybe<Scalars['String']>;
  shop_payment_method?: Maybe<ShopPaymentMethod>;
  shop_reselling_products?: Maybe<Array<Maybe<ShopifyResellingProducts>>>;
  supplier_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type ShopifyShopFilter = {
  id?: InputMaybe<IdOperator>;
  shop?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
};

export type ShopifySupplierOrderCreateInput = {
  customer: ShopifyCustomer;
  customer_paid: Scalars['Boolean'];
  payment_id?: InputMaybe<Scalars['String']>;
  products: Array<ShopifyOrderProductInput>;
  reseller: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
  supplier_id: Scalars['ID'];
  total_amount: Scalars['Float'];
};

export enum SocialPlatform {
  Apple = 'Apple',
  Facebook = 'Facebook',
  Google = 'Google',
  Twitter = 'Twitter'
}

export type SokoWorldDomainExistsRequestDto = {
  /** format should be [domain].com, eg.www.mysoko.shop. Omit http:// or https:// */
  sokoWorldDomain?: InputMaybe<Scalars['String']>;
};

export type SokoWorldDomainExistsResponseDto = {
  __typename?: 'SokoWorldDomainExistsResponseDto';
  domainExists?: Maybe<Scalars['Boolean']>;
};

export enum SortOrder {
  Ascending = 'ascending',
  Descending = 'descending'
}

export enum Status {
  Failed = 'failed',
  Pending = 'pending',
  Success = 'success'
}

export type StatusOperator = {
  eq?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  notIn?: InputMaybe<Array<Status>>;
};

export type StockAvailability = {
  __typename?: 'StockAvailability';
  isAvailable: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
};

export type StockAvailabilityInput = {
  qty: Scalars['Int'];
  sku: Scalars['String'];
};

export type StorefrontCart = {
  __typename?: 'StorefrontCart';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<StorefrontCartCustomer>;
  customer_id?: Maybe<Scalars['ID']>;
  delivery?: Maybe<StorefrontCartDelivery>;
  id: Scalars['ID'];
  identity?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<StorefrontCartItem>>>;
  payment?: Maybe<StorefrontCartPayment>;
  shop_id: Scalars['ID'];
  status?: Maybe<StorefrontCartStatusType>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type StorefrontCartCustomer = {
  __typename?: 'StorefrontCartCustomer';
  address_id?: Maybe<Scalars['ID']>;
  customer_id?: Maybe<Scalars['ID']>;
};

export type StorefrontCartCustomerInput = {
  address_id?: InputMaybe<Scalars['ID']>;
  customer_id?: InputMaybe<Scalars['ID']>;
};

export type StorefrontCartDelivery = {
  __typename?: 'StorefrontCartDelivery';
  delivery_amount?: Maybe<Scalars['Float']>;
  delivery_id?: Maybe<Scalars['ID']>;
  delivery_type?: Maybe<Scalars['String']>;
  instantDelivery?: Maybe<Scalars['Boolean']>;
};

export type StorefrontCartDeliveryInput = {
  delivery_amount?: InputMaybe<Scalars['Float']>;
  delivery_id?: InputMaybe<Scalars['ID']>;
  delivery_type?: InputMaybe<Scalars['String']>;
  instantDelivery?: InputMaybe<Scalars['Boolean']>;
};

export type StorefrontCartFilter = {
  customer_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  identity?: InputMaybe<StringOperator>;
  shop_id?: InputMaybe<IdOperator>;
  status?: InputMaybe<StringOperator>;
};

export type StorefrontCartItem = {
  __typename?: 'StorefrontCartItem';
  avatar?: Maybe<Scalars['String']>;
  cart_id: Scalars['ID'];
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  price: Scalars['Float'];
  product_id: Scalars['ID'];
  product_price: Scalars['Float'];
  quantity: Scalars['Int'];
  reseller_profit?: Maybe<Scalars['Float']>;
  sku: Scalars['String'];
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['Date']>;
};

export type StorefrontCartItemInput = {
  avatar?: InputMaybe<Scalars['String']>;
  cart_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  price: Scalars['Float'];
  product_id: Scalars['ID'];
  product_price: Scalars['Float'];
  quantity: Scalars['Int'];
  reseller_profit?: InputMaybe<Scalars['Float']>;
  sku: Scalars['String'];
  title: Scalars['String'];
};

export type StorefrontCartPayment = {
  __typename?: 'StorefrontCartPayment';
  amount?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  invoice?: Maybe<Scalars['String']>;
  payment_id: Scalars['String'];
  payment_status?: Maybe<Scalars['String']>;
  payment_type?: Maybe<Scalars['String']>;
};

export type StorefrontCartPaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  discount?: InputMaybe<Scalars['Float']>;
  invoice?: InputMaybe<Scalars['String']>;
  payment_id: Scalars['String'];
  payment_status?: InputMaybe<Scalars['String']>;
  payment_type?: InputMaybe<Scalars['String']>;
};

export enum StorefrontCartStatusType {
  Abandoned = 'ABANDONED',
  Active = 'ACTIVE',
  Completed = 'COMPLETED'
}

export type StorefrontCartsReturnType = {
  __typename?: 'StorefrontCartsReturnType';
  carts?: Maybe<Array<Maybe<StorefrontCart>>>;
  count?: Maybe<Scalars['Int']>;
};

export type StorefrontTransactionFilter = {
  created_at?: InputMaybe<DateOperator>;
  currency?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  reference?: InputMaybe<StringOperator>;
  type?: InputMaybe<TransactionTypeOperator>;
};

export type StringOperator = {
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  like?: InputMaybe<Scalars['String']>;
  notContains?: InputMaybe<Scalars['String']>;
  notEq?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  regex?: InputMaybe<Scalars['String']>;
};

export type StripeAccountSessionInput = {
  business_data?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  supplier_id?: InputMaybe<Scalars['ID']>;
};

export type SubProductId = {
  __typename?: 'SubProductId';
  US?: Maybe<Scalars['Int']>;
};

export type SubmitChargeOtpInput = {
  otp: Scalars['String'];
  reference: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  annual_plan_cost: Scalars['Float'];
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  monthly_plan_cost: Scalars['Float'];
  name: SubscriptionType;
  updated_at?: Maybe<Scalars['Date']>;
};

export type SubscriptionInput = {
  annual_plan_cost: Scalars['Float'];
  created_at?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  monthly_plan_cost: Scalars['Float'];
  name: SubscriptionType;
  updated_at?: InputMaybe<Scalars['Date']>;
};

export enum SubscriptionStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Initialised = 'initialised'
}

export enum SubscriptionType {
  Basic = 'basic',
  Enterprise = 'enterprise',
  Pro = 'pro'
}

export type Supplier = {
  __typename?: 'Supplier';
  agreement_terms?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  business_details?: Maybe<SupplierBusiness>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  device_token?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  generic_name?: Maybe<Scalars['String']>;
  has_accepted_terms: Scalars['Boolean'];
  has_verified_email: Scalars['Boolean'];
  has_verified_phonenumber: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  payment_details?: Maybe<SupplierPaymentDetails>;
  permissions: Array<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  setupConfig?: Maybe<SupplierSetupConfig>;
  setup_complete: Scalars['Boolean'];
  shop?: Maybe<Shop>;
  social_platform?: Maybe<Scalars['String']>;
  social_platform_token?: Maybe<Scalars['String']>;
  supplier_type: SupplierType;
};

export type SupplierAccountHistory = {
  __typename?: 'SupplierAccountHistory';
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  supplier_id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SupplierAddDeviceTokenInput = {
  deviceToken: Scalars['String'];
  id: Scalars['ID'];
};

export enum SupplierAgreement {
  Commission = 'COMMISSION',
  Markup = 'MARKUP'
}

export enum SupplierAgreementTerms {
  Commission = 'COMMISSION',
  Markup = 'MARKUP'
}

export type SupplierAuthPayload = {
  __typename?: 'SupplierAuthPayload';
  supplier?: Maybe<Supplier>;
  token?: Maybe<Scalars['String']>;
};

export type SupplierBusiness = {
  __typename?: 'SupplierBusiness';
  business_address?: Maybe<Scalars['String']>;
  business_name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  delivery_option?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<SupplierBusinessDocument>>>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  industry?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  registered?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  supplier_business_verified?: Maybe<Scalars['Boolean']>;
  supplier_id?: Maybe<Scalars['ID']>;
};

export type SupplierBusinessDocument = {
  __typename?: 'SupplierBusinessDocument';
  business_id?: Maybe<Scalars['ID']>;
  document?: Maybe<Scalars['String']>;
  document_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type SupplierBusinessInput = {
  business_address?: InputMaybe<Scalars['String']>;
  business_name: Scalars['String'];
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  delivery_option?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  industry: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  postal_code?: InputMaybe<Scalars['String']>;
  referred_by?: InputMaybe<Scalars['String']>;
  registered: Scalars['Boolean'];
  state?: InputMaybe<Scalars['String']>;
  supplier_id: Scalars['ID'];
};

export type SupplierCheckList = {
  __typename?: 'SupplierCheckList';
  supplier_id: Scalars['ID'];
};

export type SupplierCreationResponse = {
  __typename?: 'SupplierCreationResponse';
  created: Scalars['Boolean'];
  verification_token?: Maybe<Scalars['String']>;
};

export type SupplierEmailChangeInput = {
  id: Scalars['ID'];
  newEmail: Scalars['String'];
};

export type SupplierFilter = {
  country?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  has_accepted_terms?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  supplier_type?: InputMaybe<SupplierType>;
};

export type SupplierInput = {
  country: Scalars['String'];
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  onboardingType?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  supplier_type?: InputMaybe<SupplierType>;
};

export type SupplierLocation = {
  __typename?: 'SupplierLocation';
  address: Scalars['String'];
  address_ext?: Maybe<Scalars['String']>;
  business_id: Scalars['ID'];
  city: Scalars['String'];
  created_at?: Maybe<Scalars['Date']>;
  deleted_at?: Maybe<Scalars['Date']>;
  gmap_data: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  lat: Scalars['String'];
  lng: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
  state_code: Scalars['String'];
  supplier_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type SupplierLocationFilter = {
  business_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
};

export type SupplierPasswordChangeInput = {
  id: Scalars['ID'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type SupplierPasswordResetInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type SupplierPasswordResetMailInput = {
  email: Scalars['String'];
};

export type SupplierPaymentDetails = {
  __typename?: 'SupplierPaymentDetails';
  account_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  method?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  supplier_id?: Maybe<Scalars['ID']>;
};

export type SupplierProductFilter = {
  category?: InputMaybe<ProductCategoryFilter>;
  combination_string?: InputMaybe<StringOperator>;
  contractor?: InputMaybe<IdOperator>;
  country?: InputMaybe<StringOperator>;
  distributionChannels?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  main_stock?: InputMaybe<NumberOperator>;
  partner?: InputMaybe<IdOperator>;
  price?: InputMaybe<NumberOperator>;
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<StringOperator>;
  published?: InputMaybe<BooleanOperator>;
  qty?: InputMaybe<NumberOperator>;
  resell?: InputMaybe<BooleanOperator>;
  reseller_id?: InputMaybe<IdOperator>;
  sku?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tags?: InputMaybe<StringOperator>;
  title?: InputMaybe<StringOperator>;
  transit_stock?: InputMaybe<NumberOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type SupplierProfileUpdateInput = {
  id: Scalars['ID'];
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SupplierSetupConfig = {
  __typename?: 'SupplierSetupConfig';
  hasCategories: Scalars['Boolean'];
  hasPaymentMethod: Scalars['Boolean'];
  hasProducts: Scalars['Boolean'];
  hasTerms: Scalars['Boolean'];
  supplier_id: Scalars['ID'];
};

export type SupplierStats = {
  __typename?: 'SupplierStats';
  supplier_id: Scalars['ID'];
  total_active_orders: Scalars['Int'];
  total_customers: Scalars['Int'];
  total_finished_orders: Scalars['Int'];
  total_orders: Scalars['Int'];
  total_products: Scalars['Int'];
  total_products_in_stock: Scalars['Int'];
  total_products_in_transit: Scalars['Int'];
  total_products_out_of_stock: Scalars['Int'];
  total_resellers: Scalars['Int'];
  total_unverified_products: Scalars['Int'];
  total_verified_products: Scalars['Int'];
};

export enum SupplierType {
  Advanced = 'ADVANCED',
  Basic = 'BASIC'
}

export type SupportedCurrenciesResponseDto = {
  __typename?: 'SupportedCurrenciesResponseDTO';
  country: Scalars['String'];
  currencies: Array<Maybe<SupportedCurrency>>;
};

export type SupportedCurrency = {
  __typename?: 'SupportedCurrency';
  code: Scalars['String'];
  country: Scalars['String'];
  name: Scalars['String'];
  type: CurrencyType;
};

export type SupportedCurrencyFilter = {
  country?: InputMaybe<CountryCode>;
  type?: InputMaybe<CurrencyType>;
};

export type SyncShopifyProduct = {
  __typename?: 'SyncShopifyProduct';
  body_html?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['ID']>;
  shop?: Maybe<Scalars['String']>;
  shopify_id?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Date']>;
  variants?: Maybe<Array<Maybe<SyncedProductVariants>>>;
};

export type SyncShopifyProductInput = {
  distributionChannel?: InputMaybe<Array<InputMaybe<DistributionChannel>>>;
  integration_id: Scalars['ID'];
  product_ids?: InputMaybe<Array<Scalars['ID']>>;
  supplier_country: Scalars['String'];
};

export type SyncedProductVariants = {
  __typename?: 'SyncedProductVariants';
  created_at?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  inventory_quantity?: Maybe<Scalars['Int']>;
  meta?: Maybe<Scalars['JSONObject']>;
  price?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  shopify_product_id?: Maybe<Scalars['Int']>;
  shopify_variant_id?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type Team = {
  __typename?: 'Team';
  country: Scalars['String'];
  created_at?: Maybe<Scalars['Date']>;
  credential?: Maybe<TeamCredential>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  members?: Maybe<Array<Maybe<Member>>>;
  name: Scalars['String'];
  service_agreement_terms?: Maybe<Service_Agreement_Terms>;
  service_agreement_terms_value?: Maybe<Scalars['JSONObject']>;
  service_id: Scalars['String'];
  updated_at?: Maybe<Scalars['Date']>;
};

export type TeamCredential = {
  __typename?: 'TeamCredential';
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  scope?: Maybe<Array<Maybe<Scalars['String']>>>;
  secret_key: Scalars['String'];
  team_id: Scalars['ID'];
  updated_at?: Maybe<Scalars['Date']>;
};

export type TeamServiceAgreementTermsValue = {
  __typename?: 'TeamServiceAgreementTermsValue';
  id: Scalars['ID'];
  team_id: Scalars['ID'];
  terms: Service_Agreement_Terms;
  terms_value: Scalars['JSONObject'];
};

export type TeamServiceAgreementTermsValueInput = {
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  unit: Service_Agreement_Terms_Unit;
  value: Scalars['Float'];
};

export type TempCategoryInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type Template = {
  __typename?: 'Template';
  dependsOn?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  options?: Maybe<Array<SelectOption>>;
  required?: Maybe<Scalars['Boolean']>;
  type: TemplateType;
};

export type TemplateFilter = {
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
};

export type TemplateInput = {
  dependsOn?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  options?: InputMaybe<Array<SelectOptionInput>>;
  required?: InputMaybe<Scalars['Boolean']>;
  type: TemplateType;
};

export enum TemplateType {
  Alert = 'ALERT',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Email = 'EMAIL',
  File = 'FILE',
  Number = 'NUMBER',
  Password = 'PASSWORD',
  Radio = 'RADIO',
  Richtext = 'RICHTEXT',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export type TendoLeaderBoard = {
  __typename?: 'TendoLeaderBoard';
  country: CountryCode;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rewardsConfig?: Maybe<LeaderBoardConfig>;
  status: TendoLeaderBoardStatus;
  updatedAt: Scalars['String'];
};

export type TendoLeaderBoardFilter = {
  country?: InputMaybe<CountryCode>;
  endDateAfter?: InputMaybe<DateOperator>;
  endDateBefore?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  isActive?: InputMaybe<BooleanOperator>;
  startDateAfter?: InputMaybe<DateOperator>;
  startDateBefore?: InputMaybe<DateOperator>;
};

export type TendoLeaderBoardPosition = {
  __typename?: 'TendoLeaderBoardPosition';
  leaderBoardId: Scalars['ID'];
  points: Scalars['Int'];
  position?: Maybe<Scalars['Int']>;
  user: User;
  userId: Scalars['ID'];
};

export enum TendoLeaderBoardStatus {
  Closed = 'CLOSED',
  Running = 'RUNNING',
  Upcoming = 'UPCOMING'
}

export type TermInput = {
  ShippingLocations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cancellationPolicy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  estimatedDeliveryTime?: InputMaybe<Scalars['Int']>;
  estimatedDeliveryTimeUnit?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  returnPeriod?: InputMaybe<Scalars['Int']>;
  returnPolicy?: InputMaybe<Scalars['String']>;
  settlementCurrency?: InputMaybe<Scalars['String']>;
  settlementPeriod?: InputMaybe<Scalars['Int']>;
  settlementType: Settlement;
  settlementValue: Scalars['Float'];
  shipTo?: InputMaybe<Scalars['String']>;
  shippingPolicy?: InputMaybe<Scalars['String']>;
  supplier_id: Scalars['ID'];
};

export type Terms = {
  __typename?: 'Terms';
  cancellationPolicy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  estimatedDeliveryTime?: Maybe<Scalars['Int']>;
  estimatedDeliveryTimeUnit?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  returnPeriod?: Maybe<Scalars['Int']>;
  returnPolicy?: Maybe<Scalars['String']>;
  settlementCurrency?: Maybe<Scalars['String']>;
  settlementPeriod?: Maybe<Scalars['Int']>;
  settlementType: Settlement;
  settlementValue: Scalars['Float'];
  shipTo?: Maybe<Scalars['String']>;
  shippingLocations?: Maybe<Array<Maybe<Scalars['String']>>>;
  shippingPolicy?: Maybe<Scalars['String']>;
};

export type TermsFilter = {
  description?: InputMaybe<StringOperator>;
  estimatedDeliveryTime?: InputMaybe<NumberOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  returnPeriod?: InputMaybe<NumberOperator>;
  settlementCurrency?: InputMaybe<StringOperator>;
  settlementPeriod?: InputMaybe<NumberOperator>;
  settlementType?: InputMaybe<Settlement>;
  shipTo?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
};

export type TopDealBanner = {
  __typename?: 'TopDealBanner';
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
};

export type TopProduct = {
  __typename?: 'TopProduct';
  numberOfTimesOrdered?: Maybe<Scalars['Float']>;
  orderValue?: Maybe<Scalars['Float']>;
  product?: Maybe<Product>;
  productSKU: Scalars['String'];
  totalQuantityOrdered?: Maybe<Scalars['Float']>;
};

export type TopProductsOrderFilter = {
  cart_number?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  customer_address_id?: InputMaybe<NumberOperator>;
  customer_id?: InputMaybe<NumberOperator>;
  delivery_id?: InputMaybe<NumberOperator>;
  delivery_instructions?: InputMaybe<StringOperator>;
  delivery_type?: InputMaybe<StringOperator>;
  discount?: InputMaybe<NumberOperator>;
  free_delivery?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<IdOperator>;
  order_total?: InputMaybe<NumberOperator>;
  payment_id?: InputMaybe<StringOperator>;
  payment_method?: InputMaybe<StringOperator>;
  payment_status?: InputMaybe<StringOperator>;
  source?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<NumberOperator>;
  updated_at?: InputMaybe<DateOperator>;
  user_id?: InputMaybe<NumberOperator>;
};

export type TopProductsRequestDto = {
  /** The top (x) number of products to fetch */
  limit?: InputMaybe<Scalars['Int']>;
  /** Additional filters for orders */
  orderFilter?: InputMaybe<TopProductsOrderFilter>;
  /** Additional filters for order products */
  productFilter?: InputMaybe<OrderProductFilter>;
};

export type TopProductsResponseDto = {
  __typename?: 'TopProductsResponseDto';
  products?: Maybe<Array<Maybe<TopProduct>>>;
  totalOrderValue?: Maybe<Scalars['Float']>;
};

export type TopReseller = {
  __typename?: 'TopReseller';
  highest_amount: Scalars['Float'];
  order_count: Scalars['Int'];
  reseller?: Maybe<User>;
  total_amount: Scalars['Float'];
  user_id: Scalars['ID'];
  week?: Maybe<Scalars['String']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Float'];
  created_at: Scalars['DateTime'];
  currency: Currency;
  direction: TransactionDirection;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSONObject']>;
  reference: Scalars['String'];
  status: TransactionStatus;
  type: TransactionType;
  updated_at?: Maybe<Scalars['DateTime']>;
  wallet_id: Scalars['ID'];
};

export enum TransactionDirection {
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export type TransactionDirectionOperator = {
  eq?: InputMaybe<TransactionDirection>;
  in?: InputMaybe<Array<TransactionDirection>>;
  notIn?: InputMaybe<Array<TransactionDirection>>;
};

export type TransactionFilter = {
  created_at?: InputMaybe<DateOperator>;
  currency?: InputMaybe<StringOperator>;
  direction?: InputMaybe<TransactionDirectionOperator>;
  id?: InputMaybe<IdOperator>;
  merchant_id?: InputMaybe<IdOperator>;
  reference?: InputMaybe<StringOperator>;
  type?: InputMaybe<TransactionTypeOperator>;
  wallet_id?: InputMaybe<IdOperator>;
  wallet_type?: InputMaybe<WalletTypeOperator>;
};

export enum TransactionStatus {
  Failed = 'failed',
  Pending = 'pending',
  Success = 'success'
}

export enum TransactionType {
  Charge = 'charge',
  Conversion = 'conversion',
  Deposit = 'deposit',
  OrderPurchase = 'order_purchase',
  ProfitPayout = 'profit_payout',
  Refund = 'refund',
  SupplierPayment = 'supplier_payment',
  Transfer = 'transfer',
  Withdrawal = 'withdrawal'
}

export type TransactionTypeOperator = {
  eq?: InputMaybe<TransactionType>;
  in?: InputMaybe<Array<TransactionType>>;
  notIn?: InputMaybe<Array<TransactionType>>;
};

export type TrendingProductsFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
};

export type UnshareProductRequestDto = {
  product_id: Scalars['ID'];
  shared_by: Scalars['ID'];
};

export type UpdateCampaignInput = {
  campaignImageUrl?: InputMaybe<Scalars['String']>;
  conditions: Array<CampaginConditionInput>;
  couponCode: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['Date'];
  id: Scalars['ID'];
  startDate: Scalars['Date'];
  title: Scalars['String'];
};

export type UpdateCartItemInput = {
  cart_item_id: Scalars['ID'];
  profit?: InputMaybe<Scalars['Float']>;
  profit_type?: InputMaybe<ProfitType>;
  quantity?: InputMaybe<Scalars['Int']>;
  user_id: Scalars['ID'];
};

export type UpdateDiscountData = {
  amount?: InputMaybe<Scalars['Float']>;
  code?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<UserType>;
  description?: InputMaybe<Scalars['String']>;
  expiry_date?: InputMaybe<Scalars['String']>;
  fixed_amount_allocation?: InputMaybe<FixedAmountAllocation>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  percentage?: InputMaybe<Scalars['Float']>;
  redemptions_limit?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DiscountType>;
  user_id?: InputMaybe<Scalars['ID']>;
  valid_country?: InputMaybe<Scalars['String']>;
};

export type UpdateDiscountProductConditionRequestDto = {
  condition?: InputMaybe<ProductCondition>;
  id: Scalars['ID'];
  product_sku?: InputMaybe<Scalars['String']>;
};

export type UpdatePluginRequestDto = {
  banner_image?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  developer?: InputMaybe<Scalars['String']>;
  endpoint?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProductCategoriesInput = {
  categories?: InputMaybe<Array<Scalars['ID']>>;
  personnel?: InputMaybe<Scalars['String']>;
  product_id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type UpdateProductDistributionInput = {
  cost_price?: InputMaybe<Scalars['Float']>;
  distributionChannels: Array<Scalars['String']>;
  personnel?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product_id: Scalars['ID'];
  published?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProductStatus>;
  supplier_cost?: InputMaybe<Scalars['Float']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProductStatusInput = {
  personnel?: InputMaybe<Scalars['String']>;
  product_id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProductStatus>;
};

export type UpdateResellerSlugInput = {
  isBrand?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  user_id: Scalars['ID'];
};

export type UpdateSalesTargetCampaignInput = {
  description?: InputMaybe<Scalars['String']>;
  periodEnd?: InputMaybe<Scalars['String']>;
  rewardDetails?: InputMaybe<Scalars['JSONObject']>;
  rewardDistributionConfig?: InputMaybe<Scalars['JSONObject']>;
  targetAmount?: InputMaybe<Scalars['Float']>;
};

export type UpdateShopDetailsRequestDto = {
  avatar?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCode>;
  coverImage?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<CurrencyCode>;
  customDomains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryAgent?: InputMaybe<DeliveryAgent>;
  deliveryOption?: InputMaybe<DeliveryOption>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<ShopLocationRequestDto>;
  name?: InputMaybe<Scalars['String']>;
  paymentOptions?: InputMaybe<Array<InputMaybe<PaymentOption>>>;
  phone?: InputMaybe<Scalars['String']>;
  primaryDomain?: InputMaybe<Scalars['String']>;
  shopId: Scalars['ID'];
  shopTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shopType: ShopType;
  sokoWorldDomain?: InputMaybe<Scalars['String']>;
};

export type UpdateShopDetailsResponseDto = {
  __typename?: 'UpdateShopDetailsResponseDto';
  shopId?: Maybe<Scalars['ID']>;
};

export type UpdateStorefrontCartStatusInput = {
  cart_id: Scalars['ID'];
  status: StorefrontCartStatusType;
};

export type UpdateSupplierBusinessContactInput = {
  input: UpdateSupplierBusinessContactInputOption;
  supplier_id: Scalars['ID'];
};

export type UpdateSupplierBusinessContactInputOption = {
  business_address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateSupplierBusinessDetailsInput = {
  input: UpdateSupplierBusinessDetailsInputOptions;
  supplier_id: Scalars['ID'];
};

export type UpdateSupplierBusinessDetailsInputOptions = {
  description?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSupplierDetailsData = {
  avatar?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSupplierDetailsInput = {
  data?: InputMaybe<UpdateSupplierDetailsData>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UpdateSupplierPaymentInput = {
  input: UpdateSupplierPaymentInputOptions;
  supplier_id: Scalars['ID'];
};

export type UpdateSupplierPaymentInputOptions = {
  account_name: Scalars['String'];
  account_number: Scalars['String'];
  method: Scalars['String'];
  provider: Scalars['String'];
  stripe_account_id?: InputMaybe<Scalars['String']>;
};

export type UpdateSupplierSlugInput = {
  slug: Scalars['String'];
  supplier_id: Scalars['ID'];
};

export type UpdateUserAccountSecurityInput = {
  id: Scalars['ID'];
  oldSecurityToken: Scalars['String'];
  securityToken: Scalars['String'];
  securityType: AccountSecurityType;
  user_id: Scalars['ID'];
};

export type UpdateVariationInput = {
  uuid: Scalars['String'];
  variations?: InputMaybe<Array<InputMaybe<ProductCombinationInput>>>;
};

export type User = {
  __typename?: 'User';
  accepted_terms?: Maybe<Scalars['Boolean']>;
  banned?: Maybe<Scalars['Boolean']>;
  banned_by?: Maybe<Scalars['String']>;
  banned_until?: Maybe<Scalars['Date']>;
  country: Scalars['String'];
  created_at?: Maybe<Scalars['Date']>;
  customers?: Maybe<Array<Maybe<UserCustomers>>>;
  deleted?: Maybe<Scalars['Boolean']>;
  details?: Maybe<UserDetails>;
  deviceToken?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  facebook_id?: Maybe<Scalars['String']>;
  first_order_created?: Maybe<Scalars['Boolean']>;
  google_id?: Maybe<Scalars['String']>;
  hasReview?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  paymentDetails?: Maybe<UserPayment>;
  phone: Scalars['String'];
  shop?: Maybe<Shop>;
  state?: Maybe<Scalars['String']>;
  supplier_shop_id?: Maybe<Scalars['ID']>;
  suspended?: Maybe<Scalars['Boolean']>;
  suspended_at?: Maybe<Scalars['Date']>;
  suspended_by?: Maybe<Scalars['String']>;
  suspended_reason?: Maybe<Scalars['String']>;
  suspended_until?: Maybe<Scalars['Date']>;
  twitter_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Date']>;
  user_type?: Maybe<UserAccountType>;
  username: Scalars['String'];
  verified: Scalars['Boolean'];
  verifiedDetails?: Maybe<VerifiedDetails>;
};

export type UserAccountSecurity = {
  __typename?: 'UserAccountSecurity';
  id: Scalars['ID'];
  securityToken: Scalars['String'];
  securityType: AccountSecurityType;
  userType: UserType;
  user_id: Scalars['ID'];
};

export enum UserAccountType {
  Customer = 'CUSTOMER',
  Developer = 'DEVELOPER',
  Manager = 'MANAGER',
  Merchant = 'MERCHANT',
  Reseller = 'RESELLER',
  Supplier = 'SUPPLIER'
}

export type UserCustomers = {
  __typename?: 'UserCustomers';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  dob?: Maybe<Scalars['Date']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  referred_by?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type UserFilter = {
  country?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  referred_by?: InputMaybe<StringOperator>;
  state?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  user_type?: InputMaybe<StringOperator>;
  username?: InputMaybe<StringOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type UserGraphData = {
  __typename?: 'UserGraphData';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  notification?: Maybe<Notification>;
  notification_id: Scalars['ID'];
  read?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
  user_id: Scalars['ID'];
};

export type UserPayment = {
  __typename?: 'UserPayment';
  account_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  method?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  type?: Maybe<UserPaymentType>;
  user_id?: Maybe<Scalars['ID']>;
};

export type UserPaymentFilter = {
  account_name?: InputMaybe<StringOperator>;
  account_number?: InputMaybe<StringOperator>;
  method?: InputMaybe<StringOperator>;
  provider?: InputMaybe<StringOperator>;
  type?: InputMaybe<UserPaymentType>;
  user_id?: InputMaybe<IdOperator>;
};

export type UserPaymentInput = {
  account_name: Scalars['String'];
  account_number: Scalars['String'];
  method: Scalars['String'];
  provider: Scalars['String'];
  type: UserPaymentType;
  user_id: Scalars['ID'];
};

export enum UserPaymentType {
  Deposit = 'Deposit',
  Withdrawal = 'Withdrawal'
}

export type UserPlugin = {
  __typename?: 'UserPlugin';
  id: Scalars['ID'];
  plugin_id: Scalars['ID'];
  plugin_name?: Maybe<Scalars['String']>;
  user_id: Scalars['ID'];
};

export type UserPluginFilter = {
  id?: InputMaybe<IdOperator>;
  plugin_id?: InputMaybe<IdOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type UserReferralMetrics = {
  __typename?: 'UserReferralMetrics';
  total_referrals: Scalars['Int'];
  total_succesful_referrals: Scalars['Int'];
};

export type UserStats = {
  __typename?: 'UserStats';
  usersAllTime: Scalars['Int'];
  usersMonth: Scalars['Int'];
  usersToday: Scalars['Int'];
  usersWeek: Scalars['Int'];
  usersYear: Scalars['Int'];
};

export enum UserType {
  Developer = 'DEVELOPER',
  InHouse = 'IN_HOUSE',
  Reseller = 'RESELLER',
  Supplier = 'SUPPLIER'
}

export type UsersCouponInput = {
  cash_rewards?: InputMaybe<Scalars['Float']>;
  code: Scalars['String'];
  duration: CouponDuration;
  duration_value: Scalars['Int'];
  free_deliveries?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  issueToAll: Scalars['Boolean'];
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  neverEnds: Scalars['Boolean'];
  resellers: Array<Scalars['String']>;
  start_date: Scalars['Date'];
  title?: InputMaybe<Scalars['String']>;
  type: CouponType;
};

export type Variation = {
  __typename?: 'Variation';
  id?: Maybe<Scalars['ID']>;
  variation_name: Scalars['String'];
  variation_options: Array<Maybe<VariationOption>>;
};

export type VariationFilter = {
  id?: InputMaybe<IdOperator>;
};

export type VariationInput = {
  id?: InputMaybe<Scalars['ID']>;
  variation_name: Scalars['String'];
  variation_options?: InputMaybe<Array<InputMaybe<VariationOptionInput>>>;
};

export type VariationOption = {
  __typename?: 'VariationOption';
  id?: Maybe<Scalars['ID']>;
  variation_value?: Maybe<Scalars['String']>;
};

export type VariationOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  variation_value?: InputMaybe<Scalars['String']>;
};

export type VerifiedDetails = {
  __typename?: 'VerifiedDetails';
  has_verified_email?: Maybe<Scalars['Boolean']>;
  has_verified_phonenumber?: Maybe<Scalars['Boolean']>;
  setup_complete?: Maybe<Scalars['Boolean']>;
};

export type VerifyAliExpressProductInput = {
  category?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  maximumDeliveryTime?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  minimumDeliveryTime?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  shippingCost?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type VerifyPaymentInput = {
  reference: Scalars['String'];
};

export type VerifyProductInput = {
  id: Scalars['ID'];
  markup_amount?: InputMaybe<Scalars['Float']>;
  markup_value?: InputMaybe<Scalars['Float']>;
  personnel: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  supplier_agreement: SupplierAgreement;
  supplier_id?: InputMaybe<Scalars['ID']>;
};

export type VerifyUserAccountSecurityInput = {
  securityToken: Scalars['String'];
  securityType: AccountSecurityType;
  user_id: Scalars['ID'];
};

export type Wallet = {
  __typename?: 'Wallet';
  country: Scalars['String'];
  created_at: Scalars['String'];
  currency: Currency;
  id: Scalars['ID'];
  lock_status: LockStatus;
  lock_status_changed_date?: Maybe<Scalars['String']>;
  merchant_id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSONObject']>;
  wallet_type: WalletType;
};

export type WalletBalanceDto = {
  __typename?: 'WalletBalanceDTO';
  dateRange?: Maybe<DateRangeDto>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  wallet?: Maybe<WalletResponseDto>;
};

export type WalletPayoutFilter = {
  country?: InputMaybe<CountryCodeOperator>;
  created_at?: InputMaybe<DateOperator>;
  currency?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  merchant_id?: InputMaybe<IdOperator>;
  status?: InputMaybe<WalletPayoutStatusOperator>;
  transaction_id?: InputMaybe<IdOperator>;
  wallet_id?: InputMaybe<IdOperator>;
  wallet_type?: InputMaybe<WalletTypeOperator>;
};

export type WalletPayoutRequestDecision = {
  metadata?: InputMaybe<Scalars['JSONObject']>;
  ops_personnel?: InputMaybe<Scalars['ID']>;
  payout_id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
  status: WalletPayoutStatus;
};

export type WalletPayoutResponseDto = {
  __typename?: 'WalletPayoutResponseDTO';
  account_name: Scalars['String'];
  account_number: Scalars['String'];
  amount: Scalars['Float'];
  country: Scalars['String'];
  created_at: Scalars['DateTime'];
  currency: Currency;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSONObject']>;
  provider: Scalars['String'];
  status: WalletPayoutStatus;
  transaction?: Maybe<Transaction>;
  wallet?: Maybe<WalletResponseDto>;
};

export enum WalletPayoutStatus {
  Approved = 'approved',
  Declined = 'declined',
  Pending = 'pending'
}

export type WalletPayoutStatusOperator = {
  eq?: InputMaybe<WalletPayoutStatus>;
  in?: InputMaybe<Array<WalletPayoutStatus>>;
  notIn?: InputMaybe<Array<WalletPayoutStatus>>;
};

export type WalletResponseDto = {
  __typename?: 'WalletResponseDTO';
  balance: Scalars['Float'];
  country: Scalars['String'];
  currency: Currency;
  id: Scalars['ID'];
  lock_status: LockStatus;
  merchant_id: Scalars['ID'];
  wallet_type: WalletType;
};

export type WalletStatementDto = {
  __typename?: 'WalletStatementDTO';
  filename: Scalars['String'];
  filepath: Scalars['String'];
  url: Scalars['String'];
};

export enum WalletType {
  House = 'house',
  HouseProfit = 'house_profit',
  Merchant = 'merchant',
  PaymentFacilitator = 'payment_facilitator',
  Supplier = 'supplier'
}

export type WalletTypeOperator = {
  eq?: InputMaybe<WalletType>;
};

export type WalletWithdrawalInput = {
  amount: Scalars['Float'];
  currency: CurrencyInput;
  description?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  provider?: InputMaybe<WithdrawalProviderInput>;
  secret: Scalars['String'];
  wallet_id: Scalars['ID'];
};

export type WholesalePriceTiers = {
  __typename?: 'WholesalePriceTiers';
  discount?: Maybe<Scalars['String']>;
  min_quantity?: Maybe<Scalars['String']>;
  wholesale_price?: Maybe<Scalars['String']>;
};

export type WithdrawalProviderInput = {
  account_name: Scalars['String'];
  account_number: Scalars['String'];
  name: Scalars['String'];
};

export type XeroTokenSet = {
  __typename?: 'XeroTokenSet';
  created_at?: Maybe<Scalars['Date']>;
  expired?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  token_set?: Maybe<Scalars['JSONObject']>;
  updated_at?: Maybe<Scalars['Date']>;
  user_id: Scalars['ID'];
  user_type: Scalars['String'];
};

export type AccountRegisterInput = {
  country: Scalars['String'];
  details?: InputMaybe<Details>;
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  referred_by?: InputMaybe<Scalars['String']>;
  social_login?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  supplier_shop_id?: InputMaybe<Scalars['ID']>;
};

export type AddBusinessDocumentInput = {
  business_id?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<DocumentInput>>;
};

export type AddCommentInput = {
  id: Scalars['ID'];
  message: Scalars['String'];
  staff_name: Scalars['String'];
  title: Scalars['String'];
};

export type AddCommentsToProductInput = {
  message: Scalars['String'];
  product_id: Scalars['ID'];
  staff_number: Scalars['String'];
};

export type AddSupplierPaymentInput = {
  account_name: Scalars['String'];
  account_number: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  method: Scalars['String'];
  provider: Scalars['String'];
  stripe_account_id?: InputMaybe<Scalars['String']>;
  supplier_id: Scalars['ID'];
};

export type AuthenticateWithTokenInput = {
  token: Scalars['String'];
};

export type BanResellerInput = {
  by?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['Date']>;
  user_id: Scalars['ID'];
};

export type ChangePasswordInput = {
  confirmPassword?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type ChangeResellerUsernameInput = {
  changed_by?: InputMaybe<ChangeBy>;
  new_username: Scalars['String'];
  old_username: Scalars['String'];
  user_id: Scalars['ID'];
};

export type CheckPasswordAvailabilityInput = {
  channel?: InputMaybe<ChannelType>;
  phone: Scalars['String'];
};

export type CreateProductInput = {
  avatar: Scalars['String'];
  catalog_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  combination_string?: InputMaybe<Scalars['String']>;
  combinations?: InputMaybe<Array<InputMaybe<ProductCombinationInput>>>;
  cost_price: Scalars['Float'];
  country: CountryCode;
  currency: CurrencyCode;
  description: Scalars['String'];
  digitalDetails?: InputMaybe<Scalars['Any']>;
  distributionChannels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  extra_information?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inhouse?: InputMaybe<Scalars['Boolean']>;
  instantDelivery?: InputMaybe<Scalars['Boolean']>;
  limited_stock?: InputMaybe<Scalars['Boolean']>;
  maximumDeliveryTime?: InputMaybe<Scalars['Int']>;
  media: Array<Scalars['String']>;
  minimumDeliveryTime?: InputMaybe<Scalars['Int']>;
  minimumOrderQuantity?: InputMaybe<Scalars['Int']>;
  personnel?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<ProductOrigin>;
  published: Scalars['Boolean'];
  qty?: InputMaybe<Scalars['Int']>;
  reason?: InputMaybe<Scalars['String']>;
  shippingCost?: InputMaybe<Scalars['Int']>;
  shop_id?: InputMaybe<Scalars['ID']>;
  sku: Scalars['String'];
  status?: InputMaybe<ProductStatus>;
  supplier_cost?: InputMaybe<Scalars['Float']>;
  supplier_id?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
  uuid: Scalars['String'];
  variations?: InputMaybe<Array<InputMaybe<VariationInput>>>;
  verified: Scalars['Boolean'];
  weight?: InputMaybe<Scalars['Float']>;
};

export type DeleteResellerInput = {
  by?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  user_id: Scalars['ID'];
};

export enum DistributionChannel {
  MarketPlace = 'MarketPlace',
  ResellerNetwork = 'ResellerNetwork',
  SupplierStorefront = 'SupplierStorefront',
  TendoNetwork = 'TendoNetwork'
}

export type DocumentInput = {
  file?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type EditProductStatInput = {
  editType: ProductStatEditType;
  product_id: Scalars['ID'];
  stat: ProductStat;
  user_id: Scalars['ID'];
};

export type ForgotPasswordInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type IsProductLikedByUserInput = {
  product_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type IsProductSavedByUserInput = {
  product_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type IsProductSharedByUserInput = {
  product_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type MakeRequestForProduct = {
  product_id: Scalars['ID'];
  qty: Scalars['Int'];
  shop_id: Scalars['ID'];
};

export type MigrationUserCreateInput = {
  country: Scalars['String'];
  details?: InputMaybe<Details>;
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  referred_by?: InputMaybe<Scalars['String']>;
  social_login?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type ProductFilter = {
  attended_to?: InputMaybe<BooleanOperator>;
  catalog?: InputMaybe<CatalogFilter>;
  category?: InputMaybe<ProductCategoryFilter>;
  combination_string?: InputMaybe<StringOperator>;
  contractor?: InputMaybe<IdOperator>;
  country?: InputMaybe<StringOperator>;
  distributionChannels?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  inhouse?: InputMaybe<BooleanOperator>;
  main_stock?: InputMaybe<NumberOperator>;
  partner?: InputMaybe<IdOperator>;
  price?: InputMaybe<NumberOperator>;
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<StringOperator>;
  published?: InputMaybe<BooleanOperator>;
  qty?: InputMaybe<NumberOperator>;
  random?: InputMaybe<Scalars['Boolean']>;
  resell?: InputMaybe<BooleanOperator>;
  reseller_id?: InputMaybe<IdOperator>;
  shop?: InputMaybe<ShopProductFilter>;
  shopCollection?: InputMaybe<ShopCollectionProductFilter>;
  sku?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tags?: InputMaybe<StringOperator>;
  title?: InputMaybe<StringOperator>;
  transit_stock?: InputMaybe<NumberOperator>;
  uuid?: InputMaybe<StringOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type ProductRequestFilter = {
  product?: InputMaybe<ProductFilter>;
  qty?: InputMaybe<NumberOperator>;
  shop_id?: InputMaybe<IdOperator>;
};

export type RequestChangeEmailInput = {
  email: Scalars['String'];
  newEmail: Scalars['String'];
};

export type RequestChangePhoneInput = {
  newPhone: Scalars['String'];
  phone: Scalars['String'];
};

export type RequestChangeSupplierPhoneInput = {
  newPhone: Scalars['String'];
  phone: Scalars['String'];
};

export type RequestEmailVerificationInput = {
  email: Scalars['String'];
};

export type RequestOtpInput = {
  channel?: InputMaybe<ChannelType>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type RequestSupplierEmailVerificationInput = {
  email: Scalars['String'];
};

export type RequestSupplierPhoneVerificationInput = {
  phone: Scalars['String'];
};

export type ResetPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type SetupAccountInput = {
  confirm_password: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
};

export type ShopfiySupplierOrderCreateInput = {
  country: Scalars['String'];
  customer: ShopifyCustomer;
  customer_paid: Scalars['Boolean'];
  payment_id?: InputMaybe<Scalars['String']>;
  products: Array<ShopifyOrderProductInput>;
  reseller: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
  supplier_id: Scalars['ID'];
  total_amount: Scalars['Float'];
};

export type SupplierUserLoginInput = {
  deviceToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  supplier_id: Scalars['ID'];
};

export type SuspendResellerInput = {
  by?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['Date']>;
  user_id: Scalars['ID'];
};

export type TempCreateProductInput = {
  avatar: Scalars['String'];
  catalog_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  categories?: InputMaybe<Array<InputMaybe<TempCategoryInput>>>;
  combination_string?: InputMaybe<Scalars['String']>;
  combinations?: InputMaybe<Array<InputMaybe<ProductCombinationInput>>>;
  cost_price: Scalars['Float'];
  country: CountryCode;
  currency: CurrencyCode;
  description: Scalars['String'];
  digitalDetails?: InputMaybe<Scalars['Any']>;
  distributionChannels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  extra_information?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inhouse?: InputMaybe<Scalars['Boolean']>;
  instantDelivery?: InputMaybe<Scalars['Boolean']>;
  limited_stock?: InputMaybe<Scalars['Boolean']>;
  maximumDeliveryTime?: InputMaybe<Scalars['Int']>;
  media: Array<Scalars['String']>;
  minimumDeliveryTime?: InputMaybe<Scalars['Int']>;
  minimumOrderQuantity?: InputMaybe<Scalars['Int']>;
  personnel?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<ProductOrigin>;
  published: Scalars['Boolean'];
  qty?: InputMaybe<Scalars['Int']>;
  reason?: InputMaybe<Scalars['String']>;
  shippingCost?: InputMaybe<Scalars['Int']>;
  shop_id?: InputMaybe<Scalars['ID']>;
  sku: Scalars['String'];
  status?: InputMaybe<ProductStatus>;
  supplier_cost?: InputMaybe<Scalars['Float']>;
  supplier_id?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
  uuid: Scalars['String'];
  variations?: InputMaybe<Array<InputMaybe<VariationInput>>>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type UpdateUserDetailsInput = {
  dob?: InputMaybe<Scalars['Date']>;
  gender?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  referred_by?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  user_id: Scalars['Int'];
};

export type UserLoginInput = {
  deviceToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type VerifyEmailInput = {
  token: Scalars['String'];
};

export type VerifyOtpInput = {
  code: Scalars['String'];
  medium: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  update?: InputMaybe<Scalars['Boolean']>;
};

export type VerifySupplierAccountInput = {
  action: Scalars['String'];
  token: Scalars['String'];
};

export type VerifySupplierBusinessInput = {
  agreed_term?: InputMaybe<SupplierAgreementTerms>;
  genericName: Scalars['String'];
  supplier_id: Scalars['ID'];
};

export type VerifySupplierEmailInput = {
  token: Scalars['String'];
};

export type VerifySupplierOtpInput = {
  code: Scalars['String'];
  medium: Scalars['String'];
  token: Scalars['String'];
  update?: InputMaybe<Scalars['Boolean']>;
};
